var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 98,
    viewBox: "0 0 580 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 267,
    y: 62,
    width: 86,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.023 76.8907C352.449 70.9658 333.946 64.7838 310.697 63.0986C287.447 61.4134 268.263 64.8459 267.837 70.7796C267.74 72.1809 267.377 77.2986 267.271 78.7C266.845 84.6248 285.348 90.8069 308.597 92.4921C331.847 94.1773 351.032 90.7448 351.457 84.8111C351.554 83.4097 351.917 78.292 352.023 76.8907Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13830_12464)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.023 76.8907C352.449 70.9658 333.946 64.7838 310.697 63.0986C287.447 61.4134 268.263 64.8459 267.837 70.7796C267.74 72.1809 267.377 77.2986 267.271 78.7C266.845 84.6248 285.348 90.8069 308.597 92.4921C331.847 94.1773 351.032 90.7448 351.457 84.8111C351.554 83.4097 351.917 78.292 352.023 76.8907Z",
    fill: "url(#paint0_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.36 87.4629L267.793 87.4185L269.219 67.4355L269.786 67.4799L268.36 87.4629Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.716 87.7734L269.149 87.729L270.575 67.7461L271.142 67.7904L269.716 87.7734Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.089 88.0751L270.522 88.0396L271.948 68.0566L272.515 68.0921L271.089 88.0751Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.479 88.3852L271.912 88.3409L273.338 68.3579L273.905 68.3934L272.479 88.3852Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.887 88.6782L273.32 88.6427L274.746 68.6509L275.313 68.6952L273.887 88.6782Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.313 88.9711L274.746 88.9356L276.172 68.9526L276.739 68.9881L275.313 88.9711Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.766 89.2636L276.199 89.2282L277.625 69.2363L278.183 69.2807L276.766 89.2636Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M278.227 89.5478L277.66 89.5123L279.086 69.5205L279.653 69.5649L278.227 89.5478Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M279.715 89.831L279.148 89.7867L280.574 69.8037L281.132 69.8481L279.715 89.831Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281.212 90.1064L280.645 90.0621L282.071 70.0791L282.638 70.1234L281.212 90.1064Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M282.735 90.372L282.168 90.3277L283.594 70.3447L284.161 70.3891L282.735 90.372Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M284.277 90.6381L283.71 90.5938L285.136 70.6108L285.694 70.6463L284.277 90.6381Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.826 90.8866L285.26 90.8511L286.686 70.8682L287.252 70.9036L285.826 90.8866Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.403 91.144L286.836 91.0997L288.262 71.1167L288.829 71.1522L287.403 91.144Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.997 91.3833L288.43 91.3389L289.856 71.356L290.423 71.4003L288.997 91.3833Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.6 91.6142L290.042 91.5699L291.46 71.5869L292.026 71.6313L290.6 91.6142Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.23 91.8447L291.663 91.8003L293.089 71.8174L293.656 71.8529L292.23 91.8447Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M293.877 92.0576L293.311 92.0221L294.737 72.0303L295.303 72.0746L293.877 92.0576Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M295.534 92.2705L294.967 92.2261L296.393 72.2432L296.96 72.2875L295.534 92.2705Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M297.217 92.4657L296.65 92.4302L298.076 72.4473L298.643 72.4827L297.217 92.4657Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.908 92.6606L298.342 92.6163L299.768 72.6333L300.334 72.6777L298.908 92.6606Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M300.626 92.8466L300.06 92.8023L301.486 72.8193L302.044 72.8548L300.626 92.8466Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.354 93.0156L301.787 92.9712L303.213 72.9883L303.78 73.0326L302.354 93.0156Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M304.099 93.1748L303.532 93.1393L304.958 73.1475L305.525 73.1918L304.099 93.1748Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305.861 93.3256L305.294 93.2901L306.72 73.3071L307.287 73.3426L305.861 93.3256Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M307.632 93.4677L307.074 93.4323L308.492 73.4404L309.058 73.4848L307.632 93.4677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M309.422 93.6005L308.855 93.5562L310.281 73.5732L310.848 73.6176L309.422 93.6005Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M311.202 93.7163L310.635 93.6719L312.061 73.689L312.628 73.7333L311.202 93.7163Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M312.964 93.8222L312.397 93.7779L313.823 73.7949L314.381 73.8304L312.964 93.8222Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.709 93.9111L314.142 93.8668L315.568 73.8838L316.135 73.9281L314.709 93.9111Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M316.436 93.9907L315.869 93.9463L317.295 73.9634L317.862 74.0077L316.436 93.9907Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M318.155 94.0532L317.588 94.0177L319.014 74.0259L319.58 74.0702L318.155 94.0532Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M319.855 94.1063L319.288 94.0708L320.714 74.0879L321.281 74.1234L319.855 94.1063Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M321.538 94.1504L320.971 94.1149L322.397 74.123L322.964 74.1674L321.538 94.1504Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M323.212 94.186L322.645 94.1416L324.071 74.1587L324.629 74.203L323.212 94.186Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M324.86 94.2036L324.293 94.1681L325.719 74.1763L326.286 74.2206L324.86 94.2036Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M326.498 94.2211L325.931 94.1768L327.357 74.1938L327.924 74.2293L326.498 94.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M328.119 94.2211L327.552 94.1768L328.978 74.1938L329.545 74.2293L328.119 94.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M329.731 94.2129L329.164 94.1685L330.59 74.1855L331.148 74.221L329.731 94.2129Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M331.316 94.1864L330.749 94.1509L332.175 74.168L332.742 74.2034L331.316 94.1864Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.884 94.1596L332.326 94.1242L333.743 74.1323L334.31 74.1767L332.884 94.1596Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M334.443 94.124L333.876 94.0796L335.302 74.0967L335.869 74.141L334.443 94.124Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M335.984 94.0796L335.417 94.0352L336.843 74.0522L337.41 74.0966L335.984 94.0796Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M337.498 94.0268L336.94 93.9825L338.358 73.9995L338.924 74.035L337.498 94.0268Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M339.004 93.9643L338.437 93.92L339.863 73.937L340.43 73.9725L339.004 93.9643Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M340.492 93.893L339.925 93.8487L341.351 73.8657L341.918 73.9012L340.492 93.893Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M341.962 93.8139L341.396 93.7696L342.822 73.7866L343.388 73.831L341.962 93.8139Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M343.415 93.7251L342.848 93.6896L344.274 73.6978L344.841 73.7421L343.415 93.7251Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M344.841 93.6362L344.283 93.5918L345.7 73.6089L346.267 73.6532L344.841 93.6362Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M346.258 93.539L345.691 93.4947L347.117 73.5117L347.684 73.5561L346.258 93.539Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M347.657 93.4321L347.09 93.3877L348.516 73.4048L349.083 73.4491L347.657 93.4321Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M349.03 93.3261L348.463 93.2818L349.889 73.2988L350.456 73.3343L349.03 93.3261Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M302.495 62.7172C295.498 62.5664 289.076 62.8857 283.718 63.613L281.973 88.0839C287.172 89.5829 293.478 90.8246 300.431 91.6849L302.495 62.7172Z",
    fill: "#EDE7DE"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M352.014 76.8756C352.445 70.9494 333.947 64.7784 310.7 63.0924C287.452 61.4063 268.258 64.8436 267.828 70.7699C267.397 76.6961 285.894 82.8671 309.142 84.5531C332.39 86.2392 351.584 82.8018 352.014 76.8756Z",
    fill: "url(#paint1_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M303.505 82.2031C307.464 80.58 311.449 79.0189 315.382 77.3337C319.288 75.6485 323.176 73.9012 327.047 72.1362C330.448 70.5841 333.84 69.0319 337.241 67.4886C332.954 66.2646 327.932 65.2003 322.414 64.3843C320.333 65.2269 318.252 66.0784 316.17 66.921C310.643 69.1649 305.117 71.3823 299.554 73.5287C294.019 75.6663 288.456 77.7151 282.912 79.8438C282.699 79.9236 282.487 80.0123 282.265 80.0921C287.287 81.5556 293.372 82.7885 300.077 83.6488C301.211 83.161 302.353 82.6732 303.496 82.2031H303.505Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 277,
    y: 65,
    width: 66,
    height: 16
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M342.732 75.3562C342.44 79.4894 327.543 81.7777 309.465 80.465C291.388 79.1524 276.969 74.7354 277.261 70.6022C277.553 66.469 292.451 64.1807 310.528 65.4933C328.605 66.806 343.025 71.223 342.732 75.3562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13830_12464)"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M342.732 75.3562C342.44 79.4894 327.543 81.7777 309.465 80.465C291.388 79.1524 276.969 74.7354 277.261 70.6022C277.553 66.469 292.451 64.1807 310.528 65.4933C328.605 66.806 343.025 71.223 342.732 75.3562Z",
    fill: "url(#paint2_linear_13830_12464)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M343.104 78.5935C342.812 82.7267 327.914 85.015 309.837 83.7024C291.76 82.3897 277.341 77.9727 277.633 73.8395C277.925 69.7063 292.823 67.418 310.9 68.7307C328.977 70.0433 343.396 74.4603 343.104 78.5935Z",
    fill: "url(#paint3_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M284.675 78.7704L319.616 65.6968L335.213 68.6681L303.513 82.5577L284.675 78.7704Z",
    fill: "#EDE7DE"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M350.465 79.5157C349.18 80.7042 347.56 81.4581 345.948 82.1144L344.725 82.5845L343.476 82.9748C342.644 83.2586 341.802 83.4537 340.952 83.6755C337.56 84.4914 334.106 85.0059 330.643 85.334C323.708 86.0081 316.737 85.9638 309.802 85.5203C306.339 85.272 302.876 84.9261 299.43 84.4471C295.994 83.9327 292.557 83.3384 289.174 82.5402C285.782 81.7596 282.425 80.7929 279.157 79.5689C277.527 78.948 275.924 78.2473 274.374 77.4491C272.833 76.6331 271.318 75.7373 270.025 74.5576C272.886 76.5355 276.154 77.7152 279.44 78.7085C282.726 79.7108 286.083 80.4736 289.457 81.1299C296.215 82.4071 303.053 83.232 309.917 83.7021C316.781 84.181 323.672 84.3052 330.536 83.9327C333.964 83.7287 337.392 83.4182 340.775 82.824C341.617 82.6643 342.467 82.5402 343.299 82.3273L344.557 82.0346L345.788 81.671C347.409 81.1388 349.056 80.5623 350.465 79.5245V79.5157Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 51,
    width: 86,
    height: 31
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M401.33 65.9365C401.756 60.0117 383.253 53.8297 360.003 52.1445C336.754 50.4593 317.569 53.8918 317.144 59.8255C317.047 61.2268 316.684 66.3445 316.577 67.7459C316.152 73.6707 334.655 79.8528 357.904 81.538C381.154 83.2232 400.338 79.7907 400.764 73.857C400.861 72.4556 401.224 67.3379 401.33 65.9365Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13830_12464)"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M401.33 65.9365C401.756 60.0117 383.253 53.8297 360.003 52.1445C336.754 50.4593 317.569 53.8918 317.144 59.8255C317.047 61.2268 316.684 66.3445 316.577 67.7459C316.152 73.6707 334.655 79.8528 357.904 81.538C381.154 83.2232 400.338 79.7907 400.764 73.857C400.861 72.4556 401.224 67.3379 401.33 65.9365Z",
    fill: "url(#paint4_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M317.667 76.5004L317.1 76.4649L318.526 56.4819L319.093 56.5174L317.667 76.5004Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M319.022 76.8109L318.456 76.7754L319.882 56.7925L320.448 56.828L319.022 76.8109Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M320.395 77.121L319.828 77.0767L321.254 57.0938L321.821 57.1381L320.395 77.121Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M321.786 77.4228L321.219 77.3785L322.645 57.3955L323.212 57.4399L321.786 77.4228Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M323.194 77.7241L322.627 77.6797L324.053 57.6968L324.62 57.7411L323.194 77.7241Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M324.62 78.0171L324.053 77.9727L325.479 57.9897L326.046 58.0341L324.62 78.0171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M326.072 78.3095L325.506 78.2652L326.932 58.2822L327.498 58.3177L326.072 78.3095Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M327.534 78.5937L326.967 78.5494L328.393 58.5664L328.96 58.6108L327.534 78.5937Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M329.022 78.8685L328.455 78.8331L329.881 58.8501L330.448 58.8856L329.022 78.8685Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M330.519 79.1435L329.952 79.108L331.378 59.1162L331.945 59.1606L330.519 79.1435Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M332.042 79.4184L331.475 79.3741L332.901 59.3911L333.468 59.4266L332.042 79.4184Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M333.583 79.6757L333.016 79.6403L334.442 59.6484L335.009 59.6928L333.583 79.6757Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M335.133 79.9326L334.575 79.8882L335.992 59.9053L336.559 59.9496L335.133 79.9326Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M336.71 80.1816L336.143 80.1373L337.569 60.1543L338.136 60.1986L336.71 80.1816Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M338.304 80.4204L337.737 80.3849L339.163 60.3931L339.73 60.4374L338.304 80.4204Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M339.916 80.6601L339.349 80.6158L340.775 60.6328L341.342 60.6683L339.916 80.6601Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M341.537 80.8818L340.97 80.8463L342.396 60.8545L342.963 60.8988L341.537 80.8818Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M343.184 81.1035L342.617 81.0591L344.043 61.0762L344.61 61.1205L343.184 81.1035Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M344.85 81.3075L344.283 81.272L345.709 61.2891L346.267 61.3245L344.85 81.3075Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M346.523 81.5117L345.957 81.4673L347.383 61.4844L347.949 61.5287L346.523 81.5117Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M348.215 81.707L347.657 81.6626L349.074 61.6797L349.641 61.7152L348.215 81.707Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M349.933 81.8842L349.366 81.8399L350.792 61.8569L351.359 61.9013L349.933 81.8842Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 82.0615L351.094 82.0171L352.519 62.0342L353.086 62.0697L351.66 82.0615Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M353.405 82.2211L352.839 82.1768L354.265 62.1938L354.831 62.2382L353.405 82.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M355.168 82.372L354.601 82.3277L356.027 62.3447L356.594 62.3891L355.168 82.372Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M356.948 82.5136L356.381 82.4693L357.807 62.4863L358.365 62.5307L356.948 82.5136Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M358.728 82.6381L358.17 82.6026L359.588 62.6196L360.154 62.6551L358.728 82.6381Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M360.509 82.7627L359.942 82.7183L361.368 62.7354L361.935 62.7708L360.509 82.7627Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M362.271 82.8598L361.704 82.8243L363.13 62.8325L363.697 62.8769L362.271 82.8598Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M364.016 82.9481L363.449 82.9126L364.875 62.9297L365.442 62.9652L364.016 82.9481Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M365.743 83.0283L365.176 82.9928L366.602 63.001L367.169 63.0453L365.743 83.0283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M367.461 83.0991L366.895 83.0547L368.32 63.0718L368.887 63.1161L367.461 83.0991Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M369.162 83.1523L368.595 83.108L370.021 63.125L370.588 63.1694L369.162 83.1523Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M370.845 83.1967L370.278 83.1524L371.704 63.1694L372.271 63.2138L370.845 83.1967Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M372.519 83.2235L371.952 83.188L373.378 63.2051L373.945 63.2406L372.519 83.2235Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M374.166 83.25L373.608 83.2056L375.026 63.2227L375.592 63.267L374.166 83.25Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M375.805 83.2588L375.247 83.2144L376.664 63.2314L377.231 63.2758L375.805 83.2588Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M377.426 83.2588L376.868 83.2144L378.285 63.2314L378.852 63.2758L377.426 83.2588Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M379.038 83.25L378.471 83.2056L379.897 63.2227L380.464 63.267L379.038 83.25Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M380.623 83.2324L380.056 83.188L381.482 63.2051L382.049 63.2494L380.623 83.2324Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 83.206L381.633 83.1617L383.059 63.1787L383.617 63.2231L382.2 83.206Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M383.75 83.161L383.183 83.1255L384.609 63.1426L385.176 63.1781L383.75 83.161Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M385.29 83.1171L384.724 83.0817L386.15 63.0898L386.716 63.1342L385.29 83.1171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M386.814 83.0639L386.247 83.0284L387.673 63.0366L388.231 63.081L386.814 83.0639Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M388.311 83.0014L387.753 82.9571L389.17 62.9741L389.737 63.0185L388.311 83.0014Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M389.799 82.9306L389.232 82.8951L390.658 62.9033L391.225 62.9477L389.799 82.9306Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M391.269 82.851L390.702 82.8155L392.128 62.8325L392.695 62.868L391.269 82.851Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M392.722 82.771L392.155 82.7266L393.581 62.7437L394.148 62.788L392.722 82.771Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M394.156 82.6737L393.59 82.6382L395.016 62.6553L395.574 62.6908L394.156 82.6737Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M395.565 82.5761L394.998 82.5406L396.424 62.5576L396.991 62.5931L395.565 82.5761Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M396.964 82.4785L396.397 82.4341L397.823 62.4512L398.39 62.4867L396.964 82.4785Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M398.337 82.3632L397.779 82.3189L399.196 62.3359L399.763 62.3803L398.337 82.3632Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M351.802 51.7632C344.805 51.6036 338.384 51.9317 333.025 52.659L331.28 77.13C336.479 78.6289 342.786 79.8706 349.738 80.731L351.802 51.7632Z",
    fill: "#EDE7DE"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M401.331 65.9364C400.906 71.8612 381.721 75.3026 358.471 73.6174C335.222 71.9322 316.728 65.7501 317.145 59.8253C317.57 53.9005 336.754 50.4591 360.004 52.1443C383.253 53.8295 401.747 60.0116 401.331 65.9364Z",
    fill: "url(#paint5_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M352.812 71.2495C356.771 69.6264 360.756 68.0653 364.689 66.3801C368.595 64.6949 372.483 62.9476 376.354 61.1826C379.755 59.6304 383.147 58.0783 386.548 56.535C382.261 55.311 377.239 54.2467 371.721 53.4307C369.64 54.2733 367.559 55.1247 365.477 55.9673C359.95 58.2113 354.424 60.4287 348.861 62.5751C343.326 64.7127 337.764 66.7615 332.219 68.8902C332.007 68.97 331.794 69.0587 331.573 69.1385C336.594 70.602 342.679 71.8349 349.384 72.6952C350.518 72.2074 351.66 71.7196 352.803 71.2495H352.812Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 54,
    width: 67,
    height: 16
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M392.039 64.3938C391.747 68.527 376.85 70.8153 358.772 69.5026C340.695 68.19 326.276 63.773 326.568 59.6398C326.861 55.5066 341.758 53.2183 359.835 54.5309C377.913 55.8436 392.332 60.2606 392.039 64.3938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13830_12464)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M392.039 64.3938C391.747 68.527 376.85 70.8153 358.772 69.5026C340.695 68.19 326.276 63.773 326.568 59.6398C326.861 55.5066 341.758 53.2183 359.835 54.5309C377.913 55.8436 392.332 60.2606 392.039 64.3938Z",
    fill: "url(#paint6_linear_13830_12464)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M392.411 67.6311C392.119 71.7643 377.222 74.0526 359.144 72.74C341.067 71.4273 326.648 67.0103 326.94 62.8771C327.232 58.7439 342.13 56.4556 360.207 57.7682C378.284 59.0809 392.704 63.4979 392.411 67.6311Z",
    fill: "url(#paint7_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M333.981 67.8173L368.922 54.7437L384.52 57.7149L352.82 71.5957L333.981 67.8173Z",
    fill: "#EDE7DE"
  })))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M399.772 68.5625C398.488 69.751 396.867 70.505 395.255 71.1613L394.032 71.6314L392.784 72.0216C391.951 72.3055 391.11 72.5006 390.259 72.7223C386.867 73.5383 383.413 74.0528 379.95 74.3809C373.015 75.055 366.044 75.0107 359.109 74.5672C355.646 74.3188 352.183 73.9729 348.738 73.494C345.301 72.9707 341.865 72.3853 338.481 71.587C335.089 70.8065 331.732 69.8397 328.464 68.6158C326.834 67.9949 325.231 67.2942 323.681 66.4959C322.14 65.68 320.625 64.7841 319.332 63.6045C322.193 65.5824 325.461 66.762 328.747 67.7554C332.033 68.7577 335.39 69.5204 338.765 70.1768C345.523 71.454 352.36 72.2788 359.224 72.7489C366.089 73.2279 372.979 73.3521 379.843 72.9795C383.271 72.7755 386.699 72.4651 390.082 71.8709C390.924 71.7112 391.774 71.587 392.606 71.3742L393.864 71.0815L395.095 70.7178C396.716 70.1856 398.364 69.6091 399.772 68.5714V68.5625Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 39,
    width: 86,
    height: 32
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M356.098 54.0601C356.523 48.1353 338.021 41.9532 314.771 40.268C291.521 38.5828 272.337 42.0153 271.912 47.949C271.814 49.3504 271.451 54.4681 271.345 55.8695C270.92 61.7943 289.422 67.9763 312.672 69.6615C335.921 71.3467 355.106 67.9142 355.531 61.9805C355.628 60.5792 355.991 55.4615 356.098 54.0601Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13830_12464)"
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M356.098 54.0601C356.523 48.1353 338.021 41.9532 314.771 40.268C291.521 38.5828 272.337 42.0153 271.912 47.949C271.814 49.3504 271.451 54.4681 271.345 55.8695C270.92 61.7943 289.422 67.9763 312.672 69.6615C335.921 71.3467 355.106 67.9142 355.531 61.9805C355.628 60.5792 355.991 55.4615 356.098 54.0601Z",
    fill: "url(#paint8_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M272.434 64.6328L271.867 64.5884L273.293 44.6055L273.86 44.6498L272.434 64.6328Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M273.781 64.9433L273.223 64.899L274.64 44.916L275.207 44.9604L273.781 64.9433Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M275.153 65.245L274.586 65.2095L276.012 45.2266L276.579 45.262L275.153 65.245Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M276.544 65.5551L275.977 65.5108L277.403 45.5278L277.97 45.5633L276.544 65.5551Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M277.961 65.8476L277.394 65.8121L278.82 45.8203L279.378 45.8647L277.961 65.8476Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M279.387 66.1494L278.82 66.105L280.246 46.1221L280.813 46.1575L279.387 66.1494Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M280.831 66.4331L280.264 66.3976L281.69 46.4058L282.257 46.4501L280.831 66.4331Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M282.301 66.7172L281.734 66.6817L283.16 46.6987L283.727 46.7342L282.301 66.7172Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M283.78 67.0009L283.213 66.9566L284.639 46.9736L285.206 47.018L283.78 67.0009Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M285.286 67.2758L284.719 67.2315L286.145 47.2485L286.712 47.2929L285.286 67.2758Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M286.809 67.542L286.242 67.5065L287.668 47.5146L288.226 47.559L286.809 67.542Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M288.342 67.8081L287.775 67.7637L289.201 47.7808L289.767 47.8162L288.342 67.8081Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M289.9 68.0654L289.333 68.021L290.759 48.0381L291.326 48.0736L289.9 68.0654Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M291.477 68.3134L290.91 68.2691L292.336 48.2861L292.903 48.3216L291.477 68.3134Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M293.062 68.5532L292.504 68.5088L293.921 48.5259L294.488 48.5702L293.062 68.5532Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M294.674 68.7836L294.107 68.7482L295.533 48.7563L296.1 48.8007L294.674 68.7836Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M296.304 69.0141L295.737 68.9698L297.163 48.9868L297.73 49.0312L296.304 69.0141Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M297.943 69.227L297.385 69.1915L298.802 49.1997L299.369 49.2441L297.943 69.227Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M299.608 69.4399L299.041 69.3956L300.467 49.4126L301.034 49.4569L299.608 69.4399Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M301.29 69.6445L300.724 69.6001L302.15 49.6172L302.708 49.6527L301.29 69.6445Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M302.982 69.8305L302.415 69.795L303.841 49.8032L304.408 49.8476L302.982 69.8305Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M304.692 70.0166L304.125 69.9722L305.551 49.9893L306.118 50.0247L304.692 70.0166Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M306.419 70.185L305.861 70.1407L307.278 50.1577L307.845 50.2021L306.419 70.185Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M308.164 70.3446L307.606 70.3091L309.023 50.3262L309.59 50.3617L308.164 70.3446Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M309.926 70.4955L309.359 70.46L310.785 50.4771L311.352 50.5125L309.926 70.4955Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M311.706 70.6376L311.139 70.6021L312.565 50.6191L313.132 50.6546L311.706 70.6376Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M313.496 70.7705L312.929 70.7261L314.355 50.7432L314.922 50.7875L313.496 70.7705Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M315.267 70.8862L314.709 70.8419L316.126 50.8589L316.693 50.9032L315.267 70.8862Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M317.029 70.9921L316.463 70.9478L317.889 50.9648L318.455 51.0092L317.029 70.9921Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M318.774 71.0805L318.208 71.0362L319.633 51.0532L320.2 51.0976L318.774 71.0805Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M320.51 71.1606L319.943 71.1163L321.369 51.1333L321.936 51.1776L320.51 71.1606Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M322.228 71.2226L321.662 71.1871L323.088 51.1953L323.646 51.2397L322.228 71.2226Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M323.929 71.2762L323.362 71.2408L324.788 51.2578L325.346 51.2933L323.929 71.2762Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M325.612 71.3207L325.045 71.2852L326.471 51.3022L327.038 51.3377L325.612 71.3207Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M327.277 71.3559L326.71 71.3116L328.136 51.3286L328.703 51.373L327.277 71.3559Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M328.933 71.3734L328.366 71.3379L329.792 51.355L330.359 51.3905L328.933 71.3734Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M330.572 71.3911L330.005 71.3467L331.431 51.3638L331.998 51.3992L330.572 71.3911Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M332.193 71.3911L331.626 71.3467L333.052 51.3638L333.619 51.3992L332.193 71.3911Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M333.796 71.3823L333.229 71.3379L334.655 51.355L335.222 51.3905L333.796 71.3823Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M335.39 71.3558L334.823 71.3204L336.249 51.3374L336.807 51.3729L335.39 71.3558Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M336.958 71.3296L336.391 71.2941L337.817 51.3022L338.384 51.3466L336.958 71.3296Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M338.517 71.2934L337.95 71.2491L339.376 51.2661L339.943 51.3105L338.517 71.2934Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M340.049 71.2495L339.491 71.2051L340.908 51.2222L341.475 51.2665L340.049 71.2495Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M341.572 71.1962L341.005 71.1519L342.431 51.1689L342.998 51.2133L341.572 71.1962Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M343.078 71.1342L342.511 71.0899L343.937 51.1069L344.504 51.1424L343.078 71.1342Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M344.566 71.063L343.999 71.0186L345.425 51.0356L345.992 51.08L344.566 71.063Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M346.036 70.9834L345.469 70.939L346.895 50.9561L347.453 51.0004L346.036 70.9834Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M347.48 70.8949L346.913 70.8594L348.339 50.8765L348.906 50.9119L347.48 70.8949Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M348.915 70.8061L348.348 70.7618L349.774 50.7788L350.341 50.8232L348.915 70.8061Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M350.332 70.7085L349.765 70.6641L351.191 50.6812L351.758 50.7255L350.332 70.7085Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M351.722 70.602L351.164 70.5577L352.581 50.5747L353.148 50.6191L351.722 70.602Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M353.104 70.4956L352.537 70.4512L353.963 50.4683L354.53 50.5037L353.104 70.4956Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M306.56 39.8871C299.563 39.7363 293.142 40.0556 287.783 40.7829L286.038 65.2539C291.237 66.7528 297.544 67.9945 304.496 68.8549L306.56 39.8871Z",
    fill: "#EDE7DE"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M356.089 54.0448C356.519 48.1186 338.022 41.9476 314.774 40.2616C291.527 38.5755 272.332 42.0128 271.902 47.9391C271.472 53.8653 289.969 60.0363 313.217 61.7223C336.464 63.4084 355.659 59.971 356.089 54.0448Z",
    fill: "url(#paint9_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M307.579 59.373C311.538 57.7499 315.524 56.1889 319.456 54.5037C323.362 52.8184 327.25 51.0712 331.121 49.3061C334.522 47.754 337.914 46.2018 341.315 44.6585C337.028 43.4345 332.006 42.3702 326.489 41.5542C324.407 42.3968 322.326 43.2483 320.244 44.0909C314.718 46.3349 309.191 48.5522 303.629 50.6986C298.093 52.8362 292.531 54.885 286.986 57.0137C286.774 57.0935 286.561 57.1822 286.34 57.2621C291.362 58.7255 297.446 59.9584 304.151 60.8276C305.285 60.3398 306.427 59.852 307.57 59.3819L307.579 59.373Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 42,
    width: 66,
    height: 17
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M346.807 52.5257C346.514 56.6588 331.617 58.9472 313.54 57.6345C295.462 56.3218 281.043 51.9048 281.335 47.7716C281.628 43.6384 296.525 41.3501 314.602 42.6628C332.68 43.9755 347.099 48.3925 346.807 52.5257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13830_12464)"
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M346.807 52.5257C346.514 56.6588 331.617 58.9472 313.54 57.6345C295.462 56.3218 281.043 51.9048 281.335 47.7716C281.628 43.6384 296.525 41.3501 314.602 42.6628C332.68 43.9755 347.099 48.3925 346.807 52.5257Z",
    fill: "url(#paint10_linear_13830_12464)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M347.179 55.763C346.886 59.8961 331.989 62.1845 313.912 60.8718C295.834 59.5591 281.415 55.1421 281.707 51.0089C282 46.8757 296.897 44.5874 314.974 45.9001C333.052 47.2128 347.471 51.6298 347.179 55.763Z",
    fill: "url(#paint11_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M288.749 55.9496L323.681 42.876L339.278 45.8384L307.588 59.728L288.749 55.9496Z",
    fill: "#EDE7DE"
  })))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M354.53 56.6861C353.246 57.8746 351.625 58.6285 350.013 59.2848L348.79 59.7549L347.542 60.1452C346.709 60.429 345.868 60.6241 345.017 60.8459C341.625 61.6619 338.171 62.1763 334.708 62.5045C327.773 63.1785 320.802 63.1342 313.867 62.6907C310.404 62.4424 306.941 62.0965 303.496 61.6175C300.059 61.1031 296.623 60.5088 293.239 59.7106C289.847 58.9301 286.49 57.9633 283.222 56.7393C281.592 56.1184 279.989 55.4177 278.439 54.6195C276.898 53.8035 275.383 52.9077 274.09 51.728C276.951 53.7059 280.219 54.8856 283.505 55.8789C286.791 56.8812 290.148 57.644 293.523 58.3003C300.281 59.5775 307.118 60.4024 313.982 60.8725C320.847 61.3514 327.737 61.4756 334.602 61.1031C338.029 60.8991 341.457 60.5886 344.84 59.9944C345.682 59.8347 346.532 59.7106 347.365 59.4977L348.622 59.205L349.853 58.8414C351.474 58.3092 353.122 57.7327 354.53 56.6949V56.6861Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 371,
    y: 58,
    width: 86,
    height: 31
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M456.519 72.7837C456.944 66.8589 438.441 60.6769 415.192 58.9917C391.942 57.3065 372.758 60.7389 372.333 66.6726C372.235 68.074 371.872 73.1917 371.766 74.5931C371.341 80.5179 389.843 86.6999 413.093 88.3851C436.342 90.0704 455.527 86.6379 455.952 80.7042C456.049 79.3028 456.412 74.1851 456.519 72.7837Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13830_12464)"
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M456.519 72.7837C456.944 66.8589 438.441 60.6769 415.192 58.9917C391.942 57.3065 372.758 60.7389 372.333 66.6726C372.235 68.074 371.872 73.1917 371.766 74.5931C371.341 80.5179 389.843 86.6999 413.093 88.3851C436.342 90.0704 455.527 86.6379 455.952 80.7042C456.049 79.3028 456.412 74.1851 456.519 72.7837Z",
    fill: "url(#paint12_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M372.855 83.3559L372.297 83.3116L373.714 63.3286L374.281 63.3641L372.855 83.3559Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M374.21 83.6665L373.644 83.6221L375.07 63.6392L375.636 63.6746L374.21 83.6665Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M375.583 83.9677L375.016 83.9234L376.442 63.9404L377.009 63.9848L375.583 83.9677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M376.974 84.2695L376.407 84.234L377.833 64.2422L378.4 64.2865L376.974 84.2695Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M378.382 84.5713L377.815 84.5269L379.241 64.5439L379.808 64.5883L378.382 84.5713Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M379.808 84.8637L379.25 84.8283L380.667 64.8364L381.234 64.8808L379.808 84.8637Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M381.26 85.1567L380.694 85.1124L382.12 65.1294L382.686 65.1737L381.26 85.1567Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M382.722 85.4409L382.155 85.3965L383.581 65.4136L384.148 65.4579L382.722 85.4409Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M384.21 85.7241L383.643 85.6797L385.069 65.6968L385.636 65.7323L384.21 85.7241Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M385.707 85.9995L385.149 85.9551L386.566 65.9722L387.133 66.0076L385.707 85.9995Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M387.23 86.2651L386.663 86.2207L388.089 66.2378L388.656 66.2821L387.23 86.2651Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M388.771 86.5224L388.204 86.4869L389.63 66.4951L390.197 66.5395L388.771 86.5224Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M390.33 86.7797L389.763 86.7443L391.189 66.7524L391.747 66.7968L390.33 86.7797Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M391.898 87.0283L391.331 86.9928L392.757 67.001L393.324 67.0453L391.898 87.0283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M393.492 87.2675L392.925 87.232L394.351 67.249L394.918 67.2845L393.492 87.2675Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M395.104 87.5073L394.537 87.4629L395.963 67.48L396.53 67.5243L395.104 87.5073Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M396.725 87.7285L396.167 87.693L397.584 67.7012L398.151 67.7455L396.725 87.7285Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M398.372 87.9506L397.805 87.9063L399.231 67.9233L399.798 67.9677L398.372 87.9506Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M400.037 88.1635L399.47 88.1192L400.896 68.1362L401.463 68.1717L400.037 88.1635Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M401.711 88.3584L401.145 88.3229L402.571 68.3311L403.137 68.3754L401.711 88.3584Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M403.412 88.5537L402.845 88.5093L404.271 68.5264L404.829 68.5707L403.412 88.5537Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M405.121 88.7309L404.554 88.6954L405.98 68.7036L406.547 68.748L405.121 88.7309Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M406.848 88.9087L406.281 88.8643L407.707 68.8813L408.274 68.9257L406.848 88.9087Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M408.593 89.0678L408.026 89.0235L409.452 69.0405L410.019 69.0849L408.593 89.0678Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M410.356 89.2192L409.789 89.1749L411.215 69.1919L411.782 69.2362L410.356 89.2192Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M412.136 89.3608L411.569 89.3165L412.995 69.3335L413.562 69.3778L412.136 89.3608Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M413.925 89.4936L413.358 89.4493L414.784 69.4663L415.342 69.5018L413.925 89.4936Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 89.6093L415.13 89.565L416.556 69.582L417.123 69.6264L415.697 89.6093Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M417.459 89.7064L416.892 89.6709L418.318 69.688L418.885 69.7235L417.459 89.7064Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M419.204 89.8042L418.637 89.7598L420.063 69.7769L420.63 69.8123L419.204 89.8042Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M420.931 89.8749L420.373 89.8394L421.79 69.8564L422.357 69.8919L420.931 89.8749Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M422.649 89.9462L422.083 89.9019L423.508 69.9189L424.075 69.9633L422.649 89.9462Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M424.35 89.999L423.783 89.9546L425.209 69.9717L425.776 70.016L424.35 89.999Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M426.033 90.0434L425.475 89.9991L426.892 70.0161L427.459 70.0605L426.033 90.0434Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M427.707 90.0791L427.14 90.0347L428.566 70.0518L429.132 70.0872L427.707 90.0791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M429.363 90.0966L428.796 90.0523L430.222 70.0693L430.78 70.1137L429.363 90.0966Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M431.002 90.1059L430.435 90.0704L431.861 70.0786L432.419 70.123L431.002 90.1059Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M432.622 90.1059L432.055 90.0704L433.481 70.0786L434.039 70.123L432.622 90.1059Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M434.226 90.0966L433.659 90.0612L435.085 70.0693L435.652 70.1137L434.226 90.0966Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M435.811 90.0791L435.244 90.0347L436.67 70.0518L437.237 70.0961L435.811 90.0791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M437.387 90.0527L436.82 90.0083L438.246 70.0254L438.813 70.0697L437.387 90.0527Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M438.937 90.0171L438.37 89.9727L439.796 69.9897L440.363 70.0252L438.937 90.0171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M440.478 89.9637L439.912 89.9283L441.338 69.9453L441.904 69.9808L440.478 89.9637Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M442.002 89.911L441.435 89.8755L442.861 69.8926L443.428 69.9281L442.002 89.911Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M443.508 89.8486L442.941 89.8131L444.367 69.8213L444.925 69.8656L443.508 89.8486Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M444.987 89.7772L444.42 89.7417L445.846 69.7588L446.413 69.7943L444.987 89.7772Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M446.457 89.7065L445.89 89.6622L447.316 69.6792L447.883 69.7147L446.457 89.7065Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M447.909 89.6181L447.343 89.5738L448.769 69.5908L449.335 69.6352L447.909 89.6181Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M449.344 89.5293L448.778 89.4849L450.204 69.502L450.77 69.5374L449.344 89.5293Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M450.753 89.4321L450.195 89.3877L451.612 69.4048L452.179 69.4403L450.753 89.4321Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M452.152 89.3252L451.585 89.2808L453.011 69.2979L453.578 69.3333L452.152 89.3252Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M453.534 89.2099L452.967 89.1744L454.393 69.1826L454.951 69.227L453.534 89.2099Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M406.99 58.6103C399.993 58.4595 393.572 58.7788 388.213 59.5061L386.469 83.977C391.668 85.4759 397.974 86.7177 404.927 87.578L406.99 58.6103Z",
    fill: "#EDE7DE"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M456.501 72.7719C456.931 66.8457 438.434 60.6747 415.186 58.9886C391.939 57.3026 372.744 60.7399 372.314 66.6661C371.884 72.5924 390.381 78.7633 413.628 80.4494C436.876 82.1354 456.071 78.6981 456.501 72.7719Z",
    fill: "url(#paint13_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M408.009 78.0961C411.968 76.473 415.953 74.912 419.886 73.2268C423.792 71.5416 427.68 69.7943 431.551 68.0293C434.952 66.4771 438.344 64.925 441.745 63.3817C437.458 62.1577 432.436 61.0933 426.918 60.2773C424.837 61.1199 422.756 61.9714 420.674 62.814C415.147 65.058 409.621 67.2754 404.058 69.4218C398.523 71.5593 392.961 73.6082 387.416 75.7369C387.204 75.8167 386.991 75.9054 386.77 75.9852C391.791 77.4487 397.876 78.6815 404.581 79.5507C405.715 79.0629 406.857 78.5751 408 78.105L408.009 78.0961Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 381,
    y: 61,
    width: 67,
    height: 16
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M447.227 71.2405C446.935 75.3737 432.038 77.662 413.96 76.3493C395.883 75.0366 381.464 70.6196 381.756 66.4865C382.049 62.3533 396.946 60.0649 415.023 61.3776C433.1 62.6903 447.52 67.1073 447.227 71.2405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13830_12464)"
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M447.227 71.2405C446.935 75.3737 432.037 77.662 413.96 76.3493C395.883 75.0366 381.464 70.6196 381.756 66.4865C382.048 62.3533 396.946 60.0649 415.023 61.3776C433.1 62.6903 447.519 67.1073 447.227 71.2405Z",
    fill: "url(#paint14_linear_13830_12464)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M447.596 74.4681C447.896 70.3349 433.482 65.9212 415.401 64.6098C397.32 63.2985 382.419 65.5861 382.119 69.7193C381.819 73.8525 396.234 78.2662 414.315 79.5775C432.395 80.8888 447.296 78.6013 447.596 74.4681Z",
    fill: "url(#paint15_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M389.169 74.664L424.11 61.5903L439.708 64.5616L408.008 78.4424L389.169 74.664Z",
    fill: "#EDE7DE"
  })))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M454.96 75.4087C453.675 76.5972 452.054 77.3511 450.442 78.0075L449.22 78.4776L447.971 78.8678C447.139 79.1516 446.297 79.3468 445.447 79.5685C442.055 80.3845 438.601 80.8989 435.138 81.2271C428.202 81.9012 421.232 81.8568 414.297 81.4134C410.834 81.165 407.371 80.8191 403.925 80.3402C400.489 79.8257 397.052 79.2315 393.669 78.4332C390.277 77.6527 386.92 76.6859 383.652 75.4619C382.022 74.8411 380.419 74.1404 378.869 73.3421C377.328 72.5261 375.813 71.6303 374.52 70.4507C377.381 72.4286 380.649 73.6082 383.935 74.6016C387.221 75.6039 390.578 76.3666 393.952 77.023C400.71 78.3002 407.548 79.125 414.412 79.5951C421.276 80.0741 428.167 80.1983 435.031 79.8257C438.459 79.6217 441.887 79.3113 445.27 78.717C446.111 78.5574 446.962 78.4332 447.794 78.2204L449.052 77.9277L450.283 77.564C451.904 77.0318 453.551 76.4553 454.96 75.4176V75.4087Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 66,
    width: 86,
    height: 32
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M533.424 81.0056C533.849 75.0808 515.347 68.8988 492.097 67.2136C468.848 65.5284 449.663 68.9609 449.238 74.8946C449.141 76.2959 448.778 81.4136 448.671 82.815C448.246 88.7398 466.748 94.9219 489.998 96.6071C513.248 98.2923 532.432 94.8598 532.857 88.9261C532.955 87.5247 533.318 82.407 533.424 81.0056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13830_12464)"
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M533.424 81.0056C533.849 75.0808 515.347 68.8988 492.097 67.2136C468.848 65.5284 449.663 68.9609 449.238 74.8946C449.141 76.2959 448.778 81.4136 448.671 82.815C448.246 88.7398 466.748 94.9219 489.998 96.6071C513.248 98.2923 532.432 94.8598 532.857 88.9261C532.955 87.5247 533.318 82.407 533.424 81.0056Z",
    fill: "url(#paint16_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 91.5695L449.194 91.5341L450.62 71.5422L451.187 71.5866L449.761 91.5695Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M451.116 91.8801L450.549 91.8446L451.975 71.8528L452.542 71.8971L451.116 91.8801Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M452.489 92.1906L451.922 92.1463L453.348 72.1633L453.915 72.1988L452.489 92.1906Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M453.879 92.4919L453.312 92.4476L454.738 72.4646L455.305 72.5089L453.879 92.4919Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M455.288 92.7937L454.721 92.7493L456.147 72.7664L456.714 72.8018L455.288 92.7937Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M456.713 93.0866L456.146 93.0423L457.572 73.0593L458.139 73.1037L456.713 93.0866Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M458.166 93.3702L457.599 93.3348L459.025 73.3518L459.583 73.3873L458.166 93.3702Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M459.627 93.6628L459.061 93.6185L460.487 73.6355L461.053 73.671L459.627 93.6628Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M461.115 93.9382L460.549 93.9027L461.975 73.9109L462.533 73.9552L461.115 93.9382Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M462.612 94.2131L462.045 94.1687L463.471 74.1858L464.038 74.2301L462.612 94.2131Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M464.135 94.4791L463.569 94.4436L464.995 74.4607L465.561 74.4962L464.135 94.4791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M465.677 94.7448L465.11 94.7005L466.536 74.7175L467.094 74.7619L465.677 94.7448Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M467.227 95.0022L466.66 94.9578L468.086 74.9749L468.653 75.0192L467.227 95.0022Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M468.803 95.2507L468.236 95.2063L469.662 75.2234L470.229 75.2677L468.803 95.2507Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M470.398 95.4899L469.831 95.4456L471.257 75.4626L471.824 75.507L470.398 95.4899Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M472.01 95.7203L471.443 95.6849L472.869 75.7019L473.427 75.7374L472.01 95.7203Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M473.63 95.9514L473.063 95.907L474.489 75.9241L475.056 75.9684L473.63 95.9514Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M475.278 96.1731L474.711 96.1287L476.137 76.1458L476.704 76.1812L475.278 96.1731Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M476.934 96.3772L476.376 96.3417L477.793 76.3499L478.36 76.3942L476.934 96.3772Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M478.617 96.5813L478.05 96.5369L479.476 76.554L480.043 76.5983L478.617 96.5813Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M480.309 96.7677L479.742 96.7322L481.168 76.7493L481.735 76.7847L480.309 96.7677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M482.027 96.9533L481.46 96.909L482.886 76.926L483.444 76.9704L482.027 96.9533Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M483.754 97.1223L483.187 97.0868L484.613 77.095L485.18 77.1393L483.754 97.1223Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M485.499 97.2907L484.932 97.2464L486.358 77.2634L486.925 77.2989L485.499 97.2907Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M487.261 97.4411L486.695 97.3968L488.121 77.4138L488.687 77.4582L487.261 97.4411Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M489.033 97.5832L488.475 97.5389L489.892 77.5559L490.459 77.5914L489.033 97.5832Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M490.822 97.7072L490.255 97.6718L491.681 77.6799L492.248 77.7243L490.822 97.7072Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M492.602 97.8229L492.035 97.7874L493.461 77.8044L494.028 77.8399L492.602 97.8229Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M494.365 97.9294L493.798 97.885L495.224 77.9021L495.782 77.9464L494.365 97.9294Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M496.109 98.0178L495.542 97.9823L496.969 77.9905L497.535 78.0348L496.109 98.0178Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M497.837 98.0974L497.27 98.053L498.696 78.0701L499.263 78.1144L497.837 98.0974Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M499.555 98.1687L498.988 98.1243L500.414 78.1414L500.981 78.1768L499.555 98.1687Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M501.255 98.2219L500.688 98.1775L502.114 78.1946L502.681 78.2389L501.255 98.2219Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M502.938 98.2663L502.371 98.222L503.797 78.239L504.364 78.2745L502.938 98.2663Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M504.612 98.2927L504.045 98.2572L505.471 78.2654L506.038 78.3097L504.612 98.2927Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M506.26 98.3195L505.693 98.2752L507.119 78.2922L507.686 78.3277L506.26 98.3195Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M507.898 98.3283L507.331 98.284L508.757 78.301L509.324 78.3454L507.898 98.3283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M509.519 98.3283L508.952 98.284L510.378 78.301L510.945 78.3454L509.519 98.3283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M511.131 98.3195L510.564 98.2752L511.99 78.2922L512.548 78.3366L511.131 98.3195Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M512.716 98.302L512.149 98.2576L513.575 78.2747L514.142 78.3101L512.716 98.302Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M514.284 98.2662L513.726 98.2308L515.143 78.2478L515.71 78.2833L514.284 98.2662Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M515.843 98.2307L515.276 98.1952L516.702 78.2034L517.269 78.2477L515.843 98.2307Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M517.384 98.1867L516.817 98.1424L518.243 78.1594L518.81 78.2038L517.384 98.1867Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M518.899 98.1335L518.341 98.0892L519.758 78.1062L520.325 78.1506L518.899 98.1335Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M520.404 98.071L519.837 98.0267L521.263 78.0437L521.83 78.0881L520.404 98.071Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M521.892 98.0002L521.325 97.9559L522.751 77.9729L523.318 78.0173L521.892 98.0002Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M523.363 97.9206L522.796 97.8851L524.222 77.8933L524.788 77.9377L523.363 97.9206Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M524.815 97.8405L524.248 97.7962L525.674 77.8132L526.241 77.8487L524.815 97.8405Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M526.241 97.7429L525.683 97.7074L527.1 77.7156L527.667 77.7599L526.241 97.7429Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M527.658 97.6457L527.091 97.6014L528.517 77.6184L529.084 77.6628L527.658 97.6457Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M529.058 97.5388L528.491 97.5033L529.917 77.5115L530.484 77.5558L529.058 97.5388Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M530.43 97.4328L529.864 97.3885L531.29 77.4055L531.856 77.4499L530.43 97.4328Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M483.895 66.8238C476.898 66.6641 470.477 66.9923 465.119 67.7196L463.374 92.1905C468.573 93.6894 474.879 94.9312 481.832 95.7915L483.895 66.8238Z",
    fill: "#EDE7DE"
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M533.424 81.0057C532.999 86.9305 513.815 90.3719 490.565 88.6867C467.315 87.0015 448.822 80.8195 449.238 74.8946C449.663 68.9698 468.848 65.5285 492.097 67.2137C515.347 68.8989 533.84 75.0809 533.424 81.0057Z",
    fill: "url(#paint17_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M484.905 86.3095C488.864 84.6864 492.85 83.1254 496.782 81.4402C500.688 79.755 504.577 78.0077 508.447 76.2427C511.848 74.6905 515.24 73.1383 518.642 71.595C514.355 70.3711 509.333 69.3067 503.815 68.4907C501.734 69.3333 499.652 70.1848 497.571 71.0274C492.044 73.2714 486.517 75.4887 480.955 77.6352C475.419 79.7727 469.857 81.8216 464.313 83.9502C464.1 84.0301 463.887 84.1188 463.666 84.1986C468.688 85.6621 474.773 86.8949 481.478 87.7641C482.611 87.2763 483.754 86.7885 484.896 86.3184L484.905 86.3095Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 458,
    y: 69,
    width: 67,
    height: 16
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M524.133 79.4627C523.841 83.5958 508.943 85.8842 490.866 84.5715C472.789 83.2588 458.37 78.8418 458.662 74.7086C458.954 70.5754 473.852 68.2871 491.929 69.5998C510.006 70.9125 524.425 75.3295 524.133 79.4627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13830_12464)"
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M524.133 79.4627C523.841 83.5958 508.943 85.8842 490.866 84.5715C472.789 83.2588 458.37 78.8418 458.662 74.7086C458.954 70.5754 473.852 68.2871 491.929 69.5998C510.006 70.9125 524.425 75.3295 524.133 79.4627Z",
    fill: "url(#paint18_linear_13830_12464)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M524.505 82.7C524.213 86.8331 509.315 89.1215 491.238 87.8088C473.161 86.4961 458.741 82.0791 459.034 77.9459C459.326 73.8127 474.223 71.5244 492.301 72.8371C510.378 74.1498 524.797 78.5668 524.505 82.7Z",
    fill: "url(#paint19_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M466.075 82.8861L501.016 69.8125L516.613 72.7838L484.914 86.6645L466.075 82.8861Z",
    fill: "#EDE7DE"
  })))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M531.865 83.6314C530.581 84.8199 528.96 85.5738 527.348 86.2301L526.126 86.7002L524.877 87.0905C524.045 87.3743 523.203 87.5694 522.353 87.7912C518.961 88.6072 515.506 89.1216 512.043 89.4498C505.108 90.1239 498.138 90.0795 491.203 89.636C487.74 89.3877 484.276 89.0418 480.831 88.5628C477.395 88.0484 473.958 87.4541 470.575 86.6559C467.182 85.8754 463.826 84.9086 460.557 83.6846C458.928 83.0637 457.325 82.363 455.775 81.5648C454.233 80.7488 452.719 79.853 451.426 78.6733C454.287 80.6512 457.555 81.8309 460.841 82.8243C464.127 83.8265 467.484 84.5893 470.858 85.2456C477.616 86.5228 484.454 87.3477 491.318 87.8178C498.182 88.2967 505.073 88.4209 511.937 88.0484C515.365 87.8444 518.792 87.534 522.176 86.9397C523.017 86.7801 523.867 86.6559 524.7 86.443L525.958 86.1503L527.189 85.7867C528.81 85.2545 530.457 84.678 531.865 83.6403V83.6314Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 409,
    y: 44,
    width: 86,
    height: 32
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M494.524 59.0889C494.949 53.1641 476.447 46.982 453.197 45.2968C429.947 43.6116 410.763 47.0441 410.338 52.9778C410.241 54.3792 409.877 59.4969 409.771 60.8983C409.346 66.8231 427.848 73.0051 451.098 74.6903C474.348 76.3755 493.532 72.943 493.957 67.0093C494.055 65.608 494.418 60.4903 494.524 59.0889Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13830_12464)"
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M494.524 59.0889C494.949 53.1641 476.447 46.982 453.197 45.2968C429.947 43.6116 410.763 47.0441 410.338 52.9778C410.241 54.3792 409.877 59.4969 409.771 60.8983C409.346 66.8231 427.848 73.0051 451.098 74.6903C474.348 76.3755 493.532 72.943 493.957 67.0093C494.055 65.608 494.418 60.4903 494.524 59.0889Z",
    fill: "url(#paint20_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M410.861 69.6528L410.294 69.6173L411.72 49.6255L412.287 49.6698L410.861 69.6528Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M412.207 69.9633L411.649 69.9279L413.066 49.936L413.633 49.9804L412.207 69.9633Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M413.58 70.2739L413.013 70.2295L414.439 50.2466L415.006 50.2909L413.58 70.2739Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M414.97 70.5752L414.403 70.5308L415.829 50.5479L416.396 50.5922L414.97 70.5752Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M416.379 70.8769L415.821 70.8326L417.238 50.8496L417.805 50.8851L416.379 70.8769Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M417.813 71.1699L417.247 71.1255L418.673 51.1426L419.239 51.1869L417.813 71.1699Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M419.257 71.4624L418.69 71.418L420.116 51.4351L420.683 51.4705L419.257 71.4624Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M420.727 71.7461L420.16 71.7017L421.586 51.7188L422.144 51.7542L420.727 71.7461Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M422.206 72.021L421.64 71.9855L423.066 51.9937L423.632 52.038L422.206 72.021Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M423.712 72.2963L423.146 72.2609L424.571 52.269L425.138 52.3134L423.712 72.2963Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M425.227 72.5624L424.669 72.5269L426.086 52.5439L426.653 52.5794L425.227 72.5624Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M426.768 72.8281L426.201 72.7837L427.627 52.8008L428.194 52.8451L426.768 72.8281Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M428.327 73.0854L427.76 73.0411L429.186 53.0581L429.753 53.1025L428.327 73.0854Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M429.903 73.3335L429.336 73.2891L430.762 53.3062L431.32 53.3505L429.903 73.3335Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M431.489 73.5732L430.922 73.5289L432.348 53.5459L432.915 53.5902L431.489 73.5732Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M433.101 73.8036L432.534 73.7681L433.96 53.7852L434.527 53.8206L433.101 73.8036Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M434.73 74.0346L434.163 73.9903L435.589 54.0073L436.156 54.0517L434.73 74.0346Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M436.369 74.2563L435.811 74.212L437.228 54.229L437.795 54.2645L436.369 74.2563Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M438.034 74.4599L437.467 74.4244L438.893 54.4326L439.46 54.477L438.034 74.4599Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M439.708 74.6645L439.15 74.6202L440.567 54.6372L441.134 54.6816L439.708 74.6645Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M441.408 74.8505L440.842 74.815L442.268 54.832L442.834 54.8675L441.408 74.8505Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M443.118 75.0366L442.551 74.9922L443.977 55.0093L444.544 55.0536L443.118 75.0366Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M444.845 75.205L444.278 75.1695L445.704 55.1865L446.271 55.222L444.845 75.205Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M446.59 75.3735L446.023 75.3291L447.449 55.3462L448.016 55.3817L446.59 75.3735Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M448.353 75.5244L447.786 75.48L449.212 55.4971L449.778 55.5414L448.353 75.5244Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M450.133 75.6665L449.566 75.6221L450.992 55.6392L451.559 55.6746L450.133 75.6665Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 75.7905L451.355 75.755L452.781 55.7632L453.348 55.8075L451.922 75.7905Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M453.693 75.9056L453.126 75.8702L454.552 55.8872L455.119 55.9227L453.693 75.9056Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M455.456 76.0122L454.889 75.9678L456.315 55.9849L456.882 56.0292L455.456 76.0122Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M457.201 76.101L456.634 76.0656L458.06 56.0737L458.627 56.1181L457.201 76.101Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M458.936 76.1806L458.37 76.1363L459.796 56.1533L460.362 56.1977L458.936 76.1806Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M460.646 76.2519L460.088 76.2076L461.505 56.2246L462.072 56.2601L460.646 76.2519Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M462.347 76.3051L461.789 76.2608L463.206 56.2778L463.773 56.3222L462.347 76.3051Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M464.038 76.3496L463.471 76.3052L464.897 56.3223L465.464 56.3577L464.038 76.3496Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M465.704 76.3759L465.137 76.3405L466.563 56.3486L467.13 56.393L465.704 76.3759Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M467.36 76.4028L466.793 76.3584L468.219 56.3755L468.786 56.411L467.36 76.4028Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M468.998 76.4111L468.431 76.3667L469.857 56.3838L470.424 56.4281L468.998 76.4111Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M470.619 76.4111L470.052 76.3667L471.478 56.3838L472.045 56.4281L470.619 76.4111Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M472.222 76.4028L471.655 76.3584L473.081 56.3755L473.648 56.4198L472.222 76.4028Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M473.816 76.3847L473.25 76.3404L474.675 56.3574L475.233 56.4018L473.816 76.3847Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M475.384 76.3584L474.817 76.314L476.243 56.3311L476.81 56.3665L475.384 76.3584Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M476.943 76.3134L476.376 76.278L477.802 56.2861L478.36 56.3305L476.943 76.3134Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M478.475 76.2695L477.908 76.2252L479.334 56.2422L479.901 56.2865L478.475 76.2695Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M479.999 76.2168L479.432 76.1724L480.858 56.1895L481.425 56.2338L479.999 76.2168Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M481.504 76.1543L480.938 76.1099L482.364 56.127L482.93 56.1713L481.504 76.1543Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M482.992 76.083L482.425 76.0386L483.851 56.0557L484.418 56.1L482.992 76.083Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M484.454 76.0039L483.896 75.9684L485.313 55.9766L485.88 56.0209L484.454 76.0039Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M485.906 75.9238L485.339 75.8794L486.765 55.8965L487.332 55.932L485.906 75.9238Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M487.341 75.8261L486.774 75.7907L488.2 55.7988L488.767 55.8432L487.341 75.8261Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M488.758 75.7285L488.191 75.693L489.617 55.7012L490.184 55.7455L488.758 75.7285Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M490.149 75.622L489.582 75.5865L491.008 55.6035L491.575 55.639L490.149 75.622Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M491.53 75.5156L490.964 75.4712L492.39 55.4883L492.956 55.5326L491.53 75.5156Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M444.987 44.9068C437.99 44.7471 431.568 45.0753 426.21 45.8026L424.465 70.2735C429.664 71.7725 435.97 73.0142 442.923 73.8745L444.987 44.9068Z",
    fill: "#EDE7DE"
  }))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M494.524 59.0892C494.099 65.014 474.915 68.4554 451.665 66.7702C428.415 65.085 409.922 58.903 410.338 52.9781C410.763 47.0533 429.947 43.612 453.197 45.2972C476.447 46.9824 494.94 53.1644 494.524 59.0892Z",
    fill: "url(#paint21_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M446.005 64.393C449.964 62.7699 453.95 61.2089 457.883 59.5237C461.789 57.8385 465.677 56.0912 469.547 54.3261C472.948 52.774 476.341 51.2218 479.742 49.6785C475.455 48.4546 470.433 47.3902 464.915 46.5742C462.834 47.4168 460.752 48.2683 458.671 49.1109C453.144 51.3549 447.617 53.5722 442.055 55.7187C436.519 57.8562 430.957 59.9051 425.413 62.0337C425.2 62.1136 424.988 62.2023 424.766 62.2821C429.788 63.7455 435.873 64.9784 442.578 65.8476C443.711 65.3598 444.854 64.872 445.996 64.4019L446.005 64.393Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 419,
    y: 47,
    width: 67,
    height: 17
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M485.224 57.5457C484.932 61.6788 470.034 63.9672 451.957 62.6545C433.88 61.3418 419.461 56.9248 419.753 52.7916C420.045 48.6584 434.943 46.3701 453.02 47.6828C471.097 48.9955 485.517 53.4125 485.224 57.5457Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13830_12464)"
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M485.224 57.5457C484.932 61.6788 470.034 63.9672 451.957 62.6545C433.88 61.3418 419.461 56.9248 419.753 52.7916C420.045 48.6584 434.943 46.3701 453.02 47.6828C471.097 48.9955 485.517 53.4125 485.224 57.5457Z",
    fill: "url(#paint22_linear_13830_12464)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M485.605 60.7835C485.313 64.9166 470.415 67.205 452.338 65.8923C434.261 64.5796 419.842 60.1626 420.134 56.0294C420.426 51.8962 435.324 49.6079 453.401 50.9206C471.478 52.2333 485.897 56.6503 485.605 60.7835Z",
    fill: "url(#paint23_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M427.175 60.9696L462.107 47.896L477.705 50.8673L446.005 64.748L427.175 60.9696Z",
    fill: "#EDE7DE"
  })))), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M492.956 61.7144C491.672 62.9029 490.051 63.6568 488.439 64.3132L487.217 64.7832L485.968 65.1735C485.136 65.4573 484.294 65.6524 483.444 65.8742C480.052 66.6902 476.597 67.2046 473.134 67.5328C466.199 68.2069 459.229 68.1625 452.294 67.719C448.831 67.4707 445.368 67.1248 441.922 66.6458C438.486 66.1314 435.049 65.5371 431.666 64.7389C428.273 63.9584 424.917 62.9916 421.648 61.7676C420.019 61.1467 418.416 60.4461 416.866 59.6478C415.324 58.8318 413.81 57.936 412.517 56.7563C415.378 58.7342 418.646 59.9139 421.932 60.9073C425.218 61.9095 428.575 62.6723 431.949 63.3286C438.707 64.6058 445.545 65.4307 452.409 65.9008C459.273 66.3797 466.164 66.5039 473.028 66.1314C476.456 65.9274 479.883 65.617 483.267 65.0227C484.108 64.8631 484.958 64.7389 485.791 64.526L487.049 64.2333L488.28 63.8697C489.901 63.3375 491.548 62.761 492.956 61.7233V61.7144Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 347,
    y: 27,
    width: 86,
    height: 31
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M432.552 41.8557C432.977 35.9309 414.474 29.7489 391.225 28.0637C367.975 26.3785 348.791 29.811 348.366 35.7447C348.268 37.146 347.905 42.2637 347.799 43.6651C347.374 49.5899 365.876 55.772 389.126 57.4572C412.375 59.1424 431.56 55.7099 431.985 49.7762C432.082 48.3748 432.445 43.2571 432.552 41.8557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_13830_12464)"
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M432.552 41.8557C432.977 35.9309 414.474 29.7489 391.225 28.0637C367.975 26.3785 348.791 29.811 348.366 35.7447C348.268 37.146 347.905 42.2637 347.799 43.6651C347.374 49.5899 365.876 55.772 389.126 57.4572C412.375 59.1424 431.56 55.7099 431.985 49.7762C432.082 48.3748 432.445 43.2571 432.552 41.8557Z",
    fill: "url(#paint24_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M348.888 52.4196L348.33 52.3841L349.747 32.4011L350.314 32.4366L348.888 52.4196Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M350.243 52.7297L349.677 52.6942L351.102 32.7024L351.669 32.7467L350.243 52.7297Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M351.616 53.0402L351.049 52.9959L352.475 33.0129L353.042 33.0573L351.616 53.0402Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M353.007 53.342L352.44 53.2977L353.866 33.3147L354.433 33.359L353.007 53.342Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M354.415 53.6433L353.848 53.5989L355.274 33.616L355.841 33.6603L354.415 53.6433Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M355.85 53.9362L355.283 53.8919L356.709 33.9089L357.267 33.9533L355.85 53.9362Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M357.293 54.2287L356.727 54.1844L358.153 34.2014L358.719 34.2369L357.293 54.2287Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M358.755 54.5129L358.197 54.4686L359.614 34.4856L360.181 34.5299L358.755 54.5129Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M360.243 54.7877L359.676 54.7522L361.102 34.7693L361.669 34.8048L360.243 54.7877Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M361.749 55.0627L361.182 55.0272L362.608 35.0354L363.166 35.0797L361.749 55.0627Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M363.263 55.3376L362.696 55.2933L364.122 35.3103L364.689 35.3458L363.263 55.3376Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M364.804 55.5949L364.237 55.5506L365.663 35.5676L366.23 35.612L364.804 55.5949Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M366.363 55.8518L365.796 55.8074L367.222 35.8245L367.789 35.8688L366.363 55.8518Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M367.931 56.1008L367.373 56.0564L368.79 36.0735L369.357 36.1178L367.931 56.1008Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M369.525 56.3396L368.958 56.3041L370.384 36.3123L370.951 36.3566L369.525 56.3396Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M371.137 56.5793L370.57 56.535L371.996 36.552L372.563 36.5875L371.137 56.5793Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M372.767 56.801L372.2 56.7566L373.626 36.7737L374.184 36.818L372.767 56.801Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M374.405 57.0227L373.838 56.9783L375.264 36.9954L375.831 37.0308L374.405 57.0227Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M376.07 57.2273L375.503 57.1918L376.929 37.2L377.496 37.2443L376.07 57.2273Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M377.744 57.4309L377.177 57.3865L378.603 37.4036L379.17 37.4479L377.744 57.4309Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M379.445 57.6262L378.878 57.5818L380.304 37.5989L380.871 37.6344L379.445 57.6262Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M381.154 57.8034L380.587 57.7591L382.013 37.7761L382.58 37.8205L381.154 57.8034Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M382.881 57.9718L382.314 57.9363L383.74 37.9534L384.307 37.9888L382.881 57.9718Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M384.626 58.1403L384.059 58.096L385.485 38.113L386.052 38.1574L384.626 58.1403Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M386.389 58.2912L385.822 58.2469L387.248 38.2639L387.815 38.3083L386.389 58.2912Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M388.169 58.4328L387.602 58.3885L389.028 38.4055L389.595 38.4499L388.169 58.4328Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M389.958 58.5572L389.391 58.5218L390.817 38.5388L391.384 38.5743L389.958 58.5572Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M391.73 58.673L391.163 58.6375L392.589 38.6545L393.156 38.69L391.73 58.673Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M393.492 58.779L392.925 58.7435L394.351 38.7517L394.918 38.7961L393.492 58.779Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M395.237 58.8673L394.67 58.8318L396.096 38.8489L396.663 38.8844L395.237 58.8673Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M396.973 58.9475L396.406 58.912L397.832 38.9202L398.39 38.9645L396.973 58.9475Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M398.682 59.0183L398.115 58.9739L399.541 38.991L400.108 39.0353L398.682 59.0183Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M400.383 59.0715L399.816 59.0271L401.242 39.0442L401.809 39.0885L400.383 59.0715Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M402.074 59.1159L401.508 59.0716L402.934 39.0886L403.492 39.133L402.074 59.1159Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M403.74 59.1427L403.173 59.1072L404.599 39.1243L405.166 39.1597L403.74 59.1427Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M405.396 59.1692L404.829 59.1248L406.255 39.1418L406.822 39.1862L405.396 59.1692Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M407.035 59.1779L406.468 59.1336L407.894 39.1506L408.461 39.195L407.035 59.1779Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M408.655 59.1779L408.088 59.1336L409.514 39.1506L410.081 39.195L408.655 59.1779Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M410.258 59.1692L409.692 59.1248L411.118 39.1418L411.684 39.1862L410.258 59.1692Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M411.844 59.1516L411.277 59.1072L412.703 39.1243L413.27 39.1686L411.844 59.1516Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M413.42 59.1252L412.854 59.0809L414.28 39.0979L414.846 39.1334L413.42 59.1252Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M414.971 59.0802L414.413 59.0447L415.83 39.0618L416.397 39.0972L414.971 59.0802Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M416.511 59.0363L415.945 59.0009L417.371 39.009L417.937 39.0534L416.511 59.0363Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M418.035 58.9831L417.468 58.9388L418.894 38.9558L419.461 39.0002L418.035 58.9831Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M419.54 58.9206L418.974 58.8763L420.4 38.8933L420.966 38.9377L419.54 58.9206Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M421.02 58.8498L420.462 58.8055L421.879 38.8225L422.446 38.8669L421.02 58.8498Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M422.49 58.7701L421.923 58.7347L423.349 38.7517L423.916 38.7872L422.49 58.7701Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M423.943 58.6901L423.376 58.6458L424.802 38.6628L425.369 38.7072L423.943 58.6901Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M425.377 58.5929L424.811 58.5574L426.237 38.5745L426.803 38.6099L425.377 58.5929Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M426.794 58.4953L426.228 58.4598L427.654 38.468L428.212 38.5124L426.794 58.4953Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M428.185 58.3888L427.618 58.3533L429.044 38.3704L429.611 38.4058L428.185 58.3888Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M429.567 58.2824L429 58.2381L430.426 38.2551L430.993 38.2995L429.567 58.2824Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M383.023 27.6739C376.026 27.5142 369.605 27.8424 364.246 28.5697L362.501 53.0406C367.701 54.5395 374.007 55.7813 380.96 56.6416L383.023 27.6739Z",
    fill: "#EDE7DE"
  }))), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M432.552 41.8558C432.126 47.7806 412.942 51.222 389.692 49.5368C366.443 47.8516 347.949 41.6696 348.366 35.7447C348.791 29.8199 367.975 26.3786 391.225 28.0638C414.474 29.749 432.968 35.931 432.552 41.8558Z",
    fill: "url(#paint25_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M384.042 47.1689C388.001 45.5458 391.986 43.9848 395.919 42.2996C399.825 40.6144 403.713 38.8671 407.584 37.102C410.985 35.5499 414.377 33.9977 417.778 32.4544C413.491 31.2304 408.469 30.1661 402.951 29.3501C400.87 30.1927 398.789 31.0442 396.707 31.8868C391.18 34.1308 385.654 36.3481 380.091 38.4945C374.556 40.6321 368.994 42.6809 363.449 44.8096C363.236 44.8894 363.024 44.9781 362.802 45.058C367.824 46.5214 373.909 47.7543 380.614 48.6146C381.748 48.1268 382.89 47.639 384.033 47.1689H384.042Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 357,
    y: 30,
    width: 67,
    height: 16
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M423.26 40.3128C422.968 44.4459 408.071 46.7343 389.993 45.4216C371.916 44.1089 357.497 39.6919 357.789 35.5587C358.082 31.4255 372.979 29.1372 391.056 30.4499C409.133 31.7626 423.553 36.1796 423.26 40.3128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_13830_12464)"
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M423.26 40.3128C422.968 44.4459 408.071 46.7343 389.993 45.4216C371.916 44.1089 357.497 39.6919 357.789 35.5587C358.082 31.4255 372.979 29.1372 391.056 30.4499C409.133 31.7626 423.553 36.1796 423.26 40.3128Z",
    fill: "url(#paint26_linear_13830_12464)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M423.641 43.5501C423.349 47.6832 408.451 49.9716 390.374 48.6589C372.297 47.3462 357.878 42.9292 358.17 38.796C358.462 34.6628 373.36 32.3745 391.437 33.6872C409.514 34.9999 423.934 39.4169 423.641 43.5501Z",
    fill: "url(#paint27_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M365.203 43.7362L400.144 30.6626L415.741 33.6339L384.042 47.5146L365.203 43.7362Z",
    fill: "#EDE7DE"
  })))), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M430.993 44.4815C429.708 45.67 428.088 46.4239 426.476 47.0802L425.253 47.5503L424.004 47.9406C423.172 48.2244 422.331 48.4195 421.48 48.6413C418.088 49.4573 414.634 49.9717 411.171 50.2999C404.236 50.9739 397.265 50.9296 390.33 50.4861C386.867 50.2378 383.404 49.8919 379.958 49.4129C376.522 48.8985 373.085 48.3042 369.702 47.506C366.31 46.7255 362.953 45.7587 359.685 44.5347C358.055 43.9138 356.452 43.2131 354.902 42.4149C353.361 41.5989 351.846 40.7031 350.562 39.5234C353.423 41.5013 356.691 42.681 359.977 43.6744C363.263 44.6766 366.62 45.4394 369.994 46.0957C376.752 47.3729 383.59 48.1978 390.454 48.6679C397.318 49.1468 404.209 49.271 411.073 48.8985C414.501 48.6945 417.929 48.3841 421.312 47.7898C422.153 47.6301 423.004 47.506 423.836 47.2931L425.094 47.0004L426.325 46.6368C427.946 46.1046 429.593 45.5281 431.002 44.4903L430.993 44.4815Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 19,
    width: 88,
    height: 32
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M370.26 34.1392C370.685 28.2144 351.678 21.9969 327.817 20.2673C303.956 18.5378 284.267 21.9348 283.842 27.8685C283.744 29.2699 283.381 34.3876 283.275 35.7889C282.85 41.7138 301.857 47.9313 325.718 49.6608C349.579 51.3904 369.268 47.9934 369.693 42.0597C369.791 40.6583 370.154 35.5406 370.26 34.1392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_13830_12464)"
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M370.26 34.1392C370.685 28.2144 351.678 21.9969 327.817 20.2673C303.956 18.5378 284.267 21.9348 283.842 27.8685C283.744 29.2699 283.381 34.3876 283.275 35.7889C282.85 41.7138 301.857 47.9313 325.718 49.6608C349.579 51.3904 369.268 47.9934 369.693 42.0597C369.791 40.6583 370.154 35.5406 370.26 34.1392Z",
    fill: "url(#paint28_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4 44.5429L283.824 44.5075L285.241 24.5156L285.826 24.56L284.4 44.5429Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M285.791 44.8623L285.206 44.8179L286.632 24.835L287.217 24.8704L285.791 44.8623Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M287.199 45.164L286.614 45.1285L288.04 25.1367L288.625 25.1811L287.199 45.164Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M288.625 45.4741L288.049 45.4297L289.466 25.4468L290.051 25.4911L288.625 45.4741Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M290.077 45.7758L289.493 45.7315L290.919 25.7485L291.495 25.7929L290.077 45.7758Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M291.539 46.0683L290.963 46.0328L292.38 26.041L292.965 26.0854L291.539 46.0683Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M293.027 46.3613L292.442 46.3258L293.868 26.334L294.453 26.3783L293.027 46.3613Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M294.533 46.6538L293.948 46.6094L295.374 26.6265L295.959 26.6708L294.533 46.6538Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M296.056 46.9379L295.471 46.8936L296.897 26.9106L297.482 26.955L296.056 46.9379Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M297.597 47.2124L297.021 47.168L298.439 27.1851L299.023 27.2294L297.597 47.2124Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M299.156 47.4878L298.58 47.4434L300.006 27.4604L300.582 27.4959L299.156 47.4878Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M300.741 47.7445L300.157 47.709L301.583 27.7261L302.167 27.7616L300.741 47.7445Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M302.336 48.0107L301.76 47.9664L303.177 27.9834L303.762 28.0189L302.336 48.0107Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M303.956 48.2592L303.372 48.2149L304.798 28.2319L305.382 28.2763L303.956 48.2592Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M305.586 48.5078L305.01 48.4634L306.436 28.4805L307.012 28.5159L305.586 48.5078Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M307.242 48.7382L306.658 48.7028L308.084 28.7109L308.668 28.7553L307.242 48.7382Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M308.907 48.9687L308.332 48.9244L309.758 28.9414L310.333 28.9858L308.907 48.9687Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M310.599 49.1904L310.015 49.146L311.441 29.1631L312.025 29.2074L310.599 49.1904Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M312.309 49.4033L311.724 49.3589L313.15 29.376L313.726 29.4203L312.309 49.4033Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M314.027 49.6074L313.451 49.563L314.868 29.5801L315.453 29.6244L314.027 49.6074Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M315.772 49.8027L315.187 49.7583L316.613 29.7754L317.189 29.8197L315.772 49.8027Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M317.525 49.9887L316.949 49.9444L318.367 29.9614L318.951 30.0058L317.525 49.9887Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M319.297 50.166L318.721 50.1216L320.147 30.1387L320.723 30.183L319.297 50.166Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M321.095 50.3261L320.51 50.2907L321.936 30.2988L322.521 30.3432L321.095 50.3261Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M322.901 50.4858L322.317 50.4415L323.743 30.4585L324.327 30.5028L322.901 50.4858Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M324.726 50.6274L324.142 50.5831L325.568 30.6001L326.152 30.6444L324.726 50.6274Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M326.56 50.7602L325.984 50.7159L327.41 30.7329L327.986 30.7773L326.56 50.7602Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M328.384 50.8847L327.8 50.8404L329.226 30.8574L329.81 30.9018L328.384 50.8847Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M330.191 50.9907L329.615 50.9463L331.032 30.9634L331.617 31.0077L330.191 50.9907Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M331.98 51.08L331.404 51.0446L332.83 31.0527L333.406 31.0971L331.98 51.08Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M333.76 51.1684L333.185 51.1241L334.602 31.1411L335.186 31.1766L333.76 51.1684Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M335.523 51.2304L334.938 51.195L336.364 31.2031L336.949 31.2475L335.523 51.2304Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M337.268 51.2924L336.692 51.2481L338.109 31.2651L338.694 31.3095L337.268 51.2924Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M338.995 51.3374L338.419 51.293L339.845 31.3101L340.421 31.3544L338.995 51.3374Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M340.713 51.3725L340.128 51.3282L341.554 31.3452L342.139 31.3896L340.713 51.3725Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M342.414 51.3989L341.829 51.3545L343.255 31.3716L343.831 31.4159L342.414 51.3989Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M344.088 51.417L343.512 51.3726L344.938 31.3896L345.514 31.4251L344.088 51.417Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M345.753 51.417L345.177 51.3726L346.603 31.3896L347.179 31.434L345.753 51.417Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4 51.4082L346.824 51.3638L348.25 31.3809L348.826 31.4252L347.4 51.4082Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M349.03 51.3901L348.454 51.3546L349.88 31.3628L350.456 31.4071L349.03 51.3901Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M350.65 51.3725L350.066 51.3282L351.492 31.3452L352.068 31.3807L350.65 51.3725Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M352.245 51.3374L351.66 51.293L353.086 31.3101L353.671 31.3455L352.245 51.3374Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M353.821 51.2924L353.246 51.2481L354.663 31.2651L355.247 31.3095L353.821 51.2924Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M355.38 51.2397L354.804 51.1954L356.23 31.2124L356.806 31.2567L355.38 51.2397Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M356.93 51.1772L356.346 51.1417L357.772 31.1499L358.347 31.1942L356.93 51.1772Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M358.454 51.1152L357.869 51.0708L359.295 31.0879L359.88 31.1234L358.454 51.1152Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M359.959 51.0351L359.375 50.9908L360.801 31.0078L361.385 31.0522L359.959 51.0351Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M361.447 50.9555L360.872 50.9112L362.289 30.9282L362.873 30.9726L361.447 50.9555Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M362.918 50.8671L362.342 50.8228L363.759 30.8398L364.343 30.8842L362.918 50.8671Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M364.37 50.7695L363.794 50.7251L365.212 30.7422L365.796 30.7865L364.37 50.7695Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M365.805 50.6718L365.22 50.6275L366.646 30.6445L367.231 30.68L365.805 50.6718Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M367.222 50.5566L366.637 50.5211L368.063 30.5293L368.639 30.5736L367.222 50.5566Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M319.385 19.8593C312.202 19.6908 305.613 20.0012 300.113 20.7197L298.368 45.1906C303.7 46.6984 310.183 47.9579 317.322 48.8271L319.385 19.8593Z",
    fill: "#FFFAEF"
  }))), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M370.26 34.1395C369.835 40.0643 350.146 43.4702 326.285 41.7407C302.424 40.0111 283.417 33.7936 283.842 27.8688C284.267 21.944 303.957 18.5381 327.817 20.2676C351.678 21.9972 370.685 28.2147 370.26 34.1395Z",
    fill: "url(#paint29_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M320.466 39.3546C324.522 37.7315 328.614 36.1882 332.644 34.503C336.656 32.8267 340.633 31.0883 344.601 29.3321C348.091 27.7888 351.572 26.2366 355.061 24.7022C350.659 23.4694 345.505 22.3962 339.836 21.5713C337.702 22.4139 335.567 23.2565 333.433 24.0991C327.764 26.3253 322.096 28.5427 316.392 30.6714C310.714 32.7912 305.001 34.8312 299.324 36.951C299.103 37.0308 298.881 37.1195 298.669 37.1993C303.823 38.6717 310.077 39.9134 316.958 40.7915C318.128 40.3036 319.288 39.8247 320.466 39.3546Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 293,
    y: 22,
    width: 68,
    height: 17
  }, _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M360.712 32.5784C360.42 36.7116 345.133 38.9733 326.568 37.6251C308.004 36.277 293.204 31.8334 293.496 27.7002C293.788 23.567 309.076 21.3053 327.64 22.6534C346.204 24.0016 361.004 28.4452 360.712 32.5784Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_13830_12464)"
  }, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M360.712 32.5784C360.42 36.7116 345.133 38.9733 326.568 37.6251C308.004 36.277 293.204 31.8334 293.496 27.7002C293.788 23.567 309.076 21.3053 327.64 22.6534C346.204 24.0016 361.004 28.4452 360.712 32.5784Z",
    fill: "url(#paint30_linear_13830_12464)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M361.111 35.8157C360.819 39.9489 345.531 42.2106 326.967 40.8625C308.403 39.5143 293.603 35.0707 293.895 30.9375C294.187 26.8043 309.474 24.5426 328.039 25.8908C346.603 27.2389 361.403 31.6825 361.111 35.8157Z",
    fill: "url(#paint31_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M301.131 35.8869L336.966 22.8843L352.98 25.8822L320.475 39.7008L301.131 35.8869Z",
    fill: "#FFFAEF"
  })))), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M368.657 36.7558C367.337 37.9443 365.672 38.6893 364.025 39.3457L362.767 39.8069L361.491 40.1972C360.641 40.481 359.773 40.6672 358.905 40.8979C355.424 41.7138 351.882 42.2105 348.321 42.5387C341.209 43.2039 334.044 43.1418 326.923 42.6895C323.362 42.4323 319.81 42.0775 316.276 41.5897C312.742 41.0664 309.217 40.4721 305.745 39.665C302.265 38.8756 298.819 37.9088 295.462 36.676C293.788 36.0551 292.141 35.3455 290.547 34.5473C288.961 33.7313 287.402 32.8266 286.083 31.647C289.023 33.6337 292.38 34.8222 295.755 35.8156C299.129 36.8268 302.583 37.5895 306.046 38.2547C312.982 39.5497 320.005 40.3834 327.055 40.8712C334.097 41.3591 341.173 41.501 348.215 41.1373C351.731 40.9422 355.256 40.6406 358.719 40.0464C359.587 39.8867 360.455 39.7626 361.314 39.5497L362.599 39.257L363.865 38.8933C365.53 38.3612 367.222 37.7935 368.657 36.7558Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 495,
    y: 50,
    width: 85,
    height: 30
  }, _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M579.738 59.9939C579.596 54.0513 560.589 49.7052 537.286 50.2906C513.983 50.876 495.215 56.1622 495.366 62.1048C495.401 63.5062 495.525 68.6416 495.56 70.043C495.702 75.9855 514.709 80.3316 538.012 79.7462C561.315 79.1608 580.083 73.8746 579.933 67.932C579.897 66.5307 579.773 61.3952 579.738 59.9939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_13830_12464)"
  }, _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M579.738 59.9939C579.596 54.0513 560.589 49.7052 537.286 50.2906C513.983 50.876 495.215 56.1622 495.366 62.1048C495.401 63.5062 495.525 68.6416 495.56 70.043C495.702 75.9855 514.709 80.3316 538.012 79.7462C561.315 79.1608 580.083 73.8746 579.933 67.932C579.897 66.5307 579.773 61.3952 579.738 59.9939Z",
    fill: "url(#paint32_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M496.971 58.6495L496.404 58.6636L496.901 78.6936L497.468 78.6795L496.971 58.6495Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M498.348 58.8282L497.781 58.8423L498.277 78.8723L498.844 78.8582L498.348 58.8282Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M499.742 58.9972L499.176 59.0112L499.671 79.0413L500.238 79.0272L499.742 58.9972Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M501.154 59.1666L500.588 59.1807L501.083 79.2107L501.65 79.1966L501.154 59.1666Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M502.586 59.3086L502.019 59.3228L502.518 79.3527L503.085 79.3385L502.586 59.3086Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M504.042 59.4673L503.475 59.4814L503.974 79.5114L504.541 79.4972L504.042 59.4673Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M505.513 59.6256L504.947 59.6396L505.442 79.6697L506.009 79.6556L505.513 59.6256Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M506.995 59.7667L506.428 59.7808L506.924 79.8108L507.491 79.7967L506.995 59.7667Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M508.497 59.8882L507.93 59.9023L508.43 79.9323L508.996 79.9181L508.497 59.8882Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M510.023 60.0098L509.457 60.0239L509.956 80.0539L510.522 80.0397L510.023 60.0098Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M511.565 60.1495L510.998 60.1636L511.494 80.1936L512.061 80.1795L511.565 60.1495Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M513.11 60.2432L512.543 60.2573L513.043 80.2873L513.609 80.2731L513.11 60.2432Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M514.689 60.354L514.122 60.3682L514.621 80.3981L515.188 80.3839L514.689 60.354Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M516.285 60.4385L515.718 60.4526L516.217 80.4826L516.784 80.4684L516.285 60.4385Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M517.881 60.5317L517.314 60.5459L517.813 80.5758L518.38 80.5617L517.881 60.5317Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M519.519 60.6173L518.952 60.6313L519.448 80.6614L520.014 80.6473L519.519 60.6173Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M521.151 60.6714L520.585 60.6855L521.084 80.7155L521.651 80.7013L521.151 60.6714Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M522.807 60.7394L522.24 60.7534L522.736 80.7834L523.302 80.7694L522.807 60.7394Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M524.483 60.7744L523.917 60.7886L524.416 80.8185L524.983 80.8043L524.483 60.7744Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M526.175 60.812L525.609 60.8262L526.108 80.8561L526.675 80.8419L526.175 60.812Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M527.874 60.8443L527.307 60.8584L527.803 80.8884L528.37 80.8743L527.874 60.8443Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M529.601 60.8551L529.034 60.8691L529.53 80.8992L530.096 80.8851L529.601 60.8551Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M531.339 60.8603L530.772 60.8745L531.271 80.9044L531.838 80.8903L531.339 60.8603Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M533.089 60.8565L532.523 60.8706L533.019 80.9006L533.585 80.8866L533.089 60.8565Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M534.86 60.8399L534.293 60.854L534.789 80.884L535.355 80.87L534.86 60.8399Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M536.647 60.8038L536.081 60.8179L536.576 80.8479L537.143 80.8338L536.647 60.8038Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M538.435 60.7594L537.868 60.7734L538.364 80.8035L538.931 80.7894L538.435 60.7594Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M540.215 60.6919L539.649 60.7061L540.148 80.736L540.715 80.7218L540.215 60.6919Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M541.976 60.6299L541.409 60.644L541.908 80.674L542.475 80.6598L541.976 60.6299Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M543.725 60.5577L543.158 60.5718L543.654 80.6018L544.221 80.5877L543.725 60.5577Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M545.449 60.4703L544.883 60.4844L545.378 80.5144L545.945 80.5003L545.449 60.4703Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M547.166 60.3496L546.6 60.3638L547.099 80.3937L547.666 80.3795L547.166 60.3496Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M548.855 60.2451L548.288 60.2593L548.787 80.2892L549.354 80.275L548.855 60.2451Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M550.543 60.1235L549.976 60.1377L550.476 80.1676L551.042 80.1535L550.543 60.1235Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M552.202 60.0011L551.635 60.0151L552.131 80.0452L552.698 80.0311L552.202 60.0011Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M553.857 59.8545L553.29 59.8687L553.789 79.8986L554.356 79.8844L553.857 59.8545Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M555.48 59.7159L554.913 59.73L555.409 79.76L555.976 79.7459L555.48 59.7159Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M557.107 59.5425L556.541 59.5566L557.04 79.5866L557.607 79.5724L557.107 59.5425Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M558.697 59.3789L558.13 59.3931L558.629 79.423L559.196 79.4088L558.697 59.3789Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M560.276 59.2159L559.709 59.23L560.205 79.26L560.771 79.2459L560.276 59.2159Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M561.84 59.0254L561.273 59.0396L561.773 79.0695L562.339 79.0553L561.84 59.0254Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M563.385 58.8359L562.818 58.8501L563.318 78.88L563.884 78.8659L563.385 58.8359Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M564.91 58.6485L564.344 58.6626L564.839 78.6926L565.406 78.6786L564.91 58.6485Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M566.419 58.4425L565.853 58.4565L566.348 78.4866L566.915 78.4725L566.419 58.4425Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M567.911 58.2462L567.344 58.2603L567.84 78.2903L568.407 78.2762L567.911 58.2462Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M569.377 58.0215L568.81 58.0356L569.309 78.0656L569.876 78.0514L569.377 58.0215Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M570.841 57.7983L570.274 57.8125L570.774 77.8424L571.34 77.8283L570.841 57.7983Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M572.277 57.5792L571.71 57.5933L572.206 77.6233L572.773 77.6092L572.277 57.5792Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M573.689 57.3374L573.123 57.3516L573.622 77.3815L574.189 77.3673L573.689 57.3374Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M575.091 57.1074L574.525 57.1216L575.024 77.1515L575.591 77.1373L575.091 57.1074Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M576.465 56.8814L575.899 56.8955L576.395 76.9255L576.961 76.9115L576.465 56.8814Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M577.832 56.6261L577.265 56.6401L577.761 76.6702L578.328 76.6561L577.832 56.6261Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M529.084 50.6987C522.105 51.222 515.737 52.1711 510.485 53.4217L511.087 77.9458C516.401 78.9303 522.796 79.5601 529.802 79.7374L529.093 50.7076L529.084 50.6987Z",
    fill: "#FFFAEF"
  }))), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M537.82 71.797C561.116 71.2157 579.881 65.9291 579.733 59.9891C579.584 54.0491 560.579 49.705 537.282 50.2863C513.986 50.8676 495.221 56.1542 495.369 62.0942C495.518 68.0342 514.523 72.3783 537.82 71.797Z",
    fill: "url(#paint33_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M531.954 69.9989C535.736 67.9944 539.553 66.0608 543.309 63.9942C547.037 61.9365 550.731 59.8256 554.424 57.688C557.657 55.8166 560.89 53.9362 564.131 52.0648C559.747 51.2576 554.645 50.69 549.074 50.415C547.082 51.4616 545.098 52.4994 543.105 53.546C537.817 56.3133 532.529 59.0628 527.198 61.7414C521.892 64.4022 516.551 66.9832 511.237 69.6441C511.033 69.7505 510.83 69.8481 510.617 69.9545C515.754 70.9213 521.928 71.551 528.686 71.7639C529.775 71.1696 530.856 70.5754 531.954 69.99V69.9989Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 504,
    y: 52,
    width: 67,
    height: 16
  }, _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M570.34 59.3554C570.438 63.4975 555.832 67.2227 537.711 67.675C519.589 68.1273 504.816 65.1383 504.719 60.9874C504.621 56.8454 519.226 53.1202 537.348 52.6678C555.469 52.2155 570.243 55.2045 570.34 59.3554Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_13830_12464)"
  }, _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M570.34 59.3552C570.438 63.4972 555.832 67.2224 537.711 67.6748C519.589 68.1271 504.816 65.1381 504.719 60.9872C504.621 56.8451 519.226 53.1199 537.348 52.6676C555.469 52.2152 570.243 55.2043 570.34 59.3552Z",
    fill: "url(#paint34_linear_13830_12464)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M538.406 70.8648C556.529 70.4118 571.136 66.6861 571.033 62.5433C570.93 58.4004 556.155 55.4093 538.032 55.8623C519.91 56.3154 505.302 60.041 505.405 64.1839C505.509 68.3267 520.284 71.3179 538.406 70.8648Z",
    fill: "url(#paint35_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M512.876 68.4199L546.408 52.0024L562.209 53.4393L531.989 70.3445L512.876 68.4199Z",
    fill: "#FFFAEF"
  })))), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M578.436 62.7525C577.266 64.0652 575.725 64.9699 574.184 65.777L573.006 66.3624L571.802 66.8768C571.005 67.2405 570.181 67.5154 569.357 67.8259C566.062 68.97 562.67 69.8126 559.251 70.4778C552.414 71.826 545.47 72.4646 538.517 72.6952C535.045 72.7839 531.564 72.775 528.092 72.6331C524.62 72.4557 521.148 72.1985 517.694 71.7284C514.24 71.2761 510.812 70.6464 507.438 69.7505C505.755 69.2893 504.099 68.7483 502.469 68.1097C500.857 67.4534 499.263 66.6994 497.872 65.6528C500.91 67.3469 504.276 68.1984 507.641 68.8636C511.007 69.5466 514.426 69.9723 517.845 70.2916C524.691 70.9125 531.582 71.0632 538.455 70.8592C545.328 70.6641 552.201 70.1231 558.994 69.0765C562.387 68.5443 565.77 67.8968 569.083 66.9744C569.906 66.7349 570.739 66.5221 571.545 66.2294L572.767 65.8125L573.963 65.3335C575.522 64.6417 577.116 63.9144 578.409 62.7437L578.436 62.7525Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 441,
    y: 33,
    width: 86,
    height: 31
  }, _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M526.037 47.6743C526.463 41.7495 507.96 35.5675 484.711 33.8823C461.461 32.1971 442.277 35.6296 441.851 41.5633C441.754 42.9646 441.391 48.0823 441.285 49.4837C440.859 55.4085 459.362 61.5906 482.611 63.2758C505.861 64.961 525.045 61.5285 525.471 55.5948C525.568 54.1934 525.931 49.0757 526.037 47.6743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_13830_12464)"
  }, _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M526.037 47.6743C526.463 41.7495 507.96 35.5675 484.711 33.8823C461.461 32.1971 442.277 35.6296 441.851 41.5633C441.754 42.9646 441.391 48.0823 441.285 49.4837C440.859 55.4085 459.362 61.5906 482.611 63.2758C505.861 64.961 525.045 61.5285 525.471 55.5948C525.568 54.1934 525.931 49.0757 526.037 47.6743Z",
    fill: "url(#paint36_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M442.374 58.2378L441.807 58.2023L443.233 38.2104L443.8 38.2548L442.374 58.2378Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M443.729 58.5478L443.162 58.5123L444.588 38.5205L445.146 38.5649L443.729 58.5478Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M445.093 58.8584L444.535 58.814L445.952 38.8311L446.519 38.8754L445.093 58.8584Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M446.484 59.1596L445.926 59.1153L447.343 39.1323L447.91 39.1767L446.484 59.1596Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M447.901 59.4614L447.334 59.417L448.76 39.4341L449.327 39.4696L447.901 59.4614Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M449.327 59.7544L448.76 59.71L450.186 39.7271L450.753 39.7714L449.327 59.7544Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M450.77 60.0468L450.204 60.0025L451.63 40.0195L452.196 40.055L450.77 60.0468Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M452.241 60.3305L451.674 60.2862L453.1 40.3032L453.667 40.3476L452.241 60.3305Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M453.72 60.6059L453.153 60.5704L454.579 40.5786L455.146 40.623L453.72 60.6059Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M455.226 60.8808L454.659 60.8453L456.085 40.8535L456.652 40.8979L455.226 60.8808Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M456.749 61.1469L456.182 61.1114L457.608 41.1284L458.175 41.1639L456.749 61.1469Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M458.281 61.4126L457.714 61.3682L459.14 41.3853L459.707 41.4296L458.281 61.4126Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M459.84 61.6699L459.273 61.6255L460.699 41.6426L461.266 41.6869L459.84 61.6699Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M461.416 61.9184L460.85 61.8741L462.276 41.8911L462.842 41.9355L461.416 61.9184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M463.011 62.1582L462.444 62.1138L463.87 42.1309L464.428 42.1752L463.011 62.1582Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M464.614 62.3969L464.047 62.3526L465.473 42.3696L466.04 42.4051L464.614 62.3969Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M466.244 62.6191L465.677 62.5748L467.103 42.5918L467.67 42.6361L466.244 62.6191Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M467.891 62.8408L467.324 62.7964L468.75 42.8135L469.308 42.849L467.891 62.8408Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M469.547 63.0449L468.98 63.0094L470.406 43.0176L470.973 43.0619L469.547 63.0449Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M471.23 63.249L470.663 63.2046L472.089 43.2217L472.656 43.266L471.23 63.249Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M472.922 63.4349L472.355 63.3995L473.781 43.4165L474.348 43.452L472.922 63.4349Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M474.631 63.621L474.064 63.5767L475.49 43.5938L476.057 43.6381L474.631 63.621Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M476.367 63.7899L475.8 63.7544L477.226 43.7715L477.784 43.807L476.367 63.7899Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M478.112 63.9585L477.545 63.9141L478.971 43.9312L479.529 43.9666L478.112 63.9585Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M479.866 64.1088L479.308 64.0645L480.725 44.0815L481.292 44.1259L479.866 64.1088Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M481.646 64.2509L481.079 64.2066L482.505 44.2236L483.072 44.2591L481.646 64.2509Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M483.435 64.375L482.868 64.3395L484.294 44.3477L484.861 44.392L483.435 64.375Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M485.216 64.4906L484.649 64.4551L486.075 44.4722L486.633 44.5076L485.216 64.4906Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M486.969 64.5971L486.402 64.5528L487.828 44.5698L488.395 44.6142L486.969 64.5971Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M488.714 64.6855L488.156 64.65L489.573 44.6582L490.14 44.7026L488.714 64.6855Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M490.45 64.7651L489.883 64.7296L491.309 44.7378L491.876 44.7821L490.45 64.7651Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M492.168 64.8364L491.601 64.792L493.027 44.8091L493.594 44.8446L492.168 64.8364Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M493.869 64.8896L493.302 64.8453L494.728 44.8623L495.295 44.9066L493.869 64.8896Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M495.551 64.934L494.985 64.8897L496.411 44.9067L496.977 44.9422L495.551 64.934Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M497.217 64.9604L496.659 64.9249L498.076 44.9331L498.643 44.9775L497.217 64.9604Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M498.873 64.9873L498.306 64.9429L499.732 44.96L500.299 44.9954L498.873 64.9873Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M500.512 64.9961L499.945 64.9517L501.371 44.9688L501.938 45.0131L500.512 64.9961Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M502.132 64.9961L501.566 64.9517L502.992 44.9688L503.559 45.0131L502.132 64.9961Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M503.736 64.9873L503.169 64.9429L504.595 44.96L505.162 45.0043L503.736 64.9873Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M505.33 64.9697L504.763 64.9253L506.189 44.9424L506.756 44.9867L505.33 64.9697Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M506.898 64.9428L506.331 64.8985L507.757 44.9155L508.324 44.951L506.898 64.9428Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M508.457 64.8983L507.89 64.8628L509.316 44.8799L509.882 44.9154L508.457 64.8983Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M509.997 64.8545L509.431 64.819L510.857 44.8271L511.415 44.8715L509.997 64.8545Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M511.512 64.8012L510.945 64.7569L512.371 44.7739L512.938 44.8183L511.512 64.8012Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M513.018 64.7392L512.451 64.6949L513.877 44.7119L514.444 44.7563L513.018 64.7392Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M514.506 64.6679L513.939 64.6236L515.365 44.6406L515.932 44.685L514.506 64.6679Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M515.976 64.5879L515.409 64.5524L516.835 44.5605L517.402 44.6049L515.976 64.5879Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M517.42 64.5083L516.862 64.4639L518.279 44.481L518.846 44.5164L517.42 64.5083Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M518.854 64.4111L518.288 64.3756L519.714 44.3838L520.28 44.4281L518.854 64.4111Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M520.271 64.3134L519.705 64.278L521.131 44.2861L521.697 44.3305L520.271 64.3134Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M521.671 64.2069L521.104 64.1714L522.53 44.1885L523.088 44.224L521.671 64.2069Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M523.044 64.1005L522.477 64.0562L523.903 44.0732L524.47 44.1176L523.044 64.1005Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M476.509 33.4916C469.512 33.3408 463.09 33.6601 457.732 34.3874L455.987 58.8584C461.186 60.3573 467.492 61.599 474.445 62.4594L476.509 33.4916Z",
    fill: "#FFFAEF"
  }))), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M526.015 47.651C526.445 41.7248 507.948 35.5538 484.7 33.8677C461.453 32.1817 442.258 35.619 441.828 41.5453C441.398 47.4715 459.895 53.6425 483.142 55.3285C506.39 57.0146 525.585 53.5772 526.015 47.651Z",
    fill: "url(#paint37_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M477.519 52.9785C481.478 51.3554 485.463 49.7943 489.396 48.1091C493.302 46.4239 497.19 44.6766 501.061 42.9116C504.462 41.3594 507.854 39.8073 511.255 38.264C506.968 37.04 501.946 35.9757 496.428 35.1597C494.347 36.0023 492.266 36.8537 490.184 37.6963C484.657 39.9403 479.131 42.1577 473.568 44.3041C468.033 46.4417 462.471 48.4905 456.926 50.6192C456.714 50.699 456.501 50.7877 456.28 50.8675C461.301 52.331 467.386 53.5639 474.091 54.4331C475.225 53.9452 476.367 53.4574 477.51 52.9873L477.519 52.9785Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 451,
    y: 35,
    width: 66,
    height: 17
  }, _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M516.746 46.1311C516.454 50.2643 501.557 52.5526 483.479 51.2399C465.402 49.9273 450.983 45.5103 451.275 41.3771C451.568 37.2439 466.465 34.9556 484.542 36.2682C502.62 37.5809 517.039 41.9979 516.746 46.1311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_13830_12464)"
  }, _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M516.746 46.1311C516.454 50.2643 501.557 52.5526 483.479 51.2399C465.402 49.9273 450.983 45.5103 451.275 41.3771C451.568 37.2439 466.465 34.9556 484.542 36.2682C502.62 37.5809 517.039 41.9979 516.746 46.1311Z",
    fill: "url(#paint38_linear_13830_12464)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M517.119 49.3684C516.826 53.5016 501.929 55.7899 483.852 54.4772C465.774 53.1646 451.355 48.7476 451.647 44.6144C451.94 40.4812 466.837 38.1929 484.914 39.5056C502.992 40.8182 517.411 45.2352 517.119 49.3684Z",
    fill: "url(#paint39_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M458.689 49.5546L493.621 36.481L509.218 39.4522L477.528 53.333L458.689 49.5546Z",
    fill: "#FFFAEF"
  })))), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M524.479 50.2998C523.194 51.4883 521.573 52.2423 519.961 52.8986L518.739 53.3687L517.49 53.7589C516.658 54.0428 515.816 54.2379 514.966 54.4596C511.574 55.2756 508.12 55.79 504.657 56.1182C497.721 56.7923 490.751 56.748 483.816 56.3045C480.353 56.0561 476.89 55.7102 473.444 55.2313C470.008 54.7168 466.571 54.1226 463.188 53.3243C459.796 52.5438 456.439 51.577 453.171 50.3531C451.541 49.7322 449.938 49.0315 448.388 48.2332C446.847 47.4173 445.332 46.5214 444.048 45.3418C446.909 47.3197 450.177 48.4993 453.463 49.4927C456.749 50.495 460.106 51.2577 463.48 51.9141C470.238 53.1913 477.076 54.0162 483.94 54.4862C490.804 54.9652 497.695 55.0894 504.559 54.7168C507.987 54.5128 511.414 54.2024 514.798 53.6082C515.639 53.4485 516.489 53.3243 517.322 53.1115L518.58 52.8188L519.811 52.4551C521.432 51.923 523.079 51.3464 524.487 50.3087L524.479 50.2998Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 16,
    width: 86,
    height: 31
  }, _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M474.658 25.8288C474.374 19.8951 455.278 15.9925 431.993 17.119C408.717 18.2454 390.073 23.9662 390.356 29.9088C390.418 31.3101 390.666 36.4367 390.728 37.8381C391.012 43.7718 410.108 47.6743 433.393 46.5479C456.669 45.4215 475.313 39.7007 475.03 33.7581C474.959 32.3567 474.72 27.2302 474.658 25.8288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_13830_12464)"
  }, _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M474.658 25.8288C474.374 19.8951 455.278 15.9925 431.993 17.119C408.717 18.2454 390.073 23.9662 390.356 29.9088C390.418 31.3101 390.666 36.4367 390.728 37.8381C391.012 43.7718 410.108 47.6743 433.393 46.5479C456.669 45.4215 475.313 39.7007 475.03 33.7581C474.959 32.3567 474.72 27.2302 474.658 25.8288Z",
    fill: "url(#paint40_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M391.887 26.3763L391.321 26.4036L392.286 46.4164L392.852 46.3891L391.887 26.3763Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M393.269 26.5063L392.703 26.5337L393.67 46.5465L394.236 46.519L393.269 26.5063Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M394.665 26.6513L394.099 26.6787L395.066 46.6915L395.632 46.664L394.665 26.6513Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M396.087 26.7777L395.521 26.8052L396.487 46.8179L397.054 46.7905L396.087 26.7777Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M397.517 26.9032L396.951 26.9307L397.918 46.9434L398.484 46.916L397.517 26.9032Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M398.974 27.0277L398.408 27.0552L399.375 47.0679L399.941 47.0405L398.974 27.0277Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M400.439 27.1342L399.873 27.1616L400.839 47.1744L401.406 47.147L400.439 27.1342Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M401.935 27.2476L401.369 27.2749L402.332 47.2878L402.898 47.2605L401.935 27.2476Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M403.439 27.3525L402.873 27.3799L403.84 47.3926L404.406 47.3652L403.439 27.3525Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M404.956 27.4384L404.39 27.4658L405.357 47.4786L405.923 47.4512L404.956 27.4384Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M406.504 27.5234L405.938 27.5508L406.901 47.5637L407.468 47.5364L406.504 27.5234Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M408.06 27.5985L407.494 27.626L408.461 47.6387L409.027 47.6113L408.06 27.5985Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M409.638 27.6552L409.072 27.6826L410.039 47.6954L410.605 47.668L409.638 27.6552Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M411.234 27.7201L410.667 27.7476L411.634 47.7603L412.201 47.7329L411.234 27.7201Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M412.846 27.766L412.28 27.7935L413.246 47.8062L413.813 47.7788L412.846 27.766Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M414.466 27.8031L413.9 27.8306L414.867 47.8433L415.433 47.8159L414.466 27.8031Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M416.114 27.8388L415.548 27.8662L416.515 47.879L417.081 47.8515L416.114 27.8388Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M417.765 27.8584L417.198 27.8857L418.162 47.8987L418.728 47.8713L417.765 27.8584Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M419.441 27.8637L418.875 27.8911L419.842 47.9039L420.408 47.8764L419.441 27.8637Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M421.13 27.8524L420.564 27.8799L421.531 47.8926L422.097 47.8652L421.13 27.8524Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M422.829 27.8412L422.262 27.8687L423.229 47.8814L423.796 47.854L422.829 27.8412Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M424.557 27.8237L423.991 27.8511L424.954 47.864L425.521 47.8367L424.557 27.8237Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M426.298 27.7842L425.732 27.8115L426.696 47.8245L427.262 47.7971L426.298 27.7842Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M428.043 27.7314L427.477 27.7588L428.443 47.7716L429.01 47.7441L428.043 27.7314Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M429.809 27.6635L429.243 27.6909L430.21 47.7037L430.776 47.6763L429.809 27.6635Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M431.597 27.6001L431.031 27.6274L431.995 47.6404L432.561 47.613L431.597 27.6001Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M433.38 27.5137L432.814 27.541L433.777 47.5539L434.344 47.5266L433.38 27.5137Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M435.157 27.4047L434.591 27.4321L435.558 47.4449L436.124 47.4175L435.157 27.4047Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M436.921 27.2929L436.355 27.3203L437.322 47.3331L437.888 47.3056L436.921 27.2929Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M438.667 27.1825L438.101 27.21L439.068 47.2227L439.634 47.1953L438.667 27.1825Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M440.395 27.0458L439.829 27.0732L440.796 47.086L441.362 47.0586L440.395 27.0458Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M442.105 26.9008L441.538 26.9282L442.505 46.941L443.071 46.9136L442.105 26.9008Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M443.796 26.7572L443.229 26.7847L444.196 46.7974L444.763 46.77L443.796 26.7572Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M445.483 26.5942L444.917 26.6216L445.88 46.6345L446.446 46.6072L445.483 26.5942Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M447.138 26.4351L446.572 26.4624L447.535 46.4753L448.101 46.448L447.138 26.4351Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M448.787 26.2499L448.221 26.2773L449.188 46.2901L449.754 46.2627L448.787 26.2499Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M450.415 26.0561L449.849 26.0835L450.816 46.0963L451.382 46.0688L450.415 26.0561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M452.016 25.8637L451.45 25.8911L452.417 45.9039L452.983 45.8764L452.016 25.8637Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M453.613 25.6709L453.046 25.6982L454.01 45.7112L454.576 45.6838L453.613 25.6709Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M455.189 25.4442L454.623 25.4717L455.59 45.4844L456.156 45.457L455.189 25.4442Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M456.745 25.2274L456.179 25.2549L457.146 45.2677L457.712 45.2402L456.745 25.2274Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M458.283 25.0116L457.716 25.0391L458.683 45.0518L459.249 45.0244L458.283 25.0116Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M459.808 24.7881L459.241 24.8154L460.205 44.8284L460.771 44.801L459.808 24.7881Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M461.303 24.5463L460.737 24.5737L461.704 44.5865L462.27 44.5591L461.303 24.5463Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M462.795 24.2885L462.229 24.3159L463.196 44.3287L463.762 44.3012L462.795 24.2885Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M464.261 24.0487L463.694 24.0762L464.661 44.0889L465.227 44.0615L464.261 24.0487Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M465.708 23.7934L465.142 23.8208L466.109 43.8336L466.675 43.8061L465.708 23.7934Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M467.146 23.5287L466.58 23.5562L467.547 43.5689L468.113 43.5415L467.146 23.5287Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M468.549 23.2748L467.983 23.3022L468.95 43.315L469.516 43.2876L468.549 23.2748Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M469.951 22.9945L469.385 23.022L470.352 43.0347L470.918 43.0073L469.951 22.9945Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M471.327 22.7333L470.761 22.7607L471.728 42.7735L472.294 42.7461L471.327 22.7333Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M472.677 22.455L472.111 22.4824L473.078 42.4952L473.644 42.4677L472.677 22.455Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M423.8 17.7223C416.83 18.4141 410.497 19.505 405.263 20.8709L406.423 45.3773C411.755 46.2377 418.167 46.7166 425.173 46.7255L423.8 17.7134V17.7223Z",
    fill: "#FFFAEF"
  }))), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M433.028 38.5896C456.305 37.4639 474.941 31.7402 474.654 25.8053C474.366 19.8704 455.264 15.9718 431.988 17.0975C408.711 18.2232 390.075 23.9469 390.362 29.8818C390.649 35.8167 409.752 39.7153 433.028 38.5896Z",
    fill: "url(#paint41_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M427.122 36.9511C430.859 34.8579 434.632 32.8357 438.335 30.6804C442.019 28.5429 445.66 26.3344 449.3 24.117C452.488 22.1657 455.677 20.2144 458.874 18.272C454.472 17.5713 449.362 17.119 443.782 16.9771C441.816 18.068 439.849 19.1589 437.883 20.2499C432.666 23.1413 427.432 26.0151 422.171 28.8089C416.927 31.594 411.64 34.2992 406.396 37.0842C406.193 37.1906 405.989 37.3059 405.785 37.4124C410.94 38.2638 417.131 38.7428 423.898 38.8049C424.969 38.184 426.041 37.5631 427.122 36.96V36.9511Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 399,
    y: 19,
    width: 67,
    height: 16
  }, _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M465.251 25.4208C465.446 29.5629 450.93 33.6251 432.826 34.5032C414.722 35.3813 399.887 32.7293 399.683 28.5872C399.488 24.4452 414.005 20.383 432.108 19.5049C450.212 18.6268 465.048 21.2788 465.251 25.4208Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_13830_12464)"
  }, _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M465.251 25.4206C465.446 29.5626 450.93 33.6249 432.826 34.5029C414.722 35.381 399.887 32.729 399.683 28.587C399.488 24.4449 414.005 20.3827 432.108 19.5046C450.212 18.6266 465.048 21.2785 465.251 25.4206Z",
    fill: "url(#paint42_linear_13830_12464)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M466.004 28.5956C466.199 32.7377 451.683 36.7999 433.579 37.678C415.475 38.5561 400.639 35.9041 400.436 31.762C400.241 27.62 414.758 23.5578 432.861 22.6797C450.965 21.8016 465.801 24.4536 466.004 28.5956Z",
    fill: "url(#paint43_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M408.017 35.8155L441.151 18.6265L456.988 19.6908L427.166 37.2967L408.017 35.8155Z",
    fill: "#FFFAEF"
  })))), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M473.418 28.6231C472.284 29.9624 470.761 30.9026 469.237 31.7452L468.077 32.3572L466.881 32.8982C466.093 33.2796 465.269 33.5723 464.463 33.9005C461.195 35.1245 457.821 36.0469 454.419 36.7919C447.617 38.2997 440.682 39.098 433.747 39.4883C430.275 39.6568 426.794 39.7277 423.322 39.6656C419.85 39.5681 416.37 39.3996 412.907 39.0093C409.443 38.6368 405.998 38.0957 402.615 37.2709C400.923 36.854 399.249 36.3485 397.61 35.7453C395.981 35.1245 394.369 34.4149 392.952 33.3949C396.025 35.018 399.408 35.7985 402.792 36.3839C406.175 36.9871 409.603 37.333 413.031 37.5813C419.895 38.0425 426.786 38.0337 433.65 37.67C440.523 37.3152 447.378 36.6145 454.145 35.4083C457.528 34.7963 460.894 34.069 464.18 33.0667C464.995 32.8095 465.827 32.5789 466.633 32.2685L467.847 31.825L469.025 31.3106C470.575 30.5833 472.142 29.8205 473.409 28.6143L473.418 28.6231Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 3,
    width: 86,
    height: 31
  }, _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M420.479 17.2339C420.904 11.3091 402.402 5.12706 379.152 3.44186C355.902 1.75665 336.718 5.18915 336.293 11.1228C336.196 12.5242 335.832 17.6419 335.726 19.0433C335.301 24.9681 353.803 31.1501 377.053 32.8353C400.303 34.5205 419.487 31.0881 419.912 25.1544C420.01 23.753 420.373 18.6353 420.479 17.2339Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_13830_12464)"
  }, _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M420.479 17.2339C420.904 11.3091 402.402 5.12706 379.152 3.44186C355.902 1.75665 336.718 5.18915 336.293 11.1228C336.196 12.5242 335.832 17.6419 335.726 19.0433C335.301 24.9681 353.803 31.1501 377.053 32.8353C400.303 34.5205 419.487 31.0881 419.912 25.1544C420.01 23.753 420.373 18.6353 420.479 17.2339Z",
    fill: "url(#paint44_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M336.816 27.7977L336.258 27.7623L337.675 7.7793L338.242 7.81478L336.816 27.7977Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M338.171 28.1079L337.604 28.0724L339.03 8.08057L339.597 8.12491L338.171 28.1079Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M339.543 28.4184L338.977 28.3741L340.403 8.39111L340.969 8.43546L339.543 28.4184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M340.934 28.7202L340.367 28.6758L341.793 8.69287L342.36 8.73722L340.934 28.7202Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M342.342 29.0214L341.776 28.9771L343.202 8.99414L343.768 9.03849L342.342 29.0214Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M343.768 29.3144L343.21 29.2701L344.627 9.28711L345.194 9.33146L343.768 29.3144Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M345.221 29.6069L344.654 29.5625L346.08 9.57959L346.647 9.61507L345.221 29.6069Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M346.682 29.8911L346.115 29.8467L347.541 9.86377L348.108 9.90812L346.682 29.8911Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M348.17 30.1659L347.603 30.1304L349.029 10.1475L349.596 10.1829L348.17 30.1659Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M349.676 30.4409L349.109 30.4054L350.535 10.4136L351.093 10.4579L349.676 30.4409Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M351.19 30.7158L350.624 30.6714L352.05 10.6885L352.616 10.724L351.19 30.7158Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M352.732 30.9731L352.165 30.9288L353.591 10.9458L354.158 10.9901L352.732 30.9731Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M354.29 31.2299L353.724 31.1856L355.15 11.2026L355.708 11.247L354.29 31.2299Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M355.858 31.479L355.291 31.4346L356.717 11.4517L357.284 11.496L355.858 31.479Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M357.453 31.7177L356.886 31.6823L358.312 11.6904L358.879 11.7348L357.453 31.7177Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M359.064 31.9575L358.498 31.9131L359.924 11.9302L360.49 11.9657L359.064 31.9575Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M360.685 32.1792L360.127 32.1348L361.544 12.1519L362.111 12.1962L360.685 32.1792Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M362.333 32.4008L361.766 32.3565L363.192 12.3735L363.759 12.409L362.333 32.4008Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M363.998 32.6054L363.431 32.5699L364.857 12.5781L365.424 12.6225L363.998 32.6054Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M365.672 32.809L365.105 32.7647L366.531 12.7817L367.098 12.8261L365.672 32.809Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M367.372 33.0044L366.805 32.96L368.231 12.9771L368.789 13.0125L367.372 33.0044Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M369.082 33.1816L368.515 33.1373L369.941 13.1543L370.508 13.1986L369.082 33.1816Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M370.809 33.35L370.242 33.3145L371.668 13.3315L372.235 13.367L370.809 33.35Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M372.554 33.5185L371.987 33.4742L373.413 13.4912L373.98 13.5356L372.554 33.5185Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M374.316 33.6694L373.75 33.625L375.176 13.6421L375.742 13.6864L374.316 33.6694Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M376.096 33.811L375.53 33.7666L376.956 13.7837L377.522 13.828L376.096 33.811Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M377.886 33.9354L377.319 33.8999L378.745 13.917L379.312 13.9525L377.886 33.9354Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M379.657 34.06L379.09 34.0157L380.516 14.0327L381.083 14.0682L379.657 34.06Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M381.42 34.1572L380.853 34.1217L382.279 14.1299L382.846 14.1742L381.42 34.1572Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M383.164 34.2455L382.597 34.21L384.023 14.2271L384.59 14.2625L383.164 34.2455Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M384.891 34.3256L384.333 34.2902L385.751 14.2983L386.317 14.3427L384.891 34.3256Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M386.61 34.3964L386.043 34.3521L387.469 14.3691L388.036 14.4135L386.61 34.3964Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M388.31 34.4497L387.744 34.4053L389.17 14.4224L389.736 14.4667L388.31 34.4497Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M389.993 34.4941L389.435 34.4498L390.852 14.4668L391.419 14.5111L389.993 34.4941Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M391.667 34.5209L391.1 34.4854L392.526 14.5024L393.093 14.5379L391.667 34.5209Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M393.323 34.5473L392.757 34.503L394.183 14.52L394.749 14.5644L393.323 34.5473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M394.962 34.5561L394.395 34.5118L395.821 14.5288L396.379 14.5732L394.962 34.5561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M396.583 34.5561L396.016 34.5118L397.442 14.5288L398.009 14.5732L396.583 34.5561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M398.186 34.5473L397.619 34.503L399.045 14.52L399.612 14.5644L398.186 34.5473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M399.771 34.5297L399.204 34.4854L400.63 14.5024L401.197 14.5468L399.771 34.5297Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M401.348 34.5034L400.781 34.459L402.207 14.4761L402.774 14.5116L401.348 34.5034Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M402.898 34.4584L402.331 34.4229L403.757 14.4399L404.324 14.4754L402.898 34.4584Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M404.439 34.4145L403.872 34.379L405.298 14.3872L405.865 14.4316L404.439 34.4145Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M405.962 34.3613L405.396 34.3169L406.821 14.334L407.388 14.3783L405.962 34.3613Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M407.468 34.2988L406.901 34.2544L408.327 14.2715L408.885 14.3158L407.468 34.2988Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M408.947 34.228L408.389 34.1925L409.807 14.2007L410.373 14.245L408.947 34.228Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M410.417 34.1483L409.851 34.1128L411.277 14.1299L411.843 14.1654L410.417 34.1483Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M411.87 34.0683L411.303 34.024L412.729 14.041L413.296 14.0854L411.87 34.0683Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M413.305 33.9711L412.738 33.9356L414.164 13.9526L414.731 13.9881L413.305 33.9711Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M414.713 33.8735L414.155 33.838L415.572 13.8462L416.139 13.8905L414.713 33.8735Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M416.113 33.767L415.546 33.7315L416.972 13.7485L417.538 13.784L416.113 33.767Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M417.494 33.6606L416.927 33.6163L418.353 13.6333L418.911 13.6776L417.494 33.6606Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M370.951 3.06095C363.954 2.91017 357.532 3.22947 352.174 3.95677L350.429 28.4277C355.628 29.9266 361.934 31.1684 368.887 32.0287L370.951 3.06095Z",
    fill: "#FFFAEF"
  }))), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M420.47 17.2233C420.9 11.297 402.403 5.12609 379.155 3.44004C355.908 1.75398 336.713 5.1913 336.283 11.1175C335.853 17.0437 354.35 23.2147 377.598 24.9008C400.845 26.5868 420.04 23.1495 420.47 17.2233Z",
    fill: "url(#paint45_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M371.969 22.5468C375.928 20.9237 379.914 19.3627 383.847 17.6775C387.753 15.9923 391.641 14.245 395.511 12.48C398.912 10.9278 402.305 9.37564 405.706 7.83235C401.419 6.60836 396.397 5.54402 390.879 4.72803C388.798 5.57063 386.716 6.4221 384.635 7.2647C379.108 9.50868 373.581 11.7261 368.019 13.8725C362.483 16.01 356.921 18.0589 351.377 20.1875C351.164 20.2674 350.952 20.3561 350.73 20.4359C355.752 21.8994 361.837 23.1322 368.542 24.0014C369.675 23.5136 370.818 23.0258 371.961 22.5557L371.969 22.5468Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 5,
    width: 67,
    height: 17
  }, _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M411.188 15.6912C410.896 19.8244 395.998 22.1127 377.921 20.8C359.844 19.4873 345.425 15.0703 345.717 10.9371C346.009 6.80395 360.907 4.51562 378.984 5.82831C397.061 7.14099 411.48 11.558 411.188 15.6912Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_13830_12464)"
  }, _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M411.188 15.6912C410.896 19.8244 395.998 22.1127 377.921 20.8C359.844 19.4873 345.425 15.0703 345.717 10.9371C346.009 6.80395 360.907 4.51562 378.984 5.82831C397.061 7.14099 411.48 11.558 411.188 15.6912Z",
    fill: "url(#paint46_linear_13830_12464)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M411.569 18.9285C411.277 23.0617 396.379 25.35 378.302 24.0373C360.225 22.7246 345.806 18.3076 346.098 14.1744C346.39 10.0413 361.288 7.75293 379.365 9.06561C397.442 10.3783 411.861 14.7953 411.569 18.9285Z",
    fill: "url(#paint47_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M353.13 19.1146L388.071 6.04102L403.669 9.01229L371.969 22.893L353.13 19.1146Z",
    fill: "#FFFAEF"
  })))), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M418.92 19.8599C417.636 21.0484 416.015 21.8023 414.403 22.4587L413.181 22.9287L411.932 23.319C411.1 23.6028 410.258 23.798 409.408 24.0197C406.016 24.8357 402.562 25.3501 399.098 25.6783C392.163 26.3524 385.193 26.308 378.258 25.8645C374.795 25.6162 371.332 25.2703 367.886 24.7913C364.45 24.2769 361.013 23.6826 357.63 22.8844C354.238 22.1039 350.881 21.1371 347.613 19.9131C345.983 19.2923 344.38 18.5916 342.83 17.7933C341.289 16.9773 339.774 16.0815 338.481 14.9019C341.342 16.8798 344.61 18.0594 347.896 19.0528C351.182 20.055 354.539 20.8178 357.913 21.4741C364.671 22.7514 371.509 23.5762 378.373 24.0463C385.237 24.5253 392.128 24.6494 398.992 24.2769C402.42 24.0729 405.848 23.7625 409.231 23.1682C410.072 23.0086 410.923 22.8844 411.755 22.6715L413.013 22.3788L414.244 22.0152C415.865 21.483 417.512 20.9065 418.92 19.8688V19.8599Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 62,
    width: 86,
    height: 31
  }, _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M227.981 76.8902C227.555 70.9653 246.058 64.7833 269.307 63.0981C292.557 61.4129 311.741 64.8454 312.167 70.7791C312.264 72.1805 312.627 77.2982 312.733 78.6995C313.159 84.6244 294.656 90.8064 271.407 92.4916C248.157 94.1768 228.973 90.7443 228.547 84.8106C228.45 83.4092 228.087 78.2915 227.981 76.8902Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_13830_12464)"
  }, _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M227.981 76.8902C227.555 70.9653 246.058 64.7833 269.307 63.0981C292.557 61.4129 311.741 64.8454 312.167 70.7791C312.264 72.1805 312.627 77.2982 312.733 78.6995C313.159 84.6244 294.656 90.8064 271.407 92.4916C248.157 94.1768 228.973 90.7443 228.547 84.8106C228.45 83.4092 228.087 78.2915 227.981 76.8902Z",
    fill: "url(#paint48_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M311.644 87.4624L312.211 87.418L310.785 67.4351L310.218 67.4794L311.644 87.4624Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M310.289 87.7729L310.856 87.7286L309.43 67.7456L308.863 67.79L310.289 87.7729Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M308.916 88.0746L309.483 88.0391L308.057 68.0562L307.49 68.0916L308.916 88.0746Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M307.526 88.3847L308.092 88.3404L306.666 68.3574L306.1 68.3929L307.526 88.3847Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M306.117 88.6777L306.684 88.6422L305.258 68.6504L304.691 68.6947L306.117 88.6777Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M304.691 88.9706L305.258 88.9351L303.832 68.9521L303.265 68.9876L304.691 88.9706Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M303.239 89.2631L303.806 89.2277L302.38 69.2358L301.813 69.2802L303.239 89.2631Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M301.778 89.5473L302.344 89.5118L300.918 69.52L300.352 69.5644L301.778 89.5473Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M300.289 89.831L300.856 89.7867L299.43 69.8037L298.864 69.8481L300.289 89.831Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M298.793 90.1059L299.351 90.0616L297.934 70.0786L297.367 70.123L298.793 90.1059Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M297.269 90.372L297.836 90.3277L296.41 70.3447L295.843 70.3891L297.269 90.372Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M295.728 90.6377L296.295 90.5933L294.869 70.6104L294.302 70.6458L295.728 90.6377Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M294.169 90.8861L294.736 90.8506L293.31 70.8677L292.752 70.9032L294.169 90.8861Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M292.602 91.1435L293.168 91.0992L291.742 71.1162L291.176 71.1517L292.602 91.1435Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M291.007 91.3828L291.574 91.3384L290.148 71.3555L289.581 71.3998L291.007 91.3828Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M289.395 91.6137L289.962 91.5694L288.536 71.5864L287.969 71.6308L289.395 91.6137Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M287.774 91.8442L288.332 91.7999L286.915 71.8169L286.348 71.8524L287.774 91.8442Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M286.127 92.0571L286.694 92.0216L285.268 72.0298L284.701 72.0741L286.127 92.0571Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M284.462 92.27L285.029 92.2256L283.603 72.2427L283.045 72.287L284.462 92.27Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M282.788 92.4652L283.355 92.4297L281.929 72.4468L281.362 72.4823L282.788 92.4652Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M281.088 92.6601L281.654 92.6158L280.228 72.6328L279.67 72.6772L281.088 92.6601Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M279.378 92.8462L279.945 92.8018L278.519 72.8188L277.952 72.8543L279.378 92.8462Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M277.651 93.0151L278.218 92.9707L276.792 72.9878L276.225 73.0321L277.651 93.0151Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M275.906 93.1743L276.473 93.1388L275.047 73.147L274.48 73.1913L275.906 93.1743Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M274.144 93.3251L274.71 93.2896L273.284 73.3066L272.718 73.3421L274.144 93.3251Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M272.363 93.4672L272.93 93.4318L271.504 73.4399L270.937 73.4843L272.363 93.4672Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M270.574 93.6001L271.141 93.5557L269.715 73.5728L269.157 73.6171L270.574 93.6001Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M268.803 93.7158L269.37 93.6714L267.944 73.6885L267.377 73.7328L268.803 93.7158Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M267.04 93.8222L267.607 93.7779L266.181 73.7949L265.614 73.8304L267.04 93.8222Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M265.295 93.9106L265.862 93.8663L264.436 73.8833L263.869 73.9277L265.295 93.9106Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M263.568 93.9902L264.135 93.9458L262.709 73.9629L262.142 74.0072L263.568 93.9902Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M261.85 94.0527L262.417 94.0172L260.991 74.0254L260.424 74.0697L261.85 94.0527Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M260.15 94.1058L260.716 94.0704L259.29 74.0874L258.724 74.1229L260.15 94.1058Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M258.466 94.1504L259.033 94.1149L257.607 74.123L257.041 74.1674L258.466 94.1504Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M256.793 94.1855L257.36 94.1412L255.934 74.1582L255.367 74.2025L256.793 94.1855Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M255.136 94.2031L255.703 94.1676L254.277 74.1758L253.719 74.2201L255.136 94.2031Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M253.507 94.2211L254.065 94.1768L252.648 74.1938L252.081 74.2293L253.507 94.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M251.877 94.2211L252.444 94.1768L251.018 74.1938L250.46 74.2293L251.877 94.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M250.274 94.2124L250.841 94.168L249.415 74.1851L248.848 74.2205L250.274 94.2124Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M248.688 94.1859L249.255 94.1504L247.829 74.1675L247.262 74.203L248.688 94.1859Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M247.112 94.1591L247.679 94.1237L246.253 74.1318L245.686 74.1762L247.112 94.1591Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M245.562 94.1235L246.129 94.0791L244.703 74.0962L244.136 74.1405L245.562 94.1235Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M244.021 94.0796L244.588 94.0352L243.162 74.0522L242.595 74.0966L244.021 94.0796Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M242.497 94.0263L243.064 93.982L241.638 73.999L241.071 74.0345L242.497 94.0263Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M241 93.9638L241.558 93.9195L240.141 73.9365L239.574 73.972L241 93.9638Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M239.513 93.893L240.08 93.8487L238.654 73.8657L238.087 73.9012L239.513 93.893Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M238.042 93.8134L238.609 93.7691L237.183 73.7861L236.616 73.8305L238.042 93.8134Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M236.59 93.7246L237.157 93.6891L235.731 73.6973L235.164 73.7416L236.59 93.7246Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M235.155 93.6357L235.722 93.5914L234.296 73.6084L233.729 73.6527L235.155 93.6357Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 93.5385L234.313 93.4942L232.887 73.5112L232.321 73.5556L233.747 93.5385Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M232.347 93.4316L232.914 93.3873L231.488 73.4043L230.921 73.4486L232.347 93.4316Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M230.965 93.3254L231.532 93.2811L230.106 73.2981L229.548 73.3336L230.965 93.3254Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M277.509 62.7167C284.506 62.5659 290.928 62.8852 296.286 63.6125L298.031 88.0834C292.832 89.5824 286.526 90.8241 279.573 91.6845L277.509 62.7167Z",
    fill: "#EDE7DE"
  }))), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M270.851 84.5873C294.098 82.9013 312.596 76.7303 312.165 70.8041C311.735 64.8779 292.541 61.4405 269.293 63.1266C246.045 64.8126 227.548 70.9836 227.978 76.9098C228.409 82.836 247.603 86.2734 270.851 84.5873Z",
    fill: "url(#paint49_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M276.491 82.2031C272.531 80.58 268.546 79.0189 264.613 77.3337C260.707 75.6485 256.819 73.9012 252.949 72.1362C249.547 70.5841 246.155 69.0319 242.754 67.4886C247.041 66.2646 252.063 65.2003 257.581 64.3843C259.662 65.2269 261.744 66.0784 263.825 66.921C269.352 69.1649 274.879 71.3823 280.441 73.5287C285.976 75.6663 291.539 77.7151 297.083 79.8438C297.296 79.9236 297.508 80.0123 297.73 80.0921C292.708 81.5556 286.623 82.7885 279.918 83.6488C278.785 83.161 277.642 82.6732 276.499 82.2031H276.491Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 65,
    width: 66,
    height: 16
  }, _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M237.272 75.3557C237.564 79.4889 252.461 81.7772 270.539 80.4646C288.616 79.1519 303.035 74.7349 302.743 70.6017C302.451 66.4685 287.553 64.1802 269.476 65.4929C251.399 66.8055 236.979 71.2225 237.272 75.3557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_13830_12464)"
  }, _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M237.272 75.3557C237.564 79.4889 252.462 81.7772 270.539 80.4646C288.616 79.1519 303.035 74.7349 302.743 70.6017C302.451 66.4685 287.553 64.1802 269.476 65.4929C251.399 66.8055 236.98 71.2225 237.272 75.3557Z",
    fill: "url(#paint50_linear_13830_12464)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M236.891 78.593C237.183 82.7262 252.081 85.0145 270.158 83.7019C288.235 82.3892 302.654 77.9722 302.362 73.839C302.07 69.7058 287.172 67.4175 269.095 68.7302C251.018 70.0428 236.599 74.4599 236.891 78.593Z",
    fill: "url(#paint51_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M295.33 78.7704L260.389 65.6968L244.792 68.6681L276.491 82.5577L295.33 78.7704Z",
    fill: "#EDE7DE"
  })))), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M229.54 79.5157C230.824 80.7042 232.445 81.4581 234.057 82.1144L235.279 82.5845L236.528 82.9748C237.36 83.2586 238.202 83.4537 239.052 83.6755C242.444 84.4914 245.898 85.0059 249.362 85.334C256.297 86.0081 263.267 85.9638 270.202 85.5203C273.665 85.272 277.128 84.9261 280.574 84.4471C284.01 83.9327 287.447 83.3384 290.83 82.5402C294.222 81.7596 297.579 80.7929 300.847 79.5689C302.477 78.948 304.08 78.2473 305.63 77.4491C307.171 76.6331 308.686 75.7373 309.979 74.5576C307.118 76.5355 303.85 77.7152 300.564 78.7085C297.278 79.7108 293.921 80.4736 290.547 81.1299C283.789 82.4071 276.951 83.232 270.087 83.7021C263.223 84.181 256.332 84.3052 249.468 83.9327C246.04 83.7287 242.613 83.4182 239.229 82.824C238.388 82.6643 237.537 82.5402 236.705 82.3273L235.447 82.0346L234.216 81.671C232.595 81.1388 230.948 80.5623 229.54 79.5245V79.5157Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 51,
    width: 86,
    height: 31
  }, _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M178.674 65.9365C178.249 60.0117 196.751 53.8297 220.001 52.1445C243.25 50.4593 262.435 53.8918 262.86 59.8255C262.957 61.2268 263.32 66.3445 263.427 67.7459C263.852 73.6707 245.349 79.8528 222.1 81.538C198.85 83.2232 179.666 79.7907 179.241 73.857C179.143 72.4556 178.78 67.3379 178.674 65.9365Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_13830_12464)"
  }, _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M178.674 65.9365C178.249 60.0117 196.751 53.8297 220.001 52.1445C243.25 50.4593 262.435 53.8918 262.86 59.8255C262.957 61.2268 263.32 66.3445 263.427 67.7459C263.852 73.6707 245.349 79.8528 222.1 81.538C198.85 83.2232 179.666 79.7907 179.241 73.857C179.143 72.4556 178.78 67.3379 178.674 65.9365Z",
    fill: "url(#paint52_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M262.337 76.5004L262.895 76.4649L261.478 56.4819L260.911 56.5174L262.337 76.5004Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M260.982 76.8109L261.549 76.7754L260.123 56.7925L259.556 56.828L260.982 76.8109Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M259.609 77.121L260.176 77.0767L258.75 57.0938L258.183 57.1381L259.609 77.121Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M258.219 77.4228L258.786 77.3785L257.36 57.3955L256.793 57.4399L258.219 77.4228Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M256.811 77.7241L257.378 77.6797L255.952 57.6968L255.385 57.7411L256.811 77.7241Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M255.376 78.0171L255.942 77.9727L254.516 57.9897L253.958 58.0341L255.376 78.0171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M253.932 78.3095L254.499 78.2652L253.073 58.2822L252.506 58.3177L253.932 78.3095Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M252.47 78.5937L253.028 78.5494L251.611 58.5664L251.044 58.6108L252.47 78.5937Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M250.983 78.8685L251.549 78.8331L250.124 58.8501L249.557 58.8856L250.983 78.8685Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M249.477 79.1435L250.044 79.108L248.618 59.1162L248.06 59.1606L249.477 79.1435Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M247.962 79.4184L248.529 79.3741L247.103 59.3911L246.536 59.4266L247.962 79.4184Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M246.421 79.6757L246.988 79.6403L245.562 59.6484L244.995 59.6928L246.421 79.6757Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M244.862 79.9326L245.429 79.8882L244.003 59.9053L243.436 59.9496L244.862 79.9326Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M243.295 80.1816L243.853 80.1373L242.436 60.1543L241.869 60.1986L243.295 80.1816Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M241.701 80.4204L242.267 80.3849L240.841 60.3931L240.275 60.4374L241.701 80.4204Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M240.089 80.6601L240.655 80.6158L239.229 60.6328L238.663 60.6683L240.089 80.6601Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M238.459 80.8818L239.025 80.8463L237.6 60.8545L237.042 60.8988L238.459 80.8818Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M236.82 81.1035L237.387 81.0591L235.961 61.0762L235.394 61.1205L236.82 81.1035Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M235.155 81.3075L235.722 81.272L234.296 61.2891L233.729 61.3245L235.155 81.3075Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M233.481 81.5117L234.048 81.4673L232.622 61.4844L232.055 61.5287L233.481 81.5117Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M231.78 81.707L232.347 81.6626L230.921 61.6797L230.354 61.7152L231.78 81.707Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M230.071 81.8842L230.638 81.8399L229.212 61.8569L228.645 61.9013L230.071 81.8842Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M228.344 82.0615L228.911 82.0171L227.485 62.0342L226.918 62.0697L228.344 82.0615Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M226.599 82.2211L227.166 82.1768L225.74 62.1938L225.173 62.2382L226.599 82.2211Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M224.837 82.372L225.404 82.3277L223.978 62.3447L223.411 62.3891L224.837 82.372Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M223.056 82.5136L223.623 82.4693L222.197 62.4863L221.63 62.5307L223.056 82.5136Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M221.267 82.6381L221.834 82.6026L220.408 62.6196L219.841 62.6551L221.267 82.6381Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M219.496 82.7627L220.063 82.7183L218.637 62.7354L218.07 62.7708L219.496 82.7627Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M217.733 82.8598L218.3 82.8243L216.874 62.8325L216.307 62.8769L217.733 82.8598Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M215.988 82.9481L216.555 82.9126L215.129 62.9297L214.562 62.9652L215.988 82.9481Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M214.252 83.0283L214.819 82.9928L213.393 63.001L212.835 63.0453L214.252 83.0283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M212.543 83.0991L213.11 83.0547L211.684 63.0718L211.117 63.1161L212.543 83.0991Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M210.843 83.1523L211.41 83.108L209.984 63.125L209.417 63.1694L210.843 83.1523Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M209.151 83.1967L209.718 83.1524L208.292 63.1694L207.734 63.2138L209.151 83.1967Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M207.486 83.2235L208.053 83.188L206.627 63.2051L206.06 63.2406L207.486 83.2235Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M205.83 83.25L206.396 83.2056L204.97 63.2227L204.404 63.267L205.83 83.25Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M204.191 83.2588L204.758 83.2144L203.332 63.2314L202.765 63.2758L204.191 83.2588Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M202.57 83.2588L203.137 83.2144L201.711 63.2314L201.144 63.2758L202.57 83.2588Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M200.967 83.25L201.534 83.2056L200.108 63.2227L199.541 63.267L200.967 83.25Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M199.382 83.2324L199.948 83.188L198.522 63.2051L197.956 63.2494L199.382 83.2324Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M197.805 83.206L198.372 83.1617L196.946 63.1787L196.379 63.2231L197.805 83.206Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M196.255 83.161L196.813 83.1255L195.396 63.1426L194.829 63.1781L196.255 83.161Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M194.714 83.1171L195.281 83.0817L193.855 63.0898L193.288 63.1342L194.714 83.1171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M193.19 83.0639L193.757 83.0284L192.331 63.0366L191.764 63.081L193.19 83.0639Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M191.685 83.0014L192.252 82.9571L190.826 62.9741L190.259 63.0185L191.685 83.0014Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M190.206 82.9306L190.764 82.8951L189.347 62.9033L188.78 62.9477L190.206 82.9306Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M188.736 82.851L189.302 82.8155L187.876 62.8325L187.31 62.868L188.736 82.851Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M187.283 82.771L187.85 82.7266L186.424 62.7437L185.857 62.788L187.283 82.771Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M185.848 82.6737L186.415 82.6382L184.989 62.6553L184.422 62.6908L185.848 82.6737Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M184.431 82.5761L184.998 82.5406L183.572 62.5576L183.014 62.5931L184.431 82.5761Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M183.04 82.4785L183.607 82.4341L182.181 62.4512L181.615 62.4867L183.04 82.4785Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M181.659 82.363L182.225 82.3186L180.8 62.3357L180.233 62.38L181.659 82.363Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M228.202 51.7632C235.199 51.6036 241.621 51.9317 246.979 52.659L248.724 77.13C243.525 78.6289 237.219 79.8706 230.266 80.731L228.202 51.7632Z",
    fill: "#EDE7DE"
  }))), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M178.674 65.9371C179.099 71.8619 198.283 75.3033 221.533 73.6181C244.782 71.9329 263.276 65.7509 262.86 59.826C262.435 53.9012 243.25 50.4599 220.001 52.1451C196.751 53.8303 178.257 60.0123 178.674 65.9371Z",
    fill: "url(#paint53_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M227.184 71.2495C223.225 69.6264 219.239 68.0653 215.307 66.3801C211.401 64.6949 207.512 62.9476 203.642 61.1826C200.241 59.6304 196.849 58.0783 193.448 56.535C197.734 55.311 202.756 54.2467 208.274 53.4307C210.356 54.2733 212.437 55.1247 214.518 55.9673C220.045 58.2113 225.572 60.4287 231.134 62.5751C236.67 64.7127 242.232 66.7615 247.777 68.8902C247.989 68.97 248.202 69.0587 248.423 69.1385C243.401 70.602 237.316 71.8349 230.612 72.6952C229.478 72.2074 228.335 71.7196 227.193 71.2495H227.184Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 54,
    width: 67,
    height: 16
  }, _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M187.965 64.3938C188.257 68.527 203.155 70.8153 221.232 69.5026C239.309 68.19 253.728 63.773 253.436 59.6398C253.144 55.5066 238.246 53.2183 220.169 54.5309C202.092 55.8436 187.673 60.2606 187.965 64.3938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_13830_12464)"
  }, _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M187.965 64.3938C188.257 68.527 203.155 70.8153 221.232 69.5026C239.309 68.19 253.728 63.773 253.436 59.6398C253.144 55.5066 238.246 53.2183 220.169 54.5309C202.092 55.8436 187.673 60.2606 187.965 64.3938Z",
    fill: "url(#paint54_linear_13830_12464)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M187.584 67.6311C187.876 71.7643 202.774 74.0526 220.851 72.74C238.928 71.4273 253.347 67.0103 253.055 62.8771C252.763 58.7439 237.865 56.4556 219.788 57.7682C201.711 59.0809 187.292 63.4979 187.584 67.6311Z",
    fill: "url(#paint55_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M246.023 67.8173L211.082 54.7437L195.485 57.7149L227.184 71.5957L246.023 67.8173Z",
    fill: "#EDE7DE"
  })))), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M180.233 68.5625C181.517 69.751 183.138 70.505 184.75 71.1613L185.972 71.6314L187.221 72.0216C188.053 72.3055 188.895 72.5006 189.745 72.7223C193.137 73.5383 196.592 74.0528 200.055 74.3809C206.99 75.055 213.96 75.0107 220.895 74.5672C224.358 74.3188 227.821 73.9729 231.267 73.494C234.703 72.9707 238.14 72.3853 241.523 71.587C244.916 70.8065 248.272 69.8397 251.541 68.6158C253.17 67.9949 254.773 67.2942 256.323 66.4959C257.865 65.68 259.379 64.7841 260.672 63.6045C257.811 65.5824 254.543 66.762 251.257 67.7554C247.971 68.7577 244.614 69.5204 241.24 70.1768C234.482 71.454 227.644 72.2788 220.78 72.7489C213.916 73.2279 207.025 73.3521 200.161 72.9795C196.733 72.7755 193.306 72.4651 189.922 71.8709C189.081 71.7112 188.231 71.587 187.398 71.3742L186.14 71.0815L184.909 70.7178C183.288 70.1856 181.641 69.6091 180.233 68.5714V68.5625Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 39,
    width: 86,
    height: 32
  }, _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M223.906 54.0606C223.481 48.1358 241.984 41.9537 265.233 40.2685C288.483 38.5833 307.667 42.0158 308.092 47.9495C308.19 49.3509 308.553 54.4686 308.659 55.8699C309.084 61.7948 290.582 67.9768 267.332 69.662C244.083 71.3472 224.898 67.9147 224.473 61.981C224.376 60.5796 224.013 55.462 223.906 54.0606Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_13830_12464)"
  }, _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M223.906 54.0606C223.481 48.1358 241.984 41.9537 265.233 40.2685C288.483 38.5833 307.667 42.0158 308.092 47.9495C308.19 49.3509 308.553 54.4686 308.659 55.8699C309.084 61.7948 290.582 67.9768 267.332 69.662C244.083 71.3472 224.898 67.9147 224.473 61.981C224.376 60.5796 224.013 55.462 223.906 54.0606Z",
    fill: "url(#paint56_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M307.57 64.6333L308.136 64.5889L306.71 44.606L306.144 44.6503L307.57 64.6333Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M306.215 64.9438L306.781 64.8995L305.355 44.9165L304.789 44.9609L306.215 64.9438Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M304.842 65.2455L305.409 65.21L303.983 45.2271L303.425 45.2625L304.842 65.2455Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M303.451 65.5556L304.018 65.5113L302.592 45.5283L302.034 45.5638L303.451 65.5556Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M302.043 65.8481L302.61 65.8126L301.184 45.8208L300.617 45.8652L302.043 65.8481Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M300.617 66.1499L301.184 66.1055L299.758 46.1226L299.191 46.158L300.617 66.1499Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M299.173 66.4336L299.731 66.3981L298.314 46.4062L297.747 46.4506L299.173 66.4336Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M297.703 66.7177L298.27 66.6822L296.844 46.6992L296.277 46.7347L297.703 66.7177Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M296.224 67.0014L296.782 66.9571L295.365 46.9741L294.798 47.0185L296.224 67.0014Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M294.718 67.2763L295.285 67.232L293.859 47.249L293.292 47.2934L294.718 67.2763Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M293.195 67.5424L293.762 67.507L292.336 47.5151L291.769 47.5595L293.195 67.5424Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 67.8085L292.22 67.7642L290.803 47.7812L290.236 47.8167L291.662 67.8085Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M290.104 68.0659L290.671 68.0215L289.245 48.0386L288.678 48.0741L290.104 68.0659Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M288.527 68.3139L289.094 68.2696L287.668 48.2866L287.101 48.3221L288.527 68.3139Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M286.933 68.5537L287.5 68.5093L286.074 48.5264L285.507 48.5707L286.933 68.5537Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M285.33 68.7841L285.888 68.7487L284.471 48.7568L283.904 48.8012L285.33 68.7841Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M283.7 69.0146L284.267 68.9703L282.841 48.9873L282.274 49.0317L283.7 69.0146Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M282.053 69.2275L282.62 69.192L281.194 49.2002L280.627 49.2445L282.053 69.2275Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M280.396 69.4404L280.963 69.396L279.537 49.4131L278.97 49.4574L280.396 69.4404Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M278.713 69.645L279.28 69.6006L277.854 49.6177L277.287 49.6531L278.713 69.645Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M277.022 69.831L277.589 69.7955L276.163 49.8037L275.596 49.8481L277.022 69.831Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M275.312 70.0171L275.87 69.9727L274.453 49.9897L273.886 50.0252L275.312 70.0171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M273.576 70.1855L274.143 70.1412L272.717 50.1582L272.15 50.2026L273.576 70.1855Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M271.832 70.3451L272.399 70.3096L270.973 50.3267L270.406 50.3621L271.832 70.3451Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M270.069 70.496L270.636 70.4605L269.21 50.4775L268.652 50.513L270.069 70.496Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M268.298 70.6381L268.864 70.6026L267.438 50.6196L266.872 50.6551L268.298 70.6381Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M266.509 70.771L267.075 70.7266L265.649 50.7437L265.083 50.788L266.509 70.771Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M264.728 70.8867L265.295 70.8423L263.869 50.8594L263.302 50.9037L264.728 70.8867Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M262.975 70.9926L263.533 70.9483L262.115 50.9653L261.549 51.0097L262.975 70.9926Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M261.221 71.081L261.788 71.0367L260.362 51.0537L259.804 51.0981L261.221 71.081Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M259.494 71.1611L260.061 71.1167L258.635 51.1338L258.068 51.1781L259.494 71.1611Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M257.775 71.2231L258.342 71.1876L256.916 51.1958L256.349 51.2401L257.775 71.2231Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M256.075 71.2767L256.642 71.2413L255.216 51.2583L254.649 51.2938L256.075 71.2767Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M254.392 71.3212L254.959 71.2857L253.533 51.3027L252.966 51.3382L254.392 71.3212Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M252.718 71.3564L253.285 71.3121L251.859 51.3291L251.301 51.3734L252.718 71.3564Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M251.071 71.3739L251.638 71.3384L250.212 51.3555L249.645 51.3909L251.071 71.3739Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M249.432 71.3916L249.999 71.3472L248.573 51.3643L248.006 51.3997L249.432 71.3916Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M247.811 71.3916L248.378 71.3472L246.952 51.3643L246.385 51.3997L247.811 71.3916Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M246.208 71.3828L246.766 71.3384L245.349 51.3555L244.782 51.3909L246.208 71.3828Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M244.614 71.3563L245.181 71.3208L243.755 51.3379L243.188 51.3734L244.614 71.3563Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M243.046 71.33L243.613 71.2946L242.187 51.3027L241.62 51.3471L243.046 71.33Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M241.488 71.2939L242.054 71.2496L240.628 51.2666L240.062 51.311L241.488 71.2939Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M239.946 71.25L240.513 71.2056L239.087 51.2227L238.52 51.267L239.946 71.25Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M238.432 71.1967L238.99 71.1524L237.572 51.1694L237.006 51.2138L238.432 71.1967Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M236.926 71.1347L237.493 71.0904L236.067 51.1074L235.5 51.1429L236.926 71.1347Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M235.438 71.0634L236.005 71.0191L234.579 51.0361L234.012 51.0805L235.438 71.0634Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M233.968 70.9838L234.535 70.9395L233.109 50.9565L232.542 51.0009L233.968 70.9838Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M232.515 70.8954L233.082 70.8599L231.656 50.877L231.098 50.9124L232.515 70.8954Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M231.089 70.8066L231.656 70.7623L230.23 50.7793L229.663 50.8236L231.089 70.8066Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M229.672 70.7089L230.239 70.6646L228.813 50.6816L228.246 50.726L229.672 70.7089Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M228.273 70.6025L228.84 70.5582L227.414 50.5752L226.847 50.6195L228.273 70.6025Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9 70.4963L227.467 70.452L226.041 50.469L225.474 50.5045L226.9 70.4963Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M273.435 39.8866C280.432 39.7358 286.853 40.0551 292.212 40.7824L293.957 65.2534C288.757 66.7523 282.451 67.994 275.498 68.8544L273.435 39.8866Z",
    fill: "#EDE7DE"
  }))), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M266.776 61.7577C290.023 60.0717 308.521 53.9007 308.09 47.9745C307.66 42.0483 288.466 38.6109 265.218 40.297C241.97 41.983 223.473 48.154 223.903 54.0802C224.334 60.0065 243.528 63.4438 266.776 61.7577Z",
    fill: "url(#paint57_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M272.425 59.3735C268.466 57.7504 264.48 56.1893 260.548 54.5041C256.642 52.8189 252.754 51.0716 248.883 49.3066C245.482 47.7545 242.09 46.2023 238.689 44.659C242.976 43.435 247.997 42.3707 253.515 41.5547C255.597 42.3973 257.678 43.2488 259.76 44.0914C265.286 46.3353 270.813 48.5527 276.375 50.6991C281.911 52.8367 287.473 54.8855 293.018 57.0142C293.23 57.094 293.443 57.1827 293.664 57.2626C288.642 58.726 282.558 59.9589 275.853 60.8281C274.719 60.3403 273.577 59.8524 272.434 59.3824L272.425 59.3735Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 42,
    width: 66,
    height: 17
  }, _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M233.197 52.5261C233.49 56.6593 248.387 58.9476 266.464 57.635C284.542 56.3223 298.961 51.9053 298.669 47.7721C298.376 43.6389 283.479 41.3506 265.402 42.6633C247.324 43.976 232.905 48.393 233.197 52.5261Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_13830_12464)"
  }, _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M233.197 52.5261C233.49 56.6593 248.387 58.9476 266.464 57.635C284.542 56.3223 298.961 51.9053 298.669 47.7721C298.376 43.6389 283.479 41.3506 265.402 42.6633C247.324 43.976 232.905 48.393 233.197 52.5261Z",
    fill: "url(#paint58_linear_13830_12464)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M232.825 55.7637C233.118 59.8969 248.015 62.1852 266.092 60.8725C284.17 59.5598 298.589 55.1428 298.297 51.0096C298.004 46.8765 283.107 44.5881 265.03 45.9008C246.952 47.2135 232.533 51.6305 232.825 55.7637Z",
    fill: "url(#paint59_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M291.255 55.9501L256.314 42.8765L240.726 45.8389L272.417 59.7285L291.255 55.9501Z",
    fill: "#EDE7DE"
  })))), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M225.465 56.6856C226.75 57.8741 228.37 58.628 229.982 59.2843L231.205 59.7544L232.454 60.1447C233.286 60.4285 234.128 60.6236 234.978 60.8454C238.37 61.6614 241.824 62.1758 245.287 62.504C252.222 63.1781 259.193 63.1337 266.128 62.6902C269.591 62.4419 273.054 62.096 276.5 61.617C279.936 61.1026 283.373 60.5083 286.756 59.7101C290.148 58.9296 293.505 57.9628 296.773 56.7388C298.403 56.1179 300.006 55.4172 301.556 54.619C303.097 53.803 304.612 52.9072 305.905 51.7275C303.044 53.7054 299.776 54.8851 296.49 55.8785C293.204 56.8807 289.847 57.6435 286.473 58.2998C279.715 59.577 272.877 60.4019 266.013 60.872C259.149 61.3509 252.258 61.4751 245.394 61.1026C241.966 60.8986 238.538 60.5882 235.155 59.9939C234.314 59.8343 233.463 59.7101 232.631 59.4972L231.373 59.2045L230.142 58.8409C228.521 58.3087 226.874 57.7322 225.465 56.6945V56.6856Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 58,
    width: 86,
    height: 31
  }, _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M123.476 72.7837C123.051 66.8589 141.554 60.6769 164.803 58.9917C188.053 57.3065 207.237 60.7389 207.662 66.6726C207.76 68.074 208.123 73.1917 208.229 74.5931C208.654 80.5179 190.152 86.6999 166.902 88.3851C143.653 90.0704 124.468 86.6379 124.043 80.7042C123.946 79.3028 123.583 74.1851 123.476 72.7837Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_13830_12464)"
  }, _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M123.476 72.7837C123.051 66.8589 141.554 60.6769 164.803 58.9917C188.053 57.3065 207.237 60.7389 207.662 66.6726C207.76 68.074 208.123 73.1917 208.229 74.5931C208.654 80.5179 190.152 86.6999 166.902 88.3851C143.653 90.0704 124.468 86.6379 124.043 80.7042C123.946 79.3028 123.583 74.1851 123.476 72.7837Z",
    fill: "url(#paint60_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M207.14 83.3559L207.707 83.3116L206.281 63.3286L205.714 63.3641L207.14 83.3559Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M205.794 83.6665L206.361 83.6221L204.935 63.6392L204.368 63.6746L205.794 83.6665Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M204.421 83.9677L204.988 83.9234L203.562 63.9404L202.995 63.9848L204.421 83.9677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M203.03 84.2695L203.597 84.234L202.171 64.2422L201.604 64.2865L203.03 84.2695Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M201.622 84.5713L202.18 84.5269L200.763 64.5439L200.196 64.5883L201.622 84.5713Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M200.187 84.8637L200.754 84.8283L199.328 64.8364L198.761 64.8808L200.187 84.8637Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M198.743 85.1567L199.31 85.1124L197.884 65.1294L197.317 65.1737L198.743 85.1567Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M197.273 85.4409L197.84 85.3965L196.414 65.4136L195.856 65.4579L197.273 85.4409Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M195.794 85.7241L196.361 85.6797L194.935 65.6968L194.368 65.7323L195.794 85.7241Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M194.289 85.9995L194.855 85.9551L193.429 65.9722L192.863 66.0076L194.289 85.9995Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M192.774 86.2651L193.332 86.2207L191.915 66.2378L191.348 66.2821L192.774 86.2651Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M191.233 86.5224L191.799 86.4869L190.373 66.4951L189.807 66.5395L191.233 86.5224Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M189.674 86.7797L190.241 86.7443L188.815 66.7524L188.248 66.7968L189.674 86.7797Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M188.097 87.0283L188.664 86.9928L187.238 67.001L186.68 67.0453L188.097 87.0283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M186.512 87.2675L187.079 87.232L185.653 67.249L185.086 67.2845L186.512 87.2675Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9 87.5073L185.467 87.4629L184.041 67.48L183.474 67.5243L184.9 87.5073Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M183.27 87.7285L183.837 87.693L182.411 67.7012L181.844 67.7455L183.27 87.7285Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M181.632 87.9506L182.198 87.9063L180.772 67.9233L180.206 67.9677L181.632 87.9506Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M179.967 88.1635L180.533 88.1192L179.107 68.1362L178.541 68.1717L179.967 88.1635Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M178.293 88.3584L178.851 88.3229L177.434 68.3311L176.867 68.3754L178.293 88.3584Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M176.592 88.5537L177.159 88.5093L175.733 68.5264L175.166 68.5707L176.592 88.5537Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M174.883 88.7309L175.449 88.6954L174.023 68.7036L173.457 68.748L174.883 88.7309Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M173.155 88.9087L173.722 88.8643L172.296 68.8813L171.729 68.9257L173.155 88.9087Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M171.411 89.0678L171.977 89.0235L170.551 69.0405L169.985 69.0849L171.411 89.0678Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M169.648 89.2192L170.215 89.1749L168.789 69.1919L168.222 69.2362L169.648 89.2192Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M167.868 89.3608L168.435 89.3165L167.009 69.3335L166.442 69.3778L167.868 89.3608Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M166.079 89.4936L166.645 89.4493L165.219 69.4663L164.653 69.5018L166.079 89.4936Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M164.307 89.6093L164.874 89.565L163.448 69.582L162.881 69.6264L164.307 89.6093Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M162.545 89.7064L163.111 89.6709L161.686 69.688L161.119 69.7235L162.545 89.7064Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M160.8 89.8042L161.367 89.7598L159.941 69.7769L159.374 69.8123L160.8 89.8042Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M159.064 89.8749L159.631 89.8394L158.205 69.8564L157.638 69.8919L159.064 89.8749Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M157.354 89.9462L157.912 89.9019L156.495 69.9189L155.928 69.9633L157.354 89.9462Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M155.654 89.999L156.212 89.9546L154.795 69.9717L154.228 70.016L155.654 89.999Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M153.962 90.0434L154.529 89.9991L153.103 70.0161L152.536 70.0605L153.962 90.0434Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M152.297 90.0791L152.864 90.0347L151.438 70.0518L150.871 70.0872L152.297 90.0791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M150.641 90.0966L151.208 90.0523L149.782 70.0693L149.215 70.1137L150.641 90.0966Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M149.002 90.1059L149.569 90.0704L148.143 70.0786L147.576 70.123L149.002 90.1059Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M147.382 90.1059L147.948 90.0704L146.522 70.0786L145.956 70.123L147.382 90.1059Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M145.778 90.0966L146.345 90.0612L144.919 70.0693L144.352 70.1137L145.778 90.0966Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M144.193 90.0791L144.751 90.0347L143.334 70.0518L142.767 70.0961L144.193 90.0791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M142.616 90.0527L143.183 90.0083L141.757 70.0254L141.19 70.0697L142.616 90.0527Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M141.058 90.0171L141.625 89.9727L140.199 69.9897L139.641 70.0252L141.058 90.0171Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M139.525 89.9637L140.092 89.9283L138.666 69.9453L138.099 69.9808L139.525 89.9637Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M138.002 89.911L138.569 89.8755L137.143 69.8926L136.576 69.9281L138.002 89.911Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M136.496 89.8486L137.063 89.8131L135.637 69.8213L135.07 69.8656L136.496 89.8486Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M135.008 89.7772L135.575 89.7417L134.149 69.7588L133.591 69.7943L135.008 89.7772Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M133.547 89.7065L134.105 89.6622L132.688 69.6792L132.121 69.7147L133.547 89.7065Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M132.094 89.6181L132.661 89.5738L131.235 69.5908L130.668 69.6352L132.094 89.6181Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M130.659 89.5293L131.226 89.4849L129.8 69.502L129.233 69.5374L130.659 89.5293Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M129.242 89.4321L129.809 89.3877L128.383 69.4048L127.816 69.4403L129.242 89.4321Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M127.852 89.3252L128.419 89.2808L126.993 69.2979L126.426 69.3333L127.852 89.3252Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M126.47 89.2099L127.037 89.1744L125.611 69.1826L125.044 69.227L126.47 89.2099Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M173.014 58.6103C180.011 58.4595 186.432 58.7788 191.791 59.5061L193.535 83.977C188.336 85.4759 182.03 86.7177 175.077 87.578L173.014 58.6103Z",
    fill: "#EDE7DE"
  }))), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M123.476 72.784C123.902 78.7089 143.086 82.1502 166.336 80.465C189.585 78.7798 208.079 72.5978 207.662 66.673C207.246 60.7481 188.053 57.3068 164.803 58.992C141.554 60.6772 123.06 66.8592 123.476 72.784Z",
    fill: "url(#paint61_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M171.995 78.0961C168.036 76.473 164.05 74.912 160.118 73.2268C156.212 71.5416 152.324 69.7943 148.453 68.0293C145.052 66.4771 141.66 64.925 138.259 63.3817C142.546 62.1577 147.568 61.0933 153.085 60.2773C155.167 61.1199 157.248 61.9714 159.33 62.814C164.856 65.058 170.383 67.2754 175.945 69.4218C181.481 71.5593 187.043 73.6082 192.588 75.7369C192.8 75.8167 193.013 75.9054 193.234 75.9852C188.212 77.4487 182.128 78.6815 175.423 79.5507C174.289 79.0629 173.147 78.5751 172.004 78.105L171.995 78.0961Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 61,
    width: 67,
    height: 16
  }, _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M132.776 71.2405C133.069 75.3737 147.966 77.662 166.043 76.3493C184.121 75.0366 198.54 70.6196 198.247 66.4865C197.955 62.3533 183.058 60.0649 164.98 61.3776C146.903 62.6903 132.484 67.1073 132.776 71.2405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_13830_12464)"
  }, _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M132.776 71.2405C133.069 75.3737 147.966 77.662 166.043 76.3493C184.121 75.0366 198.54 70.6196 198.247 66.4865C197.955 62.3533 183.058 60.0649 164.98 61.3776C146.903 62.6903 132.484 67.1073 132.776 71.2405Z",
    fill: "url(#paint62_linear_13830_12464)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M165.676 79.6006C183.757 78.2893 198.171 73.8756 197.871 69.7424C197.571 65.6092 182.67 63.3216 164.589 64.6329C146.509 65.9443 132.094 70.358 132.394 74.4912C132.694 78.6244 147.595 80.912 165.676 79.6006Z",
    fill: "url(#paint63_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M190.825 74.664L155.893 61.5903L140.296 64.5616L171.995 78.4424L190.825 74.664Z",
    fill: "#EDE7DE"
  })))), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M125.044 75.4092C126.328 76.5977 127.949 77.3516 129.561 78.008L130.784 78.4781L132.032 78.8683C132.865 79.1521 133.706 79.3473 134.557 79.569C137.949 80.385 141.403 80.8994 144.866 81.2276C151.801 81.9017 158.772 81.8573 165.707 81.4139C169.17 81.1655 172.633 80.8196 176.078 80.3407C179.515 79.8262 182.951 79.232 186.335 78.4337C189.727 77.6532 193.084 76.6864 196.352 75.4624C197.982 74.8416 199.585 74.1409 201.135 73.3426C202.676 72.5266 204.191 71.6308 205.484 70.4512C202.623 72.4291 199.355 73.6087 196.069 74.6021C192.783 75.6043 189.426 76.3671 186.051 77.0235C179.293 78.3007 172.456 79.1255 165.592 79.5956C158.727 80.0746 151.837 80.1987 144.973 79.8262C141.545 79.6222 138.117 79.3118 134.734 78.7175C133.892 78.5579 133.042 78.4337 132.21 78.2208L130.952 77.9282L129.721 77.5645C128.1 77.0323 126.452 76.4558 125.044 75.4181V75.4092Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 66,
    width: 86,
    height: 32
  }, _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5797 81.0056C46.1546 75.0808 64.6569 68.8988 87.9066 67.2136C111.156 65.5284 130.341 68.9609 130.766 74.8946C130.863 76.2959 131.226 81.4136 131.333 82.815C131.758 88.7398 113.255 94.9219 90.0057 96.6071C66.756 98.2923 47.5717 94.8598 47.1465 88.9261C47.0491 87.5247 46.686 82.407 46.5797 81.0056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_13830_12464)"
  }, _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5797 81.0056C46.1546 75.0808 64.6569 68.8988 87.9066 67.2136C111.156 65.5284 130.341 68.9609 130.766 74.8946C130.863 76.2959 131.226 81.4136 131.333 82.815C131.758 88.7398 113.255 94.9219 90.0057 96.6071C66.756 98.2923 47.5717 94.8598 47.1465 88.9261C47.0491 87.5247 46.686 82.407 46.5797 81.0056Z",
    fill: "url(#paint64_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M130.243 91.5695L130.81 91.5341L129.384 71.5422L128.817 71.5866L130.243 91.5695Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M128.888 91.8801L129.455 91.8446L128.029 71.8528L127.462 71.8971L128.888 91.8801Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M127.515 92.1906L128.082 92.1463L126.656 72.1633L126.089 72.1988L127.515 92.1906Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M126.125 92.4919L126.692 92.4476L125.266 72.4646L124.699 72.5089L126.125 92.4919Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M124.716 92.7937L125.283 92.7493L123.857 72.7664L123.29 72.8018L124.716 92.7937Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M123.29 93.0866L123.848 93.0423L122.431 73.0593L121.865 73.1037L123.29 93.0866Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M121.838 93.3702L122.405 93.3348L120.979 73.3518L120.412 73.3873L121.838 93.3702Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M120.376 93.6628L120.943 93.6185L119.517 73.6355L118.95 73.671L120.376 93.6628Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M118.888 93.9382L119.455 93.9027L118.029 73.9109L117.462 73.9552L118.888 93.9382Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M117.392 94.2131L117.95 94.1687L116.533 74.1858L115.966 74.2301L117.392 94.2131Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M115.868 94.4791L116.435 94.4436L115.009 74.4607L114.442 74.4962L115.868 94.4791Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M114.327 94.7448L114.894 94.7005L113.468 74.7175L112.901 74.7619L114.327 94.7448Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M112.768 95.0022L113.335 94.9578L111.909 74.9749L111.351 75.0192L112.768 95.0022Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M111.201 95.2507L111.767 95.2063L110.342 75.2234L109.775 75.2677L111.201 95.2507Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M109.606 95.4899L110.173 95.4456L108.747 75.4626L108.18 75.507L109.606 95.4899Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M107.994 95.7203L108.561 95.6849L107.135 75.7019L106.568 75.7374L107.994 95.7203Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M106.373 95.9514L106.931 95.907L105.514 75.9241L104.948 75.9684L106.373 95.9514Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M104.726 96.1731L105.293 96.1287L103.867 76.1458L103.3 76.1812L104.726 96.1731Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 96.3772L103.628 96.3417L102.202 76.3499L101.635 76.3942L103.061 96.3772Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M101.387 96.5813L101.954 96.5369L100.528 76.554L99.9612 76.5983L101.387 96.5813Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6864 96.7677L100.253 96.7322L98.8273 76.7493L98.2693 76.7847L99.6864 96.7677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M97.977 96.9533L98.5439 96.909L97.1179 76.926L96.551 76.9704L97.977 96.9533Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2499 97.1223L96.8168 97.0868L95.3908 77.095L94.824 77.1393L96.2499 97.1223Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5051 97.2907L95.0719 97.2464L93.646 77.2634L93.0791 77.2989L94.5051 97.2907Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7424 97.4411L93.3092 97.3968L91.8833 77.4138L91.3164 77.4582L92.7424 97.4411Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9624 97.5832L91.5292 97.5389L90.1032 77.5559L89.5364 77.5914L90.9624 97.5832Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1732 97.7072L89.7401 97.6718L88.3141 77.6799L87.7561 77.7243L89.1732 97.7072Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4018 97.8229L87.9687 97.7874L86.5427 77.8044L85.9758 77.8399L87.4018 97.8229Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6391 97.9294L86.206 97.885L84.78 77.9021L84.2131 77.9464L85.6391 97.9294Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8942 98.0178L84.4611 97.9823L83.0351 77.9905L82.4683 78.0348L83.8942 98.0178Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1672 98.0974L82.7252 98.053L81.3081 78.0701L80.7412 78.1144L82.1672 98.0974Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4489 98.1687L81.0158 98.1243L79.5898 78.1414L79.0229 78.1768L80.4489 98.1687Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7485 98.2219L79.3153 98.1775L77.8894 78.1946L77.3225 78.2389L78.7485 98.2219Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0656 98.2663L77.6236 98.222L76.2065 78.239L75.6396 78.2745L77.0656 98.2663Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3918 98.2927L75.9587 98.2572L74.5327 78.2654L73.9658 78.3097L75.3918 98.2927Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7355 98.3195L74.3023 98.2752L72.8763 78.2922L72.3184 78.3277L73.7355 98.3195Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0968 98.3283L72.6637 98.284L71.2377 78.301L70.6797 78.3454L72.0968 98.3283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M70.476 98.3283L71.0428 98.284L69.6168 78.301L69.0588 78.3454L70.476 98.3283Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8728 98.3195L69.4396 98.2752L68.0136 78.2922L67.4468 78.3366L68.8728 98.3195Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2876 98.302L67.8544 98.2576L66.4284 78.2747L65.8616 78.3101L67.2876 98.302Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7109 98.2662L66.2777 98.2308L64.8518 78.2478L64.2849 78.2833L65.7109 98.2662Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1608 98.2307L64.7277 98.1952L63.3017 78.2034L62.7349 78.2477L64.1608 98.2307Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6198 98.1867L63.1867 98.1424L61.7607 78.1594L61.1938 78.2038L62.6198 98.1867Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0964 98.1335L61.6632 98.0892L60.2373 78.1062L59.6704 78.1506L61.0964 98.1335Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5907 98.071L60.1576 98.0267L58.7316 78.0437L58.1736 78.0881L59.5907 98.071Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1115 98.0002L58.6784 97.9559L57.2524 77.9729L56.6855 78.0173L58.1115 98.0002Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6413 97.9206L57.2082 97.8851L55.7822 77.8933L55.2153 77.9377L56.6413 97.9206Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1887 97.8405L55.7555 97.7962L54.3295 77.8132L53.7627 77.8487L55.1887 97.8405Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7539 97.7429L54.3207 97.7074L52.8947 77.7156L52.3279 77.7599L53.7539 97.7429Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3457 97.6457L52.9037 97.6014L51.4865 77.6184L50.9197 77.6628L52.3457 97.6457Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9462 97.5388L51.5131 97.5033L50.0871 77.5115L49.5203 77.5558L50.9462 97.5388Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5646 97.4326L50.1314 97.3882L48.7055 77.4053L48.1475 77.4496L49.5646 97.4326Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1082 66.8238C103.105 66.6641 109.527 66.9923 114.885 67.7196L116.63 92.1905C111.431 93.6894 105.125 94.9312 98.1718 95.7915L96.1082 66.8238Z",
    fill: "#EDE7DE"
  }))), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5796 81.006C47.0048 86.9308 66.1891 90.3721 89.4388 88.6869C112.688 87.0017 131.182 80.8197 130.766 74.8949C130.341 68.9701 111.156 65.5287 87.9065 67.2139C64.6568 68.8991 46.1634 75.0811 46.5796 81.006Z",
    fill: "url(#paint65_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0897 86.3095C91.1306 84.6864 87.1449 83.1254 83.2124 81.4402C79.3065 79.755 75.4182 78.0077 71.5477 76.2427C68.1466 74.6905 64.7544 73.1383 61.3533 71.595C65.6401 70.3711 70.662 69.3067 76.1799 68.4907C78.2613 69.3333 80.3427 70.1848 82.4241 71.0274C87.9509 73.2714 93.4777 75.4887 99.0399 77.6352C104.576 79.7727 110.138 81.8216 115.682 83.9502C115.895 84.0301 116.107 84.1188 116.329 84.1986C111.307 85.6621 105.222 86.8949 98.5174 87.7641C97.3837 87.2763 96.2411 86.7885 95.0985 86.3184L95.0897 86.3095Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 69,
    width: 67,
    height: 16
  }, _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8708 79.4627C56.1631 83.5958 71.0606 85.8842 89.1378 84.5715C107.215 83.2588 121.634 78.8418 121.342 74.7086C121.05 70.5754 106.152 68.2871 88.075 69.5998C69.9978 70.9125 55.5785 75.3295 55.8708 79.4627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_13830_12464)"
  }, _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8708 79.4627C56.1631 83.5958 71.0606 85.8842 89.1378 84.5715C107.215 83.2588 121.634 78.8418 121.342 74.7086C121.05 70.5754 106.152 68.2871 88.075 69.5998C69.9978 70.9125 55.5785 75.3295 55.8708 79.4627Z",
    fill: "url(#paint66_linear_13830_12464)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4902 82.7C55.7825 86.8331 70.68 89.1215 88.7572 87.8088C106.834 86.4961 121.254 82.0791 120.961 77.9459C120.669 73.8127 105.772 71.5244 87.6944 72.8371C69.6172 74.1498 55.1979 78.5668 55.4902 82.7Z",
    fill: "url(#paint67_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M113.929 82.8861L78.9878 69.8125L63.3906 72.7838L95.0899 86.6645L113.929 82.8861Z",
    fill: "#EDE7DE"
  })))), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1387 83.6314C49.4229 84.8199 51.0438 85.5738 52.6558 86.2301L53.878 86.7002L55.1269 87.0905C55.9594 87.3743 56.8008 87.5694 57.6511 87.7912C61.0434 88.6072 64.4976 89.1216 67.9607 89.4498C74.8958 90.1239 81.8662 90.0795 88.8013 89.636C92.2644 89.3877 95.7275 89.0418 99.1729 88.5628C102.609 88.0484 106.046 87.4541 109.429 86.6559C112.822 85.8754 116.178 84.9086 119.447 83.6846C121.076 83.0637 122.679 82.363 124.229 81.5648C125.771 80.7488 127.285 79.853 128.578 78.6733C125.717 80.6512 122.449 81.8309 119.163 82.8243C115.877 83.8265 112.52 84.5893 109.146 85.2456C102.388 86.5228 95.5503 87.3477 88.6861 87.8178C81.8219 88.2967 74.9312 88.4209 68.067 88.0484C64.6393 87.8444 61.2116 87.534 57.8283 86.9397C56.9868 86.7801 56.1366 86.6559 55.304 86.443L54.0463 86.1503L52.8152 85.7867C51.1943 85.2545 49.5469 84.678 48.1387 83.6403V83.6314Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 28,
    width: 86,
    height: 32
  }, _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M147.443 43.1861C147.018 37.2612 165.521 31.0792 188.77 29.394C212.02 27.7088 231.204 31.1413 231.63 37.075C231.727 38.4764 232.09 43.5941 232.196 44.9954C232.621 50.9203 214.119 57.1023 190.869 58.7875C167.62 60.4727 148.435 57.0402 148.01 51.1065C147.913 49.7051 147.55 44.5874 147.443 43.1861Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_13830_12464)"
  }, _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M147.443 43.1861C147.018 37.2612 165.521 31.0792 188.77 29.394C212.02 27.7088 231.204 31.1413 231.63 37.075C231.727 38.4764 232.09 43.5941 232.196 44.9954C232.621 50.9203 214.119 57.1023 190.869 58.7875C167.62 60.4727 148.435 57.0402 148.01 51.1065C147.913 49.7051 147.55 44.5874 147.443 43.1861Z",
    fill: "url(#paint68_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M231.107 53.7494L231.674 53.7139L230.248 33.731L229.681 33.7664L231.107 53.7494Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M229.761 54.06L230.319 54.0245L228.902 34.0327L228.335 34.0771L229.761 54.06Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M228.388 54.3701L228.955 54.3257L227.529 34.3428L226.962 34.3871L228.388 54.3701Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M226.998 54.6718L227.564 54.6275L226.138 34.6445L225.572 34.6889L226.998 54.6718Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M225.589 54.9736L226.147 54.9292L224.73 34.9463L224.163 34.9906L225.589 54.9736Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M224.154 55.2661L224.721 55.2217L223.295 35.2388L222.729 35.2831L224.154 55.2661Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M222.711 55.559L223.277 55.5147L221.852 35.5317L221.285 35.5672L222.711 55.559Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M221.24 55.8432L221.807 55.7989L220.381 35.8159L219.814 35.8603L221.24 55.8432Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M219.761 56.118L220.328 56.0826L218.902 36.0996L218.335 36.1351L219.761 56.118Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M218.256 56.3925L218.822 56.3571L217.396 36.3652L216.83 36.4096L218.256 56.3925Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M216.741 56.6674L217.299 56.6231L215.882 36.6401L215.315 36.6756L216.741 56.6674Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2 56.9248L215.767 56.8804L214.341 36.8975L213.774 36.9418L215.2 56.9248Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M213.641 57.1821L214.208 57.1377L212.782 37.1548L212.215 37.1991L213.641 57.1821Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M212.064 57.4306L212.631 57.3863L211.205 37.4033L210.638 37.4477L212.064 57.4306Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M210.479 57.6699L211.037 57.6344L209.62 37.6426L209.053 37.6869L210.479 57.6699Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M208.867 57.9096L209.434 57.8653L208.008 37.8823L207.441 37.9178L208.867 57.9096Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M207.238 58.1308L207.804 58.0865L206.378 38.1035L205.812 38.1479L207.238 58.1308Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M205.599 58.353L206.157 58.3086L204.74 38.3257L204.173 38.3612L205.599 58.353Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M203.934 58.5571L204.501 58.5216L203.075 38.5298L202.508 38.5741L203.934 58.5571Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M202.251 58.7607L202.818 58.7164L201.392 38.7334L200.834 38.7777L202.251 58.7607Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M200.559 58.956L201.126 58.9117L199.7 38.9287L199.133 38.9642L200.559 58.956Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M198.85 59.1333L199.417 59.0889L197.991 39.106L197.424 39.1503L198.85 59.1333Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M197.123 59.3021L197.681 59.2666L196.264 39.2837L195.697 39.3192L197.123 59.3021Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M195.378 59.4702L195.936 59.4258L194.519 39.4429L193.952 39.4872L195.378 59.4702Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M193.615 59.6215L194.182 59.5772L192.756 39.5942L192.189 39.6386L193.615 59.6215Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M191.835 59.7631L192.402 59.7188L190.976 39.7358L190.409 39.7802L191.835 59.7631Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M190.046 59.8871L190.613 59.8516L189.187 39.8687L188.62 39.9041L190.046 59.8871Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M188.275 60.0028L188.833 59.9673L187.415 39.9844L186.849 40.0199L188.275 60.0028Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M186.512 60.1088L187.079 60.0734L185.653 40.0815L185.086 40.1259L186.512 60.1088Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M184.767 60.1976L185.334 60.1622L183.908 40.1792L183.341 40.2147L184.767 60.1976Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M183.031 60.2778L183.598 60.2423L182.172 40.2505L181.605 40.2948L183.031 60.2778Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M181.322 60.3486L181.88 60.3042L180.463 40.3213L179.896 40.3656L181.322 60.3486Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M179.612 60.4013L180.179 60.357L178.753 40.374L178.195 40.4184L179.612 60.4013Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M177.93 60.4458L178.496 60.4014L177.071 40.4185L176.504 40.4628L177.93 60.4458Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M176.264 60.4725L176.831 60.4371L175.405 40.4541L174.838 40.4896L176.264 60.4725Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M174.608 60.499L175.175 60.4546L173.749 40.4717L173.182 40.516L174.608 60.499Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M172.97 60.5083L173.537 60.4639L172.111 40.481L171.544 40.5253L172.97 60.5083Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M171.349 60.5083L171.916 60.4639L170.49 40.481L169.923 40.5253L171.349 60.5083Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M169.746 60.499L170.312 60.4546L168.886 40.4717L168.32 40.516L169.746 60.499Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M168.152 60.4814L168.718 60.4371L167.292 40.4541L166.734 40.4984L168.152 60.4814Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M166.584 60.455L167.151 60.4107L165.725 40.4277L165.158 40.4632L166.584 60.455Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M165.025 60.4105L165.592 60.375L164.166 40.3921L163.599 40.4276L165.025 60.4105Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M163.493 60.3662L164.059 60.3307L162.633 40.3389L162.067 40.3832L163.493 60.3662Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M161.969 60.313L162.536 60.2686L161.11 40.2856L160.543 40.33L161.969 60.313Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M160.464 60.2509L161.03 60.2066L159.604 40.2236L159.038 40.268L160.464 60.2509Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M158.976 60.1801L159.542 60.1358L158.116 40.1528L157.55 40.1972L158.976 60.1801Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M157.505 60.1L158.072 60.0645L156.646 40.0815L156.088 40.117L157.505 60.1Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M156.061 60.0205L156.628 59.9761L155.202 39.9932L154.635 40.0375L156.061 60.0205Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.627 59.9227L155.194 59.8873L153.768 39.9043L153.201 39.9398L154.627 59.9227Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M153.21 59.8252L153.777 59.7897L152.351 39.7979L151.784 39.8422L153.21 59.8252Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M151.819 59.7186L152.377 59.6832L150.96 39.7002L150.393 39.7357L151.819 59.7186Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M150.437 59.6123L151.004 59.5679L149.578 39.585L149.011 39.6293L150.437 59.6123Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M196.981 29.0039C203.978 28.8443 210.399 29.1725 215.758 29.8998L217.502 54.3707C212.303 55.8696 205.997 57.1113 199.044 57.9717L196.981 29.0039Z",
    fill: "#EDE7DE"
  }))), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.443 43.1861C147.869 49.111 167.053 52.5523 190.303 50.8671C213.552 49.1819 232.046 42.9999 231.629 37.0751C231.204 31.1502 212.02 27.7089 188.77 29.3941C165.521 31.0793 147.027 37.2613 147.443 43.1861Z",
    fill: "url(#paint69_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.962 48.499C192.003 46.8759 188.017 45.3148 184.085 43.6296C180.179 41.9444 176.291 40.1971 172.42 38.4321C169.019 36.8799 165.627 35.3278 162.226 33.7845C166.513 32.5605 171.535 31.4962 177.052 30.6802C179.134 31.5228 181.215 32.3742 183.297 33.2169C188.823 35.4608 194.35 37.6782 199.912 39.8246C205.448 41.9622 211.01 44.011 216.555 46.1397C216.767 46.2195 216.98 46.3082 217.201 46.388C212.179 47.8515 206.095 49.0844 199.39 49.9447C198.256 49.4569 197.114 48.9691 195.971 48.499H195.962Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 31,
    width: 67,
    height: 17
  }, _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M156.734 41.6428C157.027 45.776 171.924 48.0643 190.001 46.7517C208.079 45.439 222.498 41.022 222.205 36.8888C221.913 32.7556 207.016 30.4673 188.938 31.78C170.861 33.0927 156.442 37.5097 156.734 41.6428Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_13830_12464)"
  }, _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M156.734 41.6428C157.027 45.776 171.924 48.0643 190.001 46.7517C208.079 45.439 222.498 41.022 222.205 36.8888C221.913 32.7556 207.016 30.4673 188.938 31.78C170.861 33.0927 156.442 37.5097 156.734 41.6428Z",
    fill: "url(#paint70_linear_13830_12464)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.362 44.8801C156.655 49.0133 171.552 51.3017 189.629 49.989C207.706 48.6763 222.126 44.2593 221.833 40.1261C221.541 35.9929 206.644 33.7046 188.566 35.0173C170.489 36.33 156.07 40.747 156.362 44.8801Z",
    fill: "url(#paint71_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M214.792 45.0663L179.86 31.9927L164.263 34.964L195.962 48.8447L214.792 45.0663Z",
    fill: "#EDE7DE"
  })))), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M149.011 45.8116C150.295 47.0001 151.916 47.754 153.528 48.4103L154.751 48.8804L155.999 49.2707C156.832 49.5545 157.673 49.7496 158.524 49.9713C161.916 50.7873 165.37 51.3018 168.833 51.6299C175.768 52.304 182.739 52.2597 189.674 51.8162C193.137 51.5679 196.6 51.2219 200.045 50.743C203.482 50.2286 206.918 49.6343 210.302 48.8361C213.694 48.0555 217.051 47.0888 220.319 45.8648C221.949 45.2439 223.552 44.5432 225.102 43.745C226.643 42.929 228.158 42.0332 229.451 40.8535C226.59 42.8314 223.322 44.0111 220.036 45.0044C216.75 46.0067 213.393 46.7695 210.018 47.4258C203.261 48.703 196.423 49.5279 189.559 49.998C182.695 50.4769 175.804 50.6011 168.94 50.2286C165.512 50.0246 162.084 49.7141 158.701 49.1199C157.859 48.9602 157.009 48.8361 156.177 48.6232L154.919 48.3305L153.688 47.9668C152.067 47.4347 150.419 46.8582 149.011 45.8204V45.8116Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 45,
    width: 85,
    height: 31
  }, _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0821 59.8521C85.657 53.9273 104.159 47.7452 127.409 46.06C150.659 44.3748 169.843 47.8073 170.268 53.741C170.366 55.1424 170.729 60.2601 170.835 61.6614C171.26 67.5863 152.758 73.7683 129.508 75.4535C106.258 77.1387 87.0741 73.7062 86.649 67.7725C86.5516 66.3711 86.1884 61.2535 86.0821 59.8521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_13830_12464)"
  }, _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0821 59.8521C85.657 53.9273 104.159 47.7452 127.409 46.06C150.659 44.3748 169.843 47.8073 170.268 53.741C170.366 55.1424 170.729 60.2601 170.835 61.6614C171.26 67.5863 152.758 73.7683 129.508 75.4535C106.258 77.1387 87.0741 73.7062 86.649 67.7725C86.5516 66.3711 86.1884 61.2535 86.0821 59.8521Z",
    fill: "url(#paint72_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M169.746 70.4155L170.312 70.3711L168.886 50.3882L168.32 50.4325L169.746 70.4155Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M168.391 70.726L168.957 70.6817L167.531 50.6987L166.973 50.7431L168.391 70.726Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M167.027 71.0361L167.585 70.9917L166.167 51.0088L165.601 51.0443L167.027 71.0361Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M165.636 71.3374L166.194 71.293L164.777 51.3101L164.21 51.3455L165.636 71.3374Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M164.219 71.6307L164.786 71.5953L163.36 51.6123L162.802 51.6478L164.219 71.6307Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M162.793 71.9321L163.36 71.8877L161.934 51.9048L161.367 51.9403L162.793 71.9321Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M161.349 72.2158L161.916 72.1803L160.49 52.1885L159.923 52.2328L161.349 72.2158Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M159.879 72.4999L160.446 72.4644L159.02 52.4814L158.453 52.5169L159.879 72.4999Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M158.4 72.7837L158.967 72.7393L157.541 52.7563L156.974 52.8007L158.4 72.7837Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M156.894 73.0586L157.461 73.0142L156.035 53.0312L155.468 53.0756L156.894 73.0586Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M155.371 73.3247L155.938 73.2892L154.512 53.2974L153.954 53.3417L155.371 73.3247Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M153.838 73.5903L154.405 73.5459L152.979 53.563L152.412 53.6073L153.838 73.5903Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M152.279 73.8481L152.846 73.8038L151.42 53.8208L150.854 53.8563L152.279 73.8481Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M150.703 74.0962L151.27 74.0518L149.844 54.0688L149.277 54.1043L150.703 74.0962Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M149.118 74.3359L149.676 74.2916L148.258 54.3086L147.692 54.3529L149.118 74.3359Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M147.506 74.5664L148.072 74.5309L146.646 54.5391L146.08 54.5834L147.506 74.5664Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M145.876 74.7968L146.443 74.7525L145.017 54.7695L144.45 54.8139L145.876 74.7968Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M144.228 75.0101L144.795 74.9747L143.369 54.9917L142.811 55.0272L144.228 75.0101Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M142.572 75.2226L143.139 75.1783L141.713 55.1953L141.146 55.2397L142.572 75.2226Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M140.89 75.4267L141.456 75.3824L140.03 55.3994L139.472 55.4349L140.89 75.4267Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M139.198 75.6128L139.765 75.5773L138.339 55.5854L137.772 55.6298L139.198 75.6128Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M137.488 75.7988L138.055 75.7544L136.629 55.7715L136.062 55.8158L137.488 75.7988Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M135.761 75.9677L136.319 75.9323L134.902 55.9404L134.335 55.9848L135.761 75.9677Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M134.007 76.1273L134.574 76.0918L133.148 56.1089L132.59 56.1444L134.007 76.1273Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M132.254 76.2871L132.812 76.2427L131.395 56.2598L130.828 56.2952L132.254 76.2871Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M130.474 76.4203L131.04 76.3848L129.614 56.4019L129.048 56.4373L130.474 76.4203Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.684 76.5527L129.251 76.5084L127.825 56.5254L127.258 56.5697L128.684 76.5527Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M126.913 76.6684L127.471 76.6329L126.054 56.6411L125.487 56.6855L126.913 76.6684Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M125.15 76.7749L125.717 76.7305L124.291 56.7476L123.724 56.7919L125.15 76.7749Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M123.406 76.8632L123.964 76.8189L122.547 56.8359L121.98 56.8803L123.406 76.8632Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M121.67 76.9433L122.236 76.899L120.811 56.916L120.244 56.9604L121.67 76.9433Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 77.0057L120.518 76.9703L119.092 56.9873L118.534 57.0228L119.951 77.0057Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M118.251 77.0673L118.818 77.023L117.392 57.04L116.834 57.0755L118.251 77.0673Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M116.568 77.1029L117.135 77.0674L115.709 57.0845L115.142 57.12L116.568 77.1029Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M114.903 77.1381L115.47 77.0938L114.044 57.1108L113.477 57.1552L114.903 77.1381Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M113.247 77.1561L113.814 77.1207L112.388 57.1377L111.821 57.1732L113.247 77.1561Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M111.608 77.1738L112.175 77.1294L110.749 57.1465L110.182 57.182L111.608 77.1738Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M109.987 77.1738L110.554 77.1294L109.128 57.1465L108.561 57.1908L109.987 77.1738Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M108.384 77.165L108.951 77.1207L107.525 57.1377L106.958 57.1732L108.384 77.165Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M106.79 77.1474L107.357 77.1031L105.931 57.1201L105.364 57.1556L106.79 77.1474Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M105.222 77.1118L105.789 77.0763L104.363 57.0845L103.796 57.1288L105.222 77.1118Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M103.664 77.0761L104.23 77.0318L102.804 57.0488L102.238 57.0932L103.664 77.0761Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M102.131 77.0322L102.689 76.9878L101.272 57.0049L100.705 57.0492L102.131 77.0322Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M100.608 76.979L101.174 76.9346L99.7485 56.9517L99.1816 56.996L100.608 76.979Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M99.102 76.917L99.6689 76.8726L98.2429 56.8896L97.676 56.934L99.102 76.917Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M97.614 76.8457L98.1808 76.8013L96.7548 56.8184L96.188 56.8627L97.614 76.8457Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1437 76.7661L96.7105 76.7217L95.2846 56.7388L94.7266 56.7831L96.1437 76.7661Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6999 76.6776L95.2579 76.6421L93.8408 56.6592L93.2739 56.6947L94.6999 76.6776Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2651 76.5888L93.8319 76.5445L92.406 56.5615L91.8391 56.6059L93.2651 76.5888Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8481 76.4912L92.415 76.4468L90.989 56.4639L90.4221 56.5082L91.8481 76.4912Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4575 76.3842L91.0155 76.3488L89.5983 56.3569L89.0315 56.4013L90.4575 76.3842Z",
    fill: "#B17D27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0759 76.2783L89.6427 76.2339L88.2168 56.251L87.6499 56.2865L89.0759 76.2783Z",
    fill: "#B17D27"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M135.62 45.6693C142.617 45.5186 149.038 45.8379 154.397 46.5652L156.141 71.0361C150.942 72.535 144.636 73.7768 137.683 74.6371L135.62 45.6693Z",
    fill: "#EDE7DE"
  }))), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0821 59.8522C86.5072 65.777 105.692 69.2183 128.941 67.5331C152.191 65.8479 170.684 59.6659 170.268 53.7411C169.843 47.8163 150.659 44.3749 127.409 46.0601C104.159 47.7453 85.6658 53.9273 86.0821 59.8522Z",
    fill: "url(#paint73_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M134.601 65.1562C130.642 63.5331 126.656 61.9721 122.724 60.2869C118.818 58.6017 114.929 56.8544 111.059 55.0893C107.658 53.5372 104.266 51.985 100.865 50.4417C105.151 49.2177 110.173 48.1534 115.691 47.3374C117.773 48.18 119.854 49.0315 121.935 49.8741C127.462 52.1181 132.989 54.3354 138.551 56.4818C144.087 58.6194 149.649 60.6682 155.194 62.7969C155.406 62.8767 155.619 62.9654 155.84 63.0453C150.818 64.5087 144.733 65.7416 138.029 66.6108C136.895 66.123 135.752 65.6352 134.61 65.1651L134.601 65.1562Z",
    fill: "#EDE7DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 48,
    width: 66,
    height: 16
  }, _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3733 58.3089C95.6655 62.442 110.563 64.7304 128.64 63.4177C146.717 62.105 161.137 57.688 160.844 53.5548C160.552 49.4216 145.655 47.1333 127.577 48.446C109.5 49.7587 95.081 54.1757 95.3733 58.3089Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_13830_12464)"
  }, _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3733 58.3089C95.6655 62.442 110.563 64.7304 128.64 63.4177C146.717 62.105 161.137 57.688 160.844 53.5548C160.552 49.4216 145.655 47.1333 127.577 48.446C109.5 49.7587 95.081 54.1757 95.3733 58.3089Z",
    fill: "url(#paint74_linear_13830_12464)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M128.277 66.6631C146.358 65.3518 160.772 60.9381 160.472 56.8049C160.172 52.6717 145.271 50.3841 127.191 51.6954C109.11 53.0068 94.6954 57.4205 94.9954 61.5537C95.2954 65.6869 110.196 67.9745 128.277 66.6631Z",
    fill: "url(#paint75_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M153.431 61.7323L118.499 48.6587L102.902 51.6211L134.592 65.5107L153.431 61.7323Z",
    fill: "#EDE7DE"
  })))), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6499 62.4683C88.9342 63.6568 90.555 64.4107 92.167 65.0671L93.3893 65.5371L94.6381 65.9274C95.4707 66.2112 96.3121 66.4064 97.1624 66.6281C100.555 67.4441 104.009 67.9585 107.472 68.2867C114.407 68.9608 121.377 68.9164 128.313 68.4729C131.776 68.2246 135.239 67.8787 138.684 67.3997C142.121 66.8853 145.557 66.291 148.941 65.4928C152.333 64.7123 155.69 63.7455 158.958 62.5215C160.588 61.9007 162.191 61.2 163.741 60.4017C165.282 59.5857 166.796 58.6899 168.089 57.5103C165.229 59.4881 161.96 60.6678 158.674 61.6612C155.388 62.6634 152.032 63.4262 148.657 64.0825C141.899 65.3598 135.062 66.1846 128.197 66.6547C121.333 67.1337 114.442 67.2578 107.578 66.8853C104.151 66.6813 100.723 66.3709 97.3395 65.7766C96.4981 65.617 95.6478 65.4928 94.8152 65.2799L93.5575 64.9872L92.3264 64.6236C90.7056 64.0914 89.0582 63.5149 87.6499 62.4772V62.4683Z",
    fill: "#ECCE8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 19,
    width: 86,
    height: 32
  }, _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M204.457 33.9712C204.032 28.0464 222.534 21.8644 245.784 20.1792C269.033 18.494 288.218 21.9265 288.643 27.8601C288.74 29.2615 289.103 34.3792 289.21 35.7806C289.635 41.7054 271.132 47.8874 247.883 49.5726C224.633 51.2579 205.449 47.8254 205.023 41.8917C204.926 40.4903 204.563 35.3726 204.457 33.9712Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_13830_12464)"
  }, _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M204.457 33.9712C204.032 28.0464 222.534 21.8644 245.784 20.1792C269.033 18.494 288.218 21.9265 288.643 27.8601C288.74 29.2615 289.103 34.3792 289.21 35.7806C289.635 41.7054 271.132 47.8874 247.883 49.5726C224.633 51.2579 205.449 47.8254 205.023 41.8917C204.926 40.4903 204.563 35.3726 204.457 33.9712Z",
    fill: "url(#paint76_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M288.12 44.5439L288.687 44.4996L287.261 24.5166L286.694 24.5609L288.12 44.5439Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M286.765 44.8545L287.332 44.8101L285.906 24.8271L285.339 24.8715L286.765 44.8545Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M285.392 45.1561L285.959 45.1207L284.533 25.1377L283.966 25.1732L285.392 45.1561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M284.002 45.4663L284.569 45.4219L283.143 25.439L282.576 25.4744L284.002 45.4663Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M282.593 45.7587L283.16 45.7233L281.734 25.7314L281.167 25.7758L282.593 45.7587Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M281.167 46.0516L281.734 46.0162L280.308 26.0332L279.741 26.0687L281.167 46.0516Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M279.715 46.3442L280.282 46.3087L278.856 26.3169L278.289 26.3612L279.715 46.3442Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M278.253 46.6283L278.82 46.5928L277.394 26.6099L276.827 26.6453L278.253 46.6283Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M276.765 46.9121L277.332 46.8677L275.906 26.8848L275.339 26.9291L276.765 46.9121Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M275.269 47.187L275.836 47.1426L274.41 27.1597L273.843 27.204L275.269 47.187Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M273.745 47.4531L274.312 47.4087L272.886 27.4258L272.319 27.4701L273.745 47.4531Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M272.204 47.7192L272.771 47.6749L271.345 27.6919L270.778 27.7274L272.204 47.7192Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M270.654 47.9677L271.212 47.9322L269.795 27.9492L269.228 27.9847L270.654 47.9677Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M269.078 48.2246L269.644 48.1802L268.218 28.1973L267.652 28.2327L269.078 48.2246Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M267.483 48.4643L268.05 48.42L266.624 28.437L266.057 28.4814L267.483 48.4643Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M265.871 48.6948L266.438 48.6593L265.012 28.6675L264.454 28.7118L265.871 48.6948Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M264.25 48.9253L264.817 48.8809L263.391 28.8979L262.824 28.9334L264.25 48.9253Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M262.603 49.1381L263.17 49.1027L261.744 29.1108L261.177 29.1552L262.603 49.1381Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M260.938 49.351L261.505 49.3067L260.088 29.3237L259.521 29.3681L260.938 49.351Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M259.264 49.5463L259.831 49.5108L258.405 29.5278L257.838 29.5633L259.264 49.5463Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M257.572 49.7417L258.13 49.6973L256.713 29.7144L256.146 29.7587L257.572 49.7417Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M255.854 49.9277L256.421 49.8833L254.995 29.9004L254.428 29.9359L255.854 49.9277Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M254.127 50.0961L254.694 50.0518L253.268 30.0688L252.701 30.1132L254.127 50.0961Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M252.382 50.2558L252.949 50.2203L251.523 30.2285L250.956 30.2729L252.382 50.2558Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M250.619 50.4066L251.186 50.3711L249.76 30.3882L249.193 30.4237L250.619 50.4066Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M248.839 50.5483L249.406 50.5128L247.98 30.521L247.422 30.5653L248.839 50.5483Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M247.059 50.6816L247.617 50.6373L246.2 30.6543L245.633 30.6986L247.059 50.6816Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M245.279 50.7973L245.846 50.753L244.42 30.77L243.853 30.8144L245.279 50.7973Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M243.516 50.9033L244.083 50.8589L242.657 30.876L242.09 30.9203L243.516 50.9033Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M241.771 50.9917L242.338 50.9473L240.912 30.9644L240.345 31.0087L241.771 50.9917Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M240.044 51.0717L240.611 51.0274L239.185 31.0444L238.618 31.0888L240.044 51.0717Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M238.326 51.1338L238.893 51.0983L237.467 31.1064L236.9 31.1508L238.326 51.1338Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M236.625 51.1874L237.192 51.1519L235.766 31.1689L235.199 31.2044L236.625 51.1874Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M234.943 51.2314L235.509 51.1959L234.083 31.2041L233.517 31.2484L234.943 51.2314Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M233.269 51.267L233.835 51.2227L232.409 31.2397L231.843 31.2841L233.269 51.267Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M231.621 51.2846L232.179 51.2492L230.762 31.2573L230.195 31.3017L231.621 51.2846Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M229.983 51.3022L230.549 51.2579L229.123 31.2749L228.557 31.3104L229.983 51.3022Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M228.362 51.3022L228.92 51.2579L227.503 31.2749L226.936 31.3104L228.362 51.3022Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M226.75 51.2934L227.317 51.2491L225.891 31.2661L225.324 31.3016L226.75 51.2934Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M225.165 51.267L225.731 51.2315L224.305 31.2485L223.739 31.284L225.165 51.267Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M223.588 51.2407L224.155 51.2052L222.729 31.2134L222.171 31.2577L223.588 51.2407Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M222.038 51.2045L222.605 51.1602L221.179 31.1772L220.612 31.2216L222.038 51.2045Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M220.497 51.1606L221.064 51.1163L219.638 31.1333L219.071 31.1776L220.497 51.1606Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M218.973 51.1074L219.54 51.063L218.114 31.0801L217.556 31.1156L218.973 51.1074Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M217.477 51.0454L218.035 51.001L216.617 31.0181L216.051 31.0535L217.477 51.0454Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M215.988 50.9741L216.555 50.9297L215.129 30.9468L214.562 30.9823L215.988 50.9741Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M214.518 50.894L215.085 50.8497L213.659 30.8667L213.092 30.911L214.518 50.894Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M213.066 50.8056L213.632 50.7701L212.206 30.7783L211.64 30.8227L213.066 50.8056Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M211.631 50.7172L212.198 50.6729L210.772 30.6899L210.214 30.7343L211.631 50.7172Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M210.223 50.6196L210.789 50.5752L209.363 30.5923L208.797 30.6366L210.223 50.6196Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M208.823 50.5131L209.39 50.4688L207.964 30.4858L207.397 30.5302L208.823 50.5131Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M207.45 50.4067L208.008 50.3624L206.591 30.3794L206.024 30.4149L207.45 50.4067Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M253.985 19.7979C260.982 19.6382 267.404 19.9664 272.762 20.6937L274.507 45.1646C269.308 46.6636 263.002 47.9053 256.049 48.7656L253.985 19.7979Z",
    fill: "#FFFAEF"
  }))), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M247.325 41.6674C270.572 39.9813 289.069 33.8104 288.639 27.8842C288.209 21.9579 269.014 18.5206 245.767 20.2066C222.519 21.8927 204.022 28.0637 204.452 33.9899C204.882 39.9161 224.077 43.3535 247.325 41.6674Z",
    fill: "url(#paint77_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M252.975 39.2841C249.016 37.661 245.031 36.1 241.098 34.4148C237.192 32.7296 233.304 30.9823 229.433 29.2173C226.032 27.6651 222.64 26.1129 219.239 24.5697C223.526 23.3457 228.548 22.2813 234.066 21.4653C236.147 22.3079 238.228 23.1594 240.31 24.002C245.837 26.246 251.363 28.4634 256.926 30.6098C262.461 32.7473 268.024 34.7962 273.568 36.9248C273.781 37.0047 273.993 37.0934 274.215 37.1732C269.193 38.6367 263.108 39.8695 256.403 40.7387C255.269 40.2509 254.127 39.7631 252.984 39.293L252.975 39.2841Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 22,
    width: 67,
    height: 16
  }, _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M213.748 32.4368C214.04 36.57 228.937 38.8583 247.015 37.5456C265.092 36.2329 279.511 31.8159 279.219 27.6827C278.926 23.5496 264.029 21.2612 245.952 22.5739C227.874 23.8866 213.455 28.3036 213.748 32.4368Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_13830_12464)"
  }, _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M213.748 32.4368C214.04 36.57 228.937 38.8583 247.015 37.5456C265.092 36.2329 279.511 31.8159 279.219 27.6827C278.926 23.5496 264.029 21.2612 245.952 22.5739C227.874 23.8866 213.455 28.3036 213.748 32.4368Z",
    fill: "url(#paint78_linear_13830_12464)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M213.376 35.6743C213.668 39.8075 228.566 42.0958 246.643 40.7832C264.72 39.4705 279.139 35.0535 278.847 30.9203C278.555 26.7871 263.657 24.4988 245.58 25.8115C227.503 27.1241 213.083 31.5411 213.376 35.6743Z",
    fill: "url(#paint79_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M271.806 35.8515L236.865 22.7778L221.267 25.7491L252.967 39.6387L271.806 35.8515Z",
    fill: "#FFFAEF"
  })))), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M206.015 36.5967C207.3 37.7852 208.92 38.5391 210.532 39.1955L211.755 39.6656L213.004 40.0558C213.836 40.3396 214.678 40.5348 215.528 40.7565C218.92 41.5725 222.374 42.0869 225.837 42.4151C232.772 43.0892 239.743 43.0448 246.678 42.6014C250.141 42.353 253.604 42.0071 257.05 41.5282C260.486 41.0137 263.923 40.4195 267.306 39.6212C270.698 38.8407 274.055 37.8739 277.323 36.6499C278.953 36.0291 280.556 35.3284 282.106 34.5301C283.647 33.7141 285.162 32.8183 286.455 31.6387C283.594 33.6166 280.326 34.7962 277.04 35.7896C273.754 36.7918 270.397 37.5546 267.023 38.211C260.265 39.4882 253.427 40.313 246.563 40.7831C239.699 41.2621 232.808 41.3862 225.944 41.0137C222.516 40.8097 219.088 40.4993 215.705 39.905C214.864 39.7454 214.013 39.6212 213.181 39.4083L211.923 39.1157L210.692 38.752C209.071 38.2198 207.424 37.6433 206.015 36.6056V36.5967Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 50,
    width: 85,
    height: 30
  }, _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M0.266453 59.9941C0.408165 54.0515 19.4153 49.7055 42.7182 50.2909C66.021 50.8763 84.7891 56.1625 84.6385 62.105C84.6031 63.5064 84.4791 68.6418 84.4436 70.0432C84.3019 75.9858 65.2947 80.3318 41.9919 79.7464C18.6979 79.1522 -0.0701144 73.866 0.071598 67.9234C0.107026 66.522 0.231025 61.3866 0.266453 59.9852V59.9941Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_13830_12464)"
  }, _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M0.266453 59.9941C0.408165 54.0515 19.4153 49.7055 42.7182 50.2909C66.021 50.8763 84.7891 56.1625 84.6385 62.105C84.6031 63.5064 84.4791 68.6418 84.4436 70.0432C84.3019 75.9858 65.2947 80.3318 41.9919 79.7464C18.6979 79.1522 -0.0701144 73.866 0.071598 67.9234C0.107026 66.522 0.231025 61.3866 0.266453 59.9852V59.9941Z",
    fill: "url(#paint80_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M83.02 58.6182L82.5242 78.6482L83.0908 78.6623L83.5867 58.6322L83.02 58.6182Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6399 58.7905L81.144 78.8206L81.7107 78.8346L82.2065 58.8046L81.6399 58.7905Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M80.25 58.9717L79.7542 79.0017L80.3208 79.0158L80.8166 58.9858L80.25 58.9717Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M78.833 59.1265L78.3372 79.1565L78.9038 79.1706L79.3997 59.1405L78.833 59.1265Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4041 59.296L76.9048 79.3259L77.4715 79.3401L77.9708 59.3102L77.4041 59.296Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9598 59.4503L75.4604 79.4802L76.0271 79.4944L76.5264 59.4645L75.9598 59.4503Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4829 59.5889L73.9871 79.6189L74.5537 79.633L75.0496 59.6029L74.4829 59.5889Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0022 59.7339L72.5063 79.7639L73.073 79.778L73.5688 59.748L73.0022 59.7339Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4996 59.8673L71.0002 79.8972L71.5669 79.9114L72.0662 59.8814L71.4996 59.8673Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9825 60.003L69.4832 80.033L70.0498 80.0471L70.5491 60.0172L69.9825 60.003Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4338 60.1148L67.938 80.1448L68.5047 80.1588L69.0005 60.1288L68.4338 60.1148Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8848 60.2296L66.3855 80.2595L66.9522 80.2737L67.4515 60.2438L66.8848 60.2296Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3042 60.3292L64.8049 80.3591L65.3716 80.3733L65.8709 60.3434L65.3042 60.3292Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7237 60.4195L63.2244 80.4495L63.791 80.4636L64.2904 60.4337L63.7237 60.4195Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M62.107 60.5099L61.6077 80.5398L62.1743 80.554L62.6737 60.524L62.107 60.5099Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4868 60.585L59.991 80.615L60.5576 80.6291L61.0535 60.599L60.4868 60.585Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8457 60.6549L58.3464 80.6848L58.9131 80.699L59.4124 60.669L58.8457 60.6549Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1899 60.7109L56.6941 80.741L57.2608 80.755L57.7566 60.725L57.1899 60.7109Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M55.512 60.7623L55.0127 80.7922L55.5794 80.8064L56.0787 60.7765L55.512 60.7623Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8223 60.7896L53.323 80.8196L53.8897 80.8337L54.389 60.8038L53.8223 60.7896Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M52.113 60.8184L51.6172 80.8484L52.1839 80.8625L52.6797 60.8324L52.113 60.8184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3967 60.8276L49.9009 80.8577L50.4676 80.8717L50.9634 60.8417L50.3967 60.8276Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6626 60.8424L48.1633 80.8723L48.73 80.8865L49.2293 60.8565L48.6626 60.8424Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9001 60.8262L46.4043 80.8562L46.971 80.8703L47.4668 60.8402L46.9001 60.8262Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1379 60.8071L44.6421 80.8372L45.2088 80.8512L45.7046 60.8212L45.1379 60.8071Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3491 60.7705L42.8533 80.8005L43.4199 80.8146L43.9158 60.7846L43.3491 60.7705Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5595 60.7334L41.0637 80.7634L41.6304 80.7775L42.1262 60.7475L41.5595 60.7334Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7881 60.6671L39.2888 80.697L39.8555 80.7112L40.3548 60.6813L39.7881 60.6671Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0259 60.6026L37.5266 80.6326L38.0933 80.6467L38.5926 60.6168L38.0259 60.6026Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2739 60.5317L35.7781 80.5618L36.3448 80.5758L36.8406 60.5458L36.2739 60.5317Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5483 60.4312L34.0525 80.4612L34.6192 80.4752L35.115 60.4452L34.5483 60.4312Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8389 60.337L32.3396 80.3669L32.9063 80.3811L33.4056 60.3512L32.8389 60.337Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1314 60.2184L30.6321 80.2483L31.1988 80.2625L31.6981 60.2325L31.1314 60.2184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M29.451 60.0992L28.9517 80.1292L29.5183 80.1433L30.0176 60.1134L29.451 60.0992Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7912 59.9741L27.2954 80.0042L27.8621 80.0182L28.3579 59.9882L27.7912 59.9741Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1446 59.8346L25.6453 79.8645L26.2119 79.8787L26.7112 59.8487L26.1446 59.8346Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5041 59.6821L24.0083 79.7122L24.575 79.7262L25.0708 59.6962L24.5041 59.6821Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9017 59.524L22.4023 79.554L22.969 79.5681L23.4683 59.5382L22.9017 59.524Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3028 59.36L20.8035 79.3899L21.3701 79.4041L21.8695 59.3741L21.3028 59.36Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7177 59.1807L19.2219 79.2107L19.7886 79.2248L20.2844 59.1947L19.7177 59.1807Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1602 59.0045L17.6609 79.0344L18.2276 79.0486L18.7269 59.0187L18.1602 59.0045Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M16.616 58.8214L16.1167 78.8513L16.6834 78.8655L17.1827 58.8356L16.616 58.8214Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 58.6157L14.5901 78.6458L15.1568 78.6598L15.6526 58.6298L15.0859 58.6157Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5781 58.4233L13.0823 78.4534L13.649 78.4674L14.1448 58.4374L13.5781 58.4233Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0801 58.2139L11.5842 78.2439L12.1509 78.258L12.6467 58.2279L12.0801 58.2139Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6121 57.9923L10.1128 78.0222L10.6795 78.0364L11.1788 58.0065L10.6121 57.9923Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15898 57.773L8.65967 77.803L9.22634 77.8171L9.72565 57.7872L9.15898 57.773Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72946 57.5576L7.23364 77.5876L7.80032 77.6017L8.29614 57.5717L7.72946 57.5576Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31523 57.3268L5.81592 77.3567L6.38259 77.3709L6.8819 57.3409L6.31523 57.3268Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90776 57.0807L4.40845 77.1106L4.97512 77.1248L5.47443 57.0948L4.90776 57.0807Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52512 56.8384L3.0293 76.8684L3.59597 76.8825L4.09179 56.8525L3.52512 56.8384Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16373 56.6009L1.66699 76.6309L2.23367 76.6449L2.73041 56.6149L2.16373 56.6009Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9198 50.6992C57.8992 51.2225 64.2674 52.1716 69.5196 53.4222L68.9173 77.9463C63.6031 78.9308 57.2083 79.5605 50.2024 79.7379L50.911 50.7081L50.9198 50.6992Z",
    fill: "#FFFAEF"
  }))), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6322 62.0939C84.7805 56.1539 66.0154 50.8673 42.719 50.286C19.4226 49.7047 0.416956 54.0488 0.268608 59.9888C0.12026 65.9288 18.8854 71.2154 42.1818 71.7967C65.4781 72.378 84.4838 68.0339 84.6322 62.0939Z",
    fill: "url(#paint81_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0501 69.9989C44.2682 67.9944 40.4508 66.0608 36.6954 63.9942C32.9666 61.9365 29.2732 59.8256 25.5799 57.688C22.347 55.8166 19.1142 53.9362 15.8726 52.0648C20.2568 51.2576 25.3584 50.69 30.9295 50.415C32.9223 51.4616 34.9063 52.4994 36.8991 53.546C42.1868 56.3133 47.4744 59.0628 52.8064 61.7414C58.1117 64.4022 63.4525 66.9832 68.7667 69.6441C68.9704 69.7505 69.1741 69.8481 69.3867 69.9545C64.2496 70.9213 58.0763 71.551 51.3184 71.7639C50.229 71.1696 49.1484 70.5754 48.0501 69.99V69.9989Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 52,
    width: 67,
    height: 16
  }, _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66381 59.3554C9.56639 63.4975 24.1716 67.2227 42.2931 67.675C60.4146 68.1273 75.1881 65.1383 75.2855 60.9874C75.383 56.8454 60.7777 53.1202 42.6562 52.6678C24.5348 52.2155 9.76124 55.2045 9.66381 59.3554Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_13830_12464)"
  }, _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66381 59.3554C9.56639 63.4975 24.1716 67.2227 42.2931 67.675C60.4146 68.1273 75.1881 65.1383 75.2855 60.9874C75.383 56.8454 60.7777 53.1202 42.6562 52.6678C24.5348 52.2155 9.76124 55.2045 9.66381 59.3554Z",
    fill: "url(#paint82_linear_13830_12464)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6004 64.1886C74.7039 60.0458 60.0964 56.3207 41.9738 55.8685C23.8511 55.4163 9.07596 58.4082 8.9725 62.551C8.86903 66.6938 23.4765 70.4188 41.5991 70.871C59.7218 71.3232 74.4969 68.3314 74.6004 64.1886Z",
    fill: "url(#paint83_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1193 68.4199L33.5954 52.0024L17.7856 53.4393L48.0147 70.3445L67.1193 68.4199Z",
    fill: "#FFFAEF"
  })))), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56836 62.7525C2.73749 64.0652 4.27861 64.9699 5.81973 65.777L6.99772 66.3624L8.20227 66.8768C8.9994 67.2405 9.82311 67.5154 10.6468 67.8259C13.9416 68.97 17.3339 69.8126 20.7527 70.4778C27.5903 71.826 34.5342 72.4646 41.487 72.6952C44.9589 72.7839 48.4397 72.775 51.9117 72.6331C55.3837 72.4557 58.8556 72.1985 62.3098 71.7284C65.7641 71.2761 69.1918 70.6464 72.5663 69.7505C74.2491 69.2893 75.9054 68.7483 77.5351 68.1097C79.1471 67.4534 80.7413 66.6994 82.1319 65.6528C79.0939 67.3469 75.7282 68.1984 72.3626 68.8636C68.9969 69.5466 65.5781 69.9723 62.1593 70.2916C55.3128 70.9125 48.422 71.0632 41.549 70.8592C34.6759 70.6641 27.8029 70.1231 21.0095 69.0765C17.6173 68.5443 14.2339 67.8968 10.9214 66.9744C10.0977 66.7349 9.26512 66.5221 8.45913 66.2294L7.23686 65.8125L6.04116 65.3335C4.48232 64.6417 2.88806 63.9144 1.59493 62.7437L1.56836 62.7525Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 33,
    width: 86,
    height: 31
  }, _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9664 47.6743C53.5413 41.7495 72.0436 35.5675 95.2933 33.8823C118.543 32.1971 137.727 35.6296 138.152 41.5633C138.25 42.9646 138.613 48.0823 138.719 49.4837C139.144 55.4085 120.642 61.5906 97.3924 63.2758C74.1427 64.961 54.9584 61.5285 54.5333 55.5948C54.4358 54.1934 54.0727 49.0757 53.9664 47.6743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_13830_12464)"
  }, _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9664 47.6743C53.5413 41.7495 72.0436 35.5675 95.2933 33.8823C118.543 32.1971 137.727 35.6296 138.152 41.5633C138.25 42.9646 138.613 48.0823 138.719 49.4837C139.144 55.4085 120.642 61.5906 97.3924 63.2758C74.1427 64.961 54.9584 61.5285 54.5333 55.5948C54.4358 54.1934 54.0727 49.0757 53.9664 47.6743Z",
    fill: "url(#paint84_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M137.63 58.2382L138.197 58.2028L136.771 38.2109L136.204 38.2553L137.63 58.2382Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M136.275 58.5483L136.842 58.5128L135.416 38.521L134.849 38.5653L136.275 58.5483Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M134.902 58.8588L135.469 58.8145L134.043 38.8315L133.476 38.8759L134.902 58.8588Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M133.512 59.1601L134.079 59.1158L132.653 39.1328L132.086 39.1772L133.512 59.1601Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M132.103 59.4619L132.67 59.4175L131.244 39.4346L130.677 39.47L132.103 59.4619Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M130.677 59.7548L131.244 59.7105L129.818 39.7275L129.251 39.7719L130.677 59.7548Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M129.225 60.0473L129.792 60.003L128.366 40.02L127.808 40.0555L129.225 60.0473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M127.763 60.331L128.33 60.2867L126.904 40.3037L126.337 40.3481L127.763 60.331Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M126.275 60.6064L126.842 60.5709L125.416 40.5791L124.858 40.6234L126.275 60.6064Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M124.779 60.8813L125.345 60.8458L123.919 40.854L123.353 40.8984L124.779 60.8813Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M123.255 61.1473L123.822 61.1119L122.396 41.1289L121.829 41.1644L123.255 61.1473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M121.714 61.413L122.281 61.3687L120.855 41.3857L120.297 41.4301L121.714 61.413Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M120.164 61.6704L120.731 61.626L119.305 41.6431L118.738 41.6874L120.164 61.6704Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M118.587 61.9189L119.154 61.8746L117.728 41.8916L117.161 41.936L118.587 61.9189Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M116.993 62.1582L117.56 62.1138L116.134 42.1309L115.567 42.1752L116.993 62.1582Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M115.381 62.3974L115.948 62.3531L114.522 42.3701L113.964 42.4056L115.381 62.3974Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M113.76 62.6196L114.327 62.5752L112.901 42.5923L112.334 42.6366L113.76 62.6196Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M112.113 62.8413L112.68 62.7969L111.254 42.814L110.687 42.8494L112.113 62.8413Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M110.457 63.0454L111.015 63.0099L109.598 43.0181L109.031 43.0624L110.457 63.0454Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M108.774 63.2495L109.341 63.2051L107.915 43.2222L107.348 43.2665L108.774 63.2495Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M107.082 63.4354L107.649 63.3999L106.223 43.417L105.656 43.4525L107.082 63.4354Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M105.364 63.6215L105.931 63.5772L104.505 43.5942L103.947 43.6386L105.364 63.6215Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M103.637 63.7904L104.204 63.7549L102.778 43.772L102.211 43.8075L103.637 63.7904Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M101.892 63.9589L102.459 63.9146L101.033 43.9316L100.466 43.9671L101.892 63.9589Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M100.129 64.1093L100.696 64.065L99.2702 44.082L98.7034 44.1264L100.129 64.1093Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3579 64.2514L98.9159 64.2071L97.4987 44.2241L96.9319 44.2596L98.3579 64.2514Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5688 64.3755L97.1357 64.34L95.7097 44.3481L95.1428 44.3925L96.5688 64.3755Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7888 64.4911L95.3556 64.4556L93.9296 44.4727L93.3628 44.5081L94.7888 64.4911Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 64.5976L93.5929 64.5533L92.1669 44.5703L91.6089 44.6147L93.026 64.5976Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2812 64.686L91.8481 64.6505L90.4221 44.6587L89.8552 44.703L91.2812 64.686Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5542 64.7656L90.121 64.7301L88.695 44.7383L88.1282 44.7826L89.5542 64.7656Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8359 64.8369L88.4027 64.7925L86.9768 44.8096L86.4099 44.845L87.8359 64.8369Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1355 64.8901L86.7023 64.8457L85.2763 44.8628L84.7095 44.9071L86.1355 64.8901Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4523 64.9345L85.0192 64.8902L83.5932 44.9072L83.0264 44.9427L84.4523 64.9345Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7785 64.9609L83.3454 64.9254L81.9194 44.9336L81.3525 44.9779L82.7785 64.9609Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1313 64.9877L81.6982 64.9434L80.2722 44.9604L79.7053 44.9959L81.1313 64.9877Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4926 64.9965L80.0595 64.9522L78.6335 44.9692L78.0667 45.0136L79.4926 64.9965Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8718 64.9965L78.4386 64.9522L77.0127 44.9692L76.4458 45.0136L77.8718 64.9965Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2597 64.9877L76.8265 64.9434L75.4005 44.9604L74.8425 45.0048L76.2597 64.9877Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6743 64.9702L75.2411 64.9258L73.8151 44.9429L73.2483 44.9872L74.6743 64.9702Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1066 64.9433L73.6646 64.899L72.2475 44.916L71.6807 44.9515L73.1066 64.9433Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5478 64.8988L72.1147 64.8633L70.6887 44.8804L70.1218 44.9158L71.5478 64.8988Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0068 64.8549L70.5736 64.8195L69.1477 44.8276L68.5808 44.872L70.0068 64.8549Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4833 64.8017L69.0501 64.7574L67.6242 44.7744L67.0662 44.8188L68.4833 64.8017Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9863 64.7397L67.5531 64.6954L66.1272 44.7124L65.5603 44.7568L66.9863 64.7397Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4985 64.6684L66.0653 64.6241L64.6394 44.6411L64.0725 44.6855L65.4985 64.6684Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0283 64.5883L64.5951 64.5529L63.1691 44.561L62.6023 44.6054L64.0283 64.5883Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5756 64.5087L63.1425 64.4644L61.7165 44.4814L61.1497 44.5169L62.5756 64.5087Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1496 64.4111L61.7076 64.3756L60.2905 44.3838L59.7236 44.4281L61.1496 64.4111Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7324 64.3139L60.2992 64.2784L58.8732 44.2866L58.3064 44.331L59.7324 64.3139Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3332 64.2074L58.9001 64.1719L57.4741 44.189L56.9072 44.2244L58.3332 64.2074Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9602 64.1008L57.527 64.0564L56.101 44.0735L55.5342 44.1178L56.9602 64.1008Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M103.495 33.4921C110.492 33.3413 116.914 33.6606 122.272 34.3879L124.017 58.8588C118.818 60.3578 112.512 61.5995 105.559 62.4599L103.495 33.4921Z",
    fill: "#FFFAEF"
  }))), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8371 55.3578C120.085 53.6718 138.582 47.5008 138.152 41.5746C137.721 35.6484 118.527 32.211 95.2793 33.8971C72.0317 35.5831 53.5345 41.7541 53.9647 47.6803C54.3949 53.6065 73.5895 57.0439 96.8371 55.3578Z",
    fill: "url(#paint85_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M102.485 52.9785C98.5263 51.3554 94.5407 49.7943 90.6082 48.1091C86.7022 46.4239 82.814 44.6766 78.9435 42.9116C75.5424 41.3594 72.1501 39.8073 68.749 38.264C73.0358 37.04 78.0578 35.9757 83.5757 35.1597C85.6571 36.0023 87.7385 36.8537 89.8199 37.6963C95.3467 39.9403 100.873 42.1577 106.436 44.3041C111.971 46.4417 117.534 48.4905 123.078 50.6192C123.291 50.699 123.503 50.7877 123.725 50.8675C118.703 52.331 112.618 53.5639 105.913 54.4331C104.779 53.9452 103.637 53.4574 102.494 52.9873L102.485 52.9785Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 35,
    width: 66,
    height: 17
  }, _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2575 46.1311C63.5498 50.2643 78.4473 52.5526 96.5245 51.2399C114.602 49.9273 129.021 45.5103 128.729 41.3771C128.436 37.2439 113.539 34.9556 95.4617 36.2682C77.3845 37.5809 62.9653 41.9979 63.2575 46.1311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_13830_12464)"
  }, _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2573 46.1311C63.5496 50.2643 78.4471 52.5526 96.5243 51.2399C114.601 49.9273 129.021 45.5103 128.728 41.3771C128.436 37.2439 113.539 34.9556 95.4614 36.2682C77.3843 37.5809 62.965 41.9979 63.2573 46.1311Z",
    fill: "url(#paint86_linear_13830_12464)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8855 49.3684C63.1778 53.5016 78.0753 55.7899 96.1525 54.4772C114.23 53.1646 128.649 48.7476 128.357 44.6144C128.064 40.4812 113.167 38.1929 95.0896 39.5056C77.0124 40.8182 62.5932 45.2352 62.8855 49.3684Z",
    fill: "url(#paint87_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M121.315 49.5546L86.3743 36.481L70.7771 39.4522L102.476 53.333L121.315 49.5546Z",
    fill: "#FFFAEF"
  })))), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5254 50.2998C56.8097 51.4883 58.4305 52.2423 60.0425 52.8986L61.2647 53.3687L62.5136 53.7589C63.3461 54.0428 64.1876 54.2379 65.0378 54.4596C68.4301 55.2756 71.8843 55.79 75.3474 56.1182C82.2825 56.7923 89.2529 56.748 96.188 56.3045C99.6511 56.0561 103.114 55.7102 106.56 55.2313C109.996 54.7168 113.433 54.1226 116.816 53.3243C120.208 52.5438 123.565 51.577 126.833 50.3531C128.463 49.7322 130.066 49.0315 131.616 48.2332C133.157 47.4173 134.672 46.5214 135.965 45.3418C133.104 47.3197 129.836 48.4993 126.55 49.4927C123.264 50.495 119.907 51.2577 116.533 51.9141C109.775 53.1913 102.937 54.0162 96.0729 54.4862C89.2087 54.9652 82.3179 55.0894 75.4537 54.7168C72.026 54.5128 68.5984 54.2024 65.215 53.6082C64.3736 53.4485 63.5233 53.3243 62.6907 53.1115L61.433 52.8188L60.2019 52.4551C58.5811 51.923 56.9337 51.3464 55.5254 50.3087V50.2998Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 16,
    width: 86,
    height: 31
  }, _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 25.8288C105.629 19.8951 124.725 15.9925 148.01 17.119C171.286 18.2454 189.93 23.9662 189.647 29.9088C189.576 31.3101 189.337 36.4367 189.275 37.8381C188.992 43.7718 169.896 47.6743 146.611 46.5479C123.335 45.4215 104.69 39.7007 104.974 33.7581C105.036 32.3567 105.284 27.2302 105.346 25.8288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_13830_12464)"
  }, _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 25.8288C105.629 19.8951 124.725 15.9925 148.01 17.119C171.286 18.2454 189.93 23.9662 189.647 29.9088C189.576 31.3101 189.337 36.4367 189.275 37.8381C188.992 43.7718 169.896 47.6743 146.611 46.5479C123.335 45.4215 104.69 39.7007 104.974 33.7581C105.036 32.3567 105.284 27.2302 105.346 25.8288Z",
    fill: "url(#paint88_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M188.122 26.3957L187.158 46.4087L187.725 46.436L188.688 26.4231L188.122 26.3957Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M186.752 26.5453L185.785 46.5581L186.351 46.5855L187.318 26.5728L186.752 26.5453Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M185.346 26.683L184.379 46.6958L184.946 46.7232L185.913 26.7105L185.346 26.683Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M183.931 26.8207L182.964 46.8335L183.531 46.8609L184.497 26.8482L183.931 26.8207Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M182.507 26.9408L181.54 46.9536L182.106 46.981L183.073 26.9683L182.507 26.9408Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M181.046 27.0605L180.079 47.0732L180.645 47.1007L181.612 27.0879L181.046 27.0605Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M179.575 27.1791L178.608 47.1919L179.175 47.2193L180.142 27.2066L179.575 27.1791Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M178.081 27.2786L177.117 47.2915L177.683 47.3188L178.647 27.3059L178.081 27.2786Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M176.578 27.3808L175.612 47.3936L176.178 47.421L177.145 27.4082L176.578 27.3808Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M175.052 27.4721L174.085 47.4849L174.651 47.5123L175.618 27.4995L175.052 27.4721Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M173.511 27.552L172.548 47.5649L173.114 47.5923L174.077 27.5793L173.511 27.552Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M171.953 27.6269L170.986 47.6396L171.552 47.6671L172.519 27.6543L171.953 27.6269Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M170.38 27.6992L169.413 47.7119L169.979 47.7393L170.946 27.7266L170.38 27.6992Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M168.788 27.7534L167.821 47.7661L168.387 47.7935L169.354 27.7808L168.788 27.7534Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M167.178 27.7983L166.211 47.811L166.777 47.8385L167.744 27.8257L167.178 27.7983Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M165.549 27.8422L164.583 47.855L165.149 47.8824L166.116 27.8697L165.549 27.8422Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M163.912 27.8686L162.945 47.8813L163.511 47.9088L164.478 27.896L163.912 27.8686Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M162.242 27.8919L161.279 47.9048L161.845 47.9321L162.809 27.9192L162.242 27.8919Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M160.579 27.9013L159.612 47.9141L160.178 47.9415L161.145 27.9287L160.579 27.9013Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M158.886 27.8906L157.919 47.9033L158.485 47.9308L159.452 27.918L158.886 27.8906Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M157.182 27.8788L156.216 47.8916L156.782 47.919L157.749 27.9063L157.182 27.8788Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M155.45 27.8469L154.487 47.8599L155.053 47.8872L156.016 27.8743L155.45 27.8469Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M153.719 27.8079L152.756 47.8208L153.322 47.8481L154.285 27.8352L153.719 27.8079Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M151.971 27.7612L151.004 47.7739L151.57 47.8014L152.537 27.7886L151.971 27.7612Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M150.203 27.7031L149.236 47.7158L149.802 47.7433L150.769 27.7305L150.203 27.7031Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M148.415 27.6331L147.452 47.646L148.018 47.6733L148.982 27.6604L148.415 27.6331Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M146.62 27.5379L145.657 47.5508L146.223 47.5781L147.186 27.5652L146.62 27.5379Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M144.852 27.4443L143.885 47.457L144.451 47.4845L145.418 27.4717L144.852 27.4443Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M143.093 27.3305L142.126 47.3433L142.692 47.3707L143.659 27.3579L143.093 27.3305Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M141.344 27.2074L140.377 47.2202L140.943 47.2476L141.91 27.2349L141.344 27.2074Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M139.622 27.0839L138.655 47.0967L139.221 47.1241L140.188 27.1114L139.622 27.0839Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M137.909 26.9418L136.942 46.9546L137.508 46.982L138.475 26.9693L137.909 26.9418Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M136.215 26.7909L135.249 46.8037L135.815 46.8311L136.782 26.8184L136.215 26.7909Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M134.533 26.6375L133.57 46.6504L134.136 46.6777L135.099 26.6648L134.533 26.6375Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M132.877 26.4592L131.914 46.4722L132.48 46.4995L133.443 26.4866L132.877 26.4592Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M131.237 26.2905L130.27 46.3032L130.836 46.3307L131.803 26.3179L131.237 26.2905Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M129.6 26.0927L128.633 46.1055L129.199 46.1329L130.166 26.1201L129.6 26.0927Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M127.999 25.9047L127.032 45.9175L127.598 45.9449L128.565 25.9321L127.999 25.9047Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M126.402 25.6965L125.438 45.7095L126.004 45.7368L126.968 25.7239L126.402 25.6965Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M124.826 25.4907L123.859 45.5034L124.425 45.5309L125.392 25.5181L124.826 25.4907Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M123.263 25.2739L122.296 45.2866L122.862 45.3141L123.829 25.3013L123.263 25.2739Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M121.727 25.0483L120.76 45.061L121.326 45.0885L122.293 25.0757L121.727 25.0483Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M120.197 24.8128L119.234 44.8257L119.8 44.853L120.763 24.8401L120.197 24.8128Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M118.694 24.5785L117.727 44.5913L118.293 44.6187L119.26 24.606L118.694 24.5785Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M117.214 24.3349L116.247 44.3477L116.814 44.3751L117.78 24.3623L117.214 24.3349Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M115.753 24.0907L114.786 44.1035L115.352 44.1309L116.319 24.1182L115.753 24.0907Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M114.302 23.8281L113.335 43.8408L113.901 43.8683L114.868 23.8555L114.302 23.8281Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M112.869 23.5746L111.902 43.5874L112.468 43.6148L113.435 23.6021L112.869 23.5746Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 23.3115L110.488 43.3242L111.054 43.3517L112.021 23.3389L111.455 23.3115Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M110.068 23.04L109.101 43.0527L109.668 43.0802L110.634 23.0674L110.068 23.04Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M108.692 22.768L107.725 42.7808L108.291 42.8082L109.258 22.7954L108.692 22.768Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M107.335 22.4868L106.366 42.4995L106.932 42.5269L107.901 22.5142L107.335 22.4868Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M156.194 17.7223C163.165 18.4141 169.497 19.505 174.732 20.8709L173.572 45.3773C168.24 46.2377 161.827 46.7166 154.821 46.7255L156.194 17.7134V17.7223Z",
    fill: "#FFFAEF"
  }))), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M189.649 29.8986C189.936 23.9637 171.3 18.2399 148.023 17.1142C124.747 15.9885 105.645 19.8872 105.358 25.8221C105.07 31.7569 123.707 37.4807 146.983 38.6064C170.26 39.7321 189.362 35.8334 189.649 29.8986Z",
    fill: "url(#paint89_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M152.882 36.9511C149.144 34.8579 145.371 32.8357 141.669 30.6804C137.984 28.5429 134.344 26.3344 130.704 24.117C127.515 22.1657 124.327 20.2144 121.129 18.272C125.531 17.5713 130.642 17.119 136.222 16.9771C138.188 18.068 140.154 19.1589 142.12 20.2499C147.337 23.1413 152.572 26.0151 157.833 28.8089C163.076 31.594 168.364 34.2992 173.607 37.0842C173.811 37.1906 174.014 37.3059 174.218 37.4124C169.063 38.2638 162.872 38.7428 156.106 38.8049C155.034 38.184 153.962 37.5631 152.882 36.96V36.9511Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 19,
    width: 67,
    height: 16
  }, _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M114.752 25.4208C114.557 29.5629 129.074 33.6251 147.178 34.5032C165.282 35.3813 180.117 32.7293 180.321 28.5872C180.524 24.4452 165.999 20.383 147.895 19.5049C129.791 18.6268 114.956 21.2788 114.752 25.4208Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_13830_12464)"
  }, _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M114.752 25.4208C114.557 29.5629 129.074 33.6251 147.178 34.5032C165.282 35.3813 180.117 32.7293 180.321 28.5872C180.524 24.4452 165.999 20.383 147.895 19.5049C129.791 18.6268 114.956 21.2788 114.752 25.4208Z",
    fill: "url(#paint90_linear_13830_12464)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M113.99 28.5959C113.796 32.7379 128.312 36.8002 146.416 37.6782C164.52 38.5563 179.355 35.9043 179.559 31.7623C179.754 27.6202 165.237 23.558 147.133 22.6799C129.03 21.8018 114.194 24.4538 113.99 28.5959Z",
    fill: "url(#paint91_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M171.986 35.8155L138.843 18.6265L123.007 19.6908L152.838 37.2967L171.986 35.8155Z",
    fill: "#FFFAEF"
  })))), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M106.586 28.6226C107.72 29.9619 109.243 30.9021 110.766 31.7447L111.927 32.3567L113.122 32.8977C113.911 33.2791 114.734 33.5718 115.54 33.9C118.809 35.124 122.183 36.0464 125.584 36.7914C132.386 38.2993 139.322 39.0975 146.257 39.4878C149.729 39.6563 153.209 39.7272 156.681 39.6652C160.153 39.5676 163.634 39.3991 167.097 39.0088C170.56 38.6363 174.006 38.0953 177.389 37.2704C179.081 36.8535 180.755 36.348 182.393 35.7448C184.023 35.124 185.635 34.4144 187.052 33.3944C183.979 35.0175 180.595 35.7981 177.212 36.3834C173.828 36.9866 170.401 37.3325 166.973 37.5808C160.109 38.042 153.218 38.0332 146.354 37.6695C139.481 37.3147 132.626 36.614 125.859 35.4078C122.475 34.7958 119.11 34.0685 115.824 33.0663C115.009 32.809 114.176 32.5784 113.37 32.268L112.157 31.8245L110.979 31.3101C109.429 30.5828 107.861 29.82 106.595 28.6138L106.586 28.6226Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 3,
    width: 86,
    height: 31
  }, _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M159.516 17.2339C159.091 11.3091 177.593 5.12706 200.843 3.44186C224.092 1.75665 243.277 5.18915 243.702 11.1228C243.799 12.5242 244.162 17.6419 244.269 19.0433C244.694 24.9681 226.191 31.1501 202.942 32.8353C179.692 34.5205 160.508 31.0881 160.083 25.1544C159.985 23.753 159.622 18.6353 159.516 17.2339Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_13830_12464)"
  }, _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M159.516 17.2339C159.091 11.3091 177.593 5.12706 200.843 3.44186C224.092 1.75665 243.277 5.18915 243.702 11.1228C243.799 12.5242 244.162 17.6419 244.269 19.0433C244.694 24.9681 226.191 31.1501 202.942 32.8353C179.692 34.5205 160.508 31.0881 160.083 25.1544C159.985 23.753 159.622 18.6353 159.516 17.2339Z",
    fill: "url(#paint92_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M243.179 27.7977L243.746 27.7623L242.32 7.7793L241.753 7.81478L243.179 27.7977Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M241.833 28.1079L242.4 28.0724L240.974 8.08057L240.407 8.12491L241.833 28.1079Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M240.46 28.4184L241.027 28.3741L239.601 8.39111L239.034 8.43546L240.46 28.4184Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M239.07 28.7202L239.636 28.6758L238.21 8.69287L237.644 8.73722L239.07 28.7202Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M237.661 29.0214L238.219 28.9771L236.802 8.99414L236.235 9.03849L237.661 29.0214Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M236.227 29.3144L236.793 29.2701L235.367 9.28711L234.801 9.33146L236.227 29.3144Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M234.783 29.6069L235.35 29.5625L233.924 9.57959L233.357 9.61507L234.783 29.6069Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M233.312 29.8911L233.879 29.8467L232.453 9.86377L231.895 9.90812L233.312 29.8911Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M231.833 30.1659L232.4 30.1304L230.974 10.1475L230.407 10.1829L231.833 30.1659Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M230.328 30.4409L230.894 30.4054L229.468 10.4136L228.902 10.4579L230.328 30.4409Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M228.813 30.7158L229.371 30.6714L227.954 10.6885L227.387 10.724L228.813 30.7158Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M227.272 30.9731L227.839 30.9288L226.413 10.9458L225.846 10.9901L227.272 30.9731Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M225.713 31.2299L226.28 31.1856L224.854 11.2026L224.287 11.247L225.713 31.2299Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M224.137 31.479L224.703 31.4346L223.277 11.4517L222.719 11.496L224.137 31.479Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M222.551 31.7177L223.118 31.6823L221.692 11.6904L221.125 11.7348L222.551 31.7177Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M220.939 31.9575L221.506 31.9131L220.08 11.9302L219.513 11.9657L220.939 31.9575Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M219.309 32.1792L219.876 32.1348L218.45 12.1519L217.883 12.1962L219.309 32.1792Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M217.671 32.4008L218.238 32.3565L216.812 12.3735L216.245 12.409L217.671 32.4008Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M216.006 32.6054L216.573 32.5699L215.147 12.5781L214.58 12.6225L216.006 32.6054Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M214.332 32.809L214.89 32.7647L213.473 12.7817L212.906 12.8261L214.332 32.809Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M212.631 33.0044L213.198 32.96L211.772 12.9771L211.205 13.0125L212.631 33.0044Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M210.922 33.1816L211.489 33.1373L210.063 13.1543L209.496 13.1986L210.922 33.1816Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M209.195 33.35L209.762 33.3145L208.336 13.3315L207.769 13.367L209.195 33.35Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M207.45 33.5185L208.017 33.4742L206.591 13.4912L206.024 13.5356L207.45 33.5185Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M205.687 33.6694L206.254 33.625L204.828 13.6421L204.261 13.6864L205.687 33.6694Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M203.907 33.811L204.474 33.7666L203.048 13.7837L202.481 13.828L203.907 33.811Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M202.118 33.9354L202.685 33.8999L201.259 13.917L200.692 13.9525L202.118 33.9354Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M200.347 34.06L200.913 34.0157L199.488 14.0327L198.921 14.0682L200.347 34.06Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M198.584 34.1572L199.151 34.1217L197.725 14.1299L197.158 14.1742L198.584 34.1572Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M196.839 34.2455L197.406 34.21L195.98 14.2271L195.413 14.2625L196.839 34.2455Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M195.103 34.3256L195.67 34.2902L194.244 14.2983L193.677 14.3427L195.103 34.3256Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M193.394 34.3964L193.952 34.3521L192.535 14.3691L191.968 14.4135L193.394 34.3964Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M191.693 34.4497L192.251 34.4053L190.834 14.4224L190.267 14.4667L191.693 34.4497Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M190.002 34.4941L190.569 34.4498L189.143 14.4668L188.576 14.5111L190.002 34.4941Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M188.336 34.5209L188.903 34.4854L187.477 14.5024L186.91 14.5379L188.336 34.5209Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M186.68 34.5473L187.247 34.503L185.821 14.52L185.254 14.5644L186.68 34.5473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M185.042 34.5561L185.609 34.5118L184.183 14.5288L183.616 14.5732L185.042 34.5561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M183.421 34.5561L183.988 34.5118L182.562 14.5288L181.995 14.5732L183.421 34.5561Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M181.818 34.5473L182.384 34.503L180.958 14.52L180.392 14.5644L181.818 34.5473Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M180.224 34.5297L180.79 34.4854L179.364 14.5024L178.806 14.5468L180.224 34.5297Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M178.656 34.5034L179.223 34.459L177.797 14.4761L177.23 14.5116L178.656 34.5034Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M177.097 34.4584L177.664 34.4229L176.238 14.4399L175.68 14.4754L177.097 34.4584Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M175.565 34.4145L176.132 34.379L174.706 14.3872L174.139 14.4316L175.565 34.4145Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M174.041 34.3613L174.608 34.3169L173.182 14.334L172.615 14.3783L174.041 34.3613Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M172.536 34.2988L173.102 34.2544L171.676 14.2715L171.11 14.3158L172.536 34.2988Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M171.047 34.228L171.614 34.1925L170.188 14.2007L169.63 14.245L171.047 34.228Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M169.586 34.1483L170.144 34.1128L168.727 14.1299L168.16 14.1654L169.586 34.1483Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M168.134 34.0683L168.7 34.024L167.274 14.041L166.708 14.0854L168.134 34.0683Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M166.699 33.9711L167.266 33.9356L165.84 13.9526L165.273 13.9881L166.699 33.9711Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M165.282 33.8735L165.849 33.838L164.423 13.8462L163.856 13.8905L165.282 33.8735Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M163.891 33.767L164.458 33.7315L163.032 13.7485L162.465 13.784L163.891 33.767Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M162.509 33.6604L163.076 33.616L161.65 13.6331L161.083 13.6774L162.509 33.6604Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M209.053 3.06095C216.05 2.91017 222.471 3.22947 227.83 3.95677L229.575 28.4277C224.376 29.9266 218.069 31.1684 211.117 32.0287L209.053 3.06095Z",
    fill: "#FFFAEF"
  }))), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M159.516 17.2345C159.941 23.1593 179.125 26.6007 202.375 24.9155C225.625 23.2303 244.118 17.0482 243.702 11.1234C243.277 5.19858 224.092 1.75722 200.843 3.44243C177.593 5.12763 159.099 11.3097 159.516 17.2345Z",
    fill: "url(#paint93_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M208.035 22.5468C204.075 20.9237 200.09 19.3627 196.157 17.6775C192.251 15.9923 188.363 14.245 184.493 12.48C181.091 10.9278 177.699 9.37564 174.298 7.83235C178.585 6.60836 183.607 5.54402 189.125 4.72803C191.206 5.57063 193.288 6.4221 195.369 7.2647C200.896 9.50868 206.423 11.7261 211.985 13.8725C217.52 16.01 223.083 18.0589 228.627 20.1875C228.84 20.2674 229.052 20.3561 229.274 20.4359C224.252 21.8994 218.167 23.1322 211.462 24.0014C210.328 23.5136 209.186 23.0258 208.043 22.5557L208.035 22.5468Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 5,
    width: 67,
    height: 17
  }, _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M168.816 15.6912C169.108 19.8244 184.005 22.1127 202.083 20.8C220.16 19.4873 234.579 15.0703 234.287 10.9371C233.994 6.80395 219.097 4.51562 201.02 5.82831C182.943 7.14099 168.523 11.558 168.816 15.6912Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_13830_12464)"
  }, _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M168.816 15.6912C169.108 19.8244 184.005 22.1127 202.083 20.8C220.16 19.4873 234.579 15.0703 234.287 10.9371C233.994 6.80395 219.097 4.51562 201.02 5.82831C182.943 7.14099 168.523 11.558 168.816 15.6912Z",
    fill: "url(#paint94_linear_13830_12464)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M168.435 18.9285C168.727 23.0617 183.625 25.35 201.702 24.0373C219.779 22.7246 234.198 18.3076 233.906 14.1744C233.614 10.0413 218.716 7.75293 200.639 9.06561C182.562 10.3783 168.143 14.7953 168.435 18.9285Z",
    fill: "url(#paint95_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M226.865 19.1146L191.933 6.04102L176.335 9.01229L208.035 22.893L226.865 19.1146Z",
    fill: "#FFFAEF"
  })))), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M161.083 19.8599C162.368 21.0484 163.989 21.8023 165.601 22.4587L166.823 22.9287L168.072 23.319C168.904 23.6028 169.746 23.798 170.596 24.0197C173.988 24.8357 177.442 25.3501 180.906 25.6783C187.841 26.3524 194.811 26.308 201.746 25.8645C205.209 25.6162 208.672 25.2703 212.118 24.7913C215.554 24.2769 218.991 23.6826 222.374 22.8844C225.766 22.1039 229.123 21.1371 232.391 19.9131C234.021 19.2923 235.624 18.5916 237.174 17.7933C238.715 16.9773 240.23 16.0815 241.523 14.9019C238.662 16.8798 235.394 18.0594 232.108 19.0528C228.822 20.055 225.465 20.8178 222.091 21.4741C215.333 22.7514 208.495 23.5762 201.631 24.0463C194.767 24.5253 187.876 24.6494 181.012 24.2769C177.584 24.0729 174.156 23.7625 170.773 23.1682C169.932 23.0086 169.081 22.8844 168.249 22.6715L166.991 22.3788L165.76 22.0152C164.139 21.483 162.492 20.9065 161.083 19.8688V19.8599Z",
    fill: "#FEDE9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 3,
    width: 85,
    height: 30
  }, _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M316.48 13.2164C316.374 7.27386 297.393 2.81251 274.09 3.25598C250.788 3.69946 231.993 8.87037 232.099 14.8129C232.126 16.2143 232.223 21.3497 232.25 22.7511C232.356 28.6937 251.337 33.155 274.64 32.7116C297.942 32.2681 316.737 27.0972 316.631 21.1546C316.604 19.7532 316.507 14.6178 316.48 13.2164Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_13830_12464)"
  }, _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M316.48 13.2164C316.374 7.27386 297.393 2.81251 274.09 3.25598C250.788 3.69946 231.993 8.87037 232.099 14.8129C232.126 16.2143 232.223 21.3497 232.25 22.7511C232.356 28.6937 251.337 33.155 274.64 32.7116C297.942 32.2681 316.737 27.0972 316.631 21.1546C316.604 19.7532 316.507 14.6178 316.48 13.2164Z",
    fill: "url(#paint96_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M233.733 11.3521L233.166 11.3628L233.544 31.3954L234.111 31.3847L233.733 11.3521Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M235.109 11.5391L234.542 11.5498L234.919 31.5824L235.486 31.5717L235.109 11.5391Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M236.507 11.7316L235.941 11.7422L236.314 31.7749L236.881 31.7643L236.507 11.7316Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M237.914 11.8941L237.347 11.9048L237.724 31.9374L238.291 31.9267L237.914 11.8941Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M239.351 12.0621L238.785 12.0728L239.162 32.1054L239.729 32.0947L239.351 12.0621Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M240.789 12.23L240.223 12.2407L240.6 32.2733L241.167 32.2626L240.789 12.23Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M242.262 12.3794L241.695 12.3901L242.072 32.4228L242.639 32.4121L242.262 12.3794Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M243.753 12.5284L243.186 12.5391L243.563 32.5717L244.13 32.561L243.753 12.5284Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M245.252 12.6871L244.686 12.6978L245.063 32.7304L245.629 32.7197L245.252 12.6871Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M246.769 12.8174L246.202 12.8281L246.579 32.8607L247.146 32.85L246.769 12.8174Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M248.312 12.939L247.745 12.9497L248.122 32.9823L248.689 32.9716L248.312 12.939Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M249.864 13.0606L249.297 13.0713L249.674 33.1039L250.241 33.0932L249.864 13.0606Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M251.442 13.1817L250.876 13.1924L251.253 33.225L251.82 33.2143L251.442 13.1817Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M253.021 13.2759L252.454 13.2866L252.831 33.3192L253.398 33.3085L253.021 13.2759Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M254.634 13.3785L254.068 13.3892L254.445 33.4218L255.012 33.4111L254.634 13.3785Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M256.261 13.4723L255.694 13.4829L256.068 33.5156L256.635 33.505L256.261 13.4723Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M257.896 13.5386L257.329 13.5493L257.706 33.5819L258.273 33.5712L257.896 13.5386Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M259.558 13.6144L258.991 13.625L259.365 33.6577L259.931 33.6471L259.558 13.6144Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M261.228 13.6622L260.661 13.6729L261.038 33.7055L261.605 33.6948L261.228 13.6622Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M262.92 13.71L262.354 13.7207L262.731 33.7533L263.297 33.7426L262.92 13.71Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M264.63 13.7491L264.063 13.7598L264.441 33.7924L265.007 33.7817L264.63 13.7491Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M266.349 13.7784L265.782 13.7891L266.159 33.8217L266.726 33.811L266.349 13.7784Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M268.085 13.7813L267.518 13.792L267.895 33.8246L268.462 33.8139L268.085 13.7813Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M269.838 13.7832L269.271 13.7939L269.648 33.8266L270.215 33.8159L269.838 13.7832Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M271.609 13.7764L271.042 13.7871L271.419 33.8197L271.986 33.809L271.609 13.7764Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M273.384 13.7643L272.817 13.7749L273.191 33.8076L273.758 33.797L273.384 13.7643Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M275.181 13.7306L274.615 13.7412L274.988 33.7739L275.555 33.7633L275.181 13.7306Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M276.956 13.6758L276.389 13.6865L276.766 33.7191L277.333 33.7084L276.956 13.6758Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M278.721 13.6203L278.155 13.6309L278.528 33.6635L279.095 33.6529L278.721 13.6203Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M280.46 13.5562L279.893 13.5669L280.27 33.5995L280.837 33.5888L280.46 13.5562Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M282.199 13.4752L281.632 13.4858L282.006 33.5185L282.572 33.5079L282.199 13.4752Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M283.919 13.3755L283.353 13.3862L283.73 33.4188L284.296 33.4081L283.919 13.3755Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M285.609 13.2818L285.042 13.2925L285.419 33.3251L285.986 33.3144L285.609 13.2818Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M287.294 13.1764L286.727 13.187L287.101 33.2197L287.668 33.2091L287.294 13.1764Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M288.961 13.0498L288.394 13.0605L288.771 33.0932L289.338 33.0825L288.961 13.0498Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M290.605 12.9122L290.039 12.9229L290.416 32.9555L290.982 32.9448L290.605 12.9122Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M292.241 12.7837L291.674 12.7944L292.051 32.827L292.618 32.8163L292.241 12.7837Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M293.859 12.6294L293.292 12.6401L293.669 32.6728L294.236 32.6621L293.859 12.6294Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M295.45 12.4751L294.883 12.4858L295.26 32.5185L295.827 32.5078L295.45 12.4751Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M297.032 12.3125L296.465 12.3232L296.842 32.3559L297.409 32.3452L297.032 12.3125Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M298.592 12.1491L298.025 12.1597L298.399 32.1923L298.966 32.1817L298.592 12.1491Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M300.142 11.961L299.575 11.9717L299.953 32.0043L300.519 31.9936L300.142 11.961Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M301.671 11.773L301.104 11.7837L301.481 31.8163L302.048 31.8056L301.671 11.773Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M303.182 11.5845L302.615 11.5952L302.992 31.6278L303.559 31.6171L303.182 11.5845Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M304.67 11.3878L304.104 11.3984L304.477 31.4311L305.044 31.4205L304.67 11.3878Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M306.149 11.1739L305.583 11.1846L305.96 31.2172L306.526 31.2065L306.149 11.1739Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M307.597 10.9688L307.031 10.9795L307.408 31.0121L307.975 31.0014L307.597 10.9688Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M309.037 10.7559L308.47 10.7666L308.847 30.7992L309.414 30.7885L309.037 10.7559Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M310.459 10.5337L309.892 10.5444L310.269 30.577L310.836 30.5664L310.459 10.5337Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M311.859 10.3048L311.292 10.3154L311.666 30.3481L312.232 30.3375L311.859 10.3048Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M313.231 10.0733L312.664 10.084L313.041 30.1166L313.608 30.1059L313.231 10.0733Z",
    fill: "#C38B2C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M314.599 9.82622L314.032 9.83691L314.409 29.8695L314.976 29.8588L314.599 9.82622Z",
    fill: "#C38B2C"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M265.889 3.61971C258.901 4.10753 252.541 5.01222 247.271 6.22734L247.723 30.7515C253.028 31.7715 259.423 32.4367 266.429 32.6495L265.889 3.61084V3.61971Z",
    fill: "#FFFAEF"
  }))), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M274.5 24.7804C297.799 24.3413 316.596 19.1694 316.484 13.2286C316.372 7.28783 297.394 2.82777 274.094 3.26681C250.795 3.70585 231.998 8.87774 232.11 14.8185C232.222 20.7593 251.2 25.2194 274.5 24.7804Z",
    fill: "url(#paint97_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M268.644 22.9373C272.443 20.9594 276.269 19.0436 280.034 17.0036C283.78 14.9725 287.482 12.8793 291.185 10.7683C294.435 8.91462 297.677 7.05202 300.919 5.20717C296.543 4.37344 291.442 3.77918 285.87 3.46875C283.878 4.49761 281.876 5.53534 279.883 6.5642C274.587 9.296 269.272 12.0189 263.923 14.662C258.6 17.2963 253.241 19.8418 247.918 22.4672C247.714 22.5648 247.502 22.6712 247.298 22.7776C252.426 23.7799 258.6 24.4451 265.358 24.7023C266.447 24.1169 267.536 23.5227 268.635 22.955L268.644 22.9373Z",
    fill: "#FFFAEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_13830_12464",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 5,
    width: 67,
    height: 16
  }, _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M307.092 12.5337C307.172 16.6757 292.54 20.3122 274.418 20.6581C256.297 21.0041 241.541 17.9175 241.461 13.7754C241.382 9.63337 256.013 5.99688 274.135 5.65097C292.256 5.30506 307.012 8.39164 307.092 12.5337Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_13830_12464)"
  }, _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M307.092 12.5337C307.172 16.6757 292.54 20.3122 274.418 20.6581C256.297 21.0041 241.541 17.9175 241.461 13.7754C241.382 9.63337 256.013 5.99688 274.135 5.65097C292.256 5.30506 307.012 8.39164 307.092 12.5337Z",
    fill: "url(#paint98_linear_13830_12464)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M307.756 15.7266C307.836 19.8686 293.204 23.5051 275.083 23.851C256.961 24.1969 242.205 21.1103 242.126 16.9683C242.046 12.8262 256.678 9.18975 274.799 8.84384C292.921 8.49793 307.676 11.5845 307.756 15.7266Z",
    fill: "url(#paint99_linear_13830_12464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.11
  }, _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M249.583 21.2343L283.204 5.02979L299.005 6.56421L268.679 23.2832L249.583 21.2343Z",
    fill: "#FFFAEF"
  })))), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M315.16 15.9748C313.982 17.2787 312.441 18.1745 310.891 18.9727L309.713 19.5493L308.509 20.0548C307.712 20.4096 306.879 20.6845 306.064 20.9861C302.761 22.1125 299.368 22.9374 295.941 23.576C289.094 24.8798 282.15 25.4741 275.197 25.6603C271.726 25.7224 268.245 25.6958 264.773 25.5362C261.301 25.3322 257.829 25.0661 254.383 24.5694C250.938 24.0993 247.51 23.4518 244.145 22.5294C242.471 22.0593 240.806 21.5094 239.194 20.8531C237.582 20.1879 235.996 19.4251 234.606 18.3696C237.635 20.0814 240.992 20.9595 244.357 21.6425C247.723 22.3431 251.133 22.7955 254.552 23.1325C261.398 23.7889 268.28 23.984 275.162 23.8243C282.035 23.6736 288.908 23.168 295.71 22.1658C299.111 21.6513 302.495 21.0305 305.807 20.1258C306.631 19.8952 307.472 19.6823 308.278 19.3985L309.501 18.9905L310.696 18.5115C312.264 17.8286 313.858 17.1101 315.16 15.9482V15.9748Z",
    fill: "#FEDE9A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13830_12464",
    x1: 269.243,
    y1: 74.8882,
    x2: 355.395,
    y2: 81.0852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13830_12464",
    x1: 311.117,
    y1: 56.809,
    x2: 308.147,
    y2: 98.1581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13830_12464",
    x1: 311.677,
    y1: 50.0001,
    x2: 309.395,
    y2: 81.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13830_12464",
    x1: 311.445,
    y1: 61.6147,
    x2: 309.164,
    y2: 93.2407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13830_12464",
    x1: 318.551,
    y1: 63.9322,
    x2: 404.703,
    y2: 70.1291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13830_12464",
    x1: 360.491,
    y1: 45.9177,
    x2: 357.508,
    y2: 87.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13830_12464",
    x1: 360.985,
    y1: 39.0446,
    x2: 358.704,
    y2: 70.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13830_12464",
    x1: 360.762,
    y1: 50.6598,
    x2: 358.481,
    y2: 82.2859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13830_12464",
    x1: 273.318,
    y1: 52.0613,
    x2: 359.47,
    y2: 58.2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13830_12464",
    x1: 315.193,
    y1: 33.9766,
    x2: 312.223,
    y2: 75.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13830_12464",
    x1: 315.752,
    y1: 27.1643,
    x2: 313.47,
    y2: 58.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13830_12464",
    x1: 315.521,
    y1: 38.7788,
    x2: 313.239,
    y2: 70.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13830_12464",
    x1: 373.744,
    y1: 70.7857,
    x2: 459.896,
    y2: 76.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13830_12464",
    x1: 415.606,
    y1: 52.6859,
    x2: 412.636,
    y2: 94.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13830_12464",
    x1: 416.179,
    y1: 45.8887,
    x2: 413.897,
    y2: 77.5236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_13830_12464",
    x1: 415.945,
    y1: 57.5203,
    x2: 413.668,
    y2: 89.1466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13830_12464",
    x1: 450.648,
    y1: 79.0095,
    x2: 536.8,
    y2: 85.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13830_12464",
    x1: 492.588,
    y1: 60.9864,
    x2: 489.606,
    y2: 102.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13830_12464",
    x1: 493.083,
    y1: 54.1129,
    x2: 490.801,
    y2: 85.7477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13830_12464",
    x1: 492.851,
    y1: 65.7274,
    x2: 490.569,
    y2: 97.3623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13830_12464",
    x1: 411.741,
    y1: 57.0929,
    x2: 497.902,
    y2: 63.2904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13830_12464",
    x1: 453.681,
    y1: 39.07,
    x2: 450.698,
    y2: 80.4182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13830_12464",
    x1: 454.176,
    y1: 32.1959,
    x2: 451.894,
    y2: 63.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13830_12464",
    x1: 453.953,
    y1: 43.8116,
    x2: 451.672,
    y2: 75.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_13830_12464",
    x1: 349.782,
    y1: 39.8543,
    x2: 435.934,
    y2: 46.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_13830_12464",
    x1: 391.714,
    y1: 21.8305,
    x2: 388.731,
    y2: 63.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_13830_12464",
    x1: 392.208,
    y1: 14.9569,
    x2: 389.926,
    y2: 46.5918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_13830_12464",
    x1: 391.985,
    y1: 26.581,
    x2: 389.703,
    y2: 58.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_13830_12464",
    x1: 286.556,
    y1: 32.0748,
    x2: 375.292,
    y2: 38.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_13830_12464",
    x1: 329.709,
    y1: 14.1394,
    x2: 326.727,
    y2: 55.4877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_13830_12464",
    x1: 330.195,
    y1: 7.2649,
    x2: 327.913,
    y2: 38.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_13830_12464",
    x1: 329.99,
    y1: 18.8814,
    x2: 327.708,
    y2: 50.5163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_13830_12464",
    x1: 497.072,
    y1: 65.9744,
    x2: 583.41,
    y2: 63.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_13830_12464",
    x1: 537.08,
    y1: 43.9835,
    x2: 538.107,
    y2: 85.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_13830_12464",
    x1: 536.908,
    y1: 37.0912,
    x2: 537.695,
    y2: 68.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_13830_12464",
    x1: 537.808,
    y1: 48.673,
    x2: 538.595,
    y2: 80.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_13830_12464",
    x1: 443.261,
    y1: 45.6725,
    x2: 529.412,
    y2: 51.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_13830_12464",
    x1: 485.116,
    y1: 27.5708,
    x2: 482.146,
    y2: 68.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_13830_12464",
    x1: 485.695,
    y1: 20.7845,
    x2: 483.413,
    y2: 52.4105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_13830_12464",
    x1: 485.463,
    y1: 32.3991,
    x2: 483.182,
    y2: 64.0251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_13830_12464",
    x1: 392.19,
    y1: 33.7946,
    x2: 478.456,
    y2: 29.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_13830_12464",
    x1: 431.709,
    y1: 10.8936,
    x2: 433.69,
    y2: 52.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_13830_12464",
    x1: 431.342,
    y1: 4.00038,
    x2: 432.86,
    y2: 35.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_13830_12464",
    x1: 432.497,
    y1: 15.5593,
    x2: 434.015,
    y2: 47.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_13830_12464",
    x1: 337.709,
    y1: 15.2315,
    x2: 423.861,
    y2: 21.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_13830_12464",
    x1: 379.573,
    y1: -2.86147,
    x2: 376.604,
    y2: 38.4877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_13830_12464",
    x1: 380.135,
    y1: -9.66557,
    x2: 377.853,
    y2: 21.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_13830_12464",
    x1: 379.912,
    y1: 1.9585,
    x2: 377.63,
    y2: 33.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_13830_12464",
    x1: 310.738,
    y1: 74.9286,
    x2: 224.586,
    y2: 81.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_13830_12464",
    x1: 268.853,
    y1: 56.7693,
    x2: 271.823,
    y2: 98.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_13830_12464",
    x1: 268.305,
    y1: 50.0404,
    x2: 270.586,
    y2: 81.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_13830_12464",
    x1: 268.536,
    y1: 61.655,
    x2: 270.818,
    y2: 93.2811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_13830_12464",
    x1: 261.43,
    y1: 63.9731,
    x2: 175.278,
    y2: 70.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_13830_12464",
    x1: 219.491,
    y1: 45.9593,
    x2: 222.473,
    y2: 87.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_13830_12464",
    x1: 218.996,
    y1: 39.0855,
    x2: 221.278,
    y2: 70.7115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_13830_12464",
    x1: 219.228,
    y1: 50.7,
    x2: 221.509,
    y2: 82.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_13830_12464",
    x1: 306.663,
    y1: 52.1026,
    x2: 220.511,
    y2: 58.2995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_13830_12464",
    x1: 264.794,
    y1: 33.9369,
    x2: 267.764,
    y2: 75.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_13830_12464",
    x1: 264.238,
    y1: 27.205,
    x2: 266.519,
    y2: 58.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_13830_12464",
    x1: 264.46,
    y1: 38.8204,
    x2: 266.742,
    y2: 70.4553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_13830_12464",
    x1: 206.236,
    y1: 70.8265,
    x2: 120.085,
    y2: 77.0235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_13830_12464",
    x1: 164.305,
    y1: 52.803,
    x2: 167.288,
    y2: 94.1512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_13830_12464",
    x1: 163.811,
    y1: 45.9289,
    x2: 166.093,
    y2: 77.5638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_13830_12464",
    x1: 164.021,
    y1: 57.5975,
    x2: 166.298,
    y2: 89.2326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_13830_12464",
    x1: 129.332,
    y1: 79.0504,
    x2: 43.1807,
    y2: 85.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_13830_12464",
    x1: 87.4012,
    y1: 61.0269,
    x2: 90.3838,
    y2: 102.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_13830_12464",
    x1: 86.9069,
    y1: 54.1531,
    x2: 89.1882,
    y2: 85.7791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_13830_12464",
    x1: 87.1299,
    y1: 65.7683,
    x2: 89.4112,
    y2: 97.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_13830_12464",
    x1: 230.205,
    y1: 41.2195,
    x2: 144.053,
    y2: 47.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_13830_12464",
    x1: 188.266,
    y1: 23.2052,
    x2: 191.248,
    y2: 64.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_13830_12464",
    x1: 187.771,
    y1: 16.3314,
    x2: 190.052,
    y2: 47.9575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_13830_12464",
    x1: 188.003,
    y1: 27.946,
    x2: 190.284,
    y2: 59.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_13830_12464",
    x1: 168.845,
    y1: 57.8908,
    x2: 82.6931,
    y2: 64.0877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D0932D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B68028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E4D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_13830_12464",
    x1: 126.905,
    y1: 39.8677,
    x2: 129.887,
    y2: 81.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEC66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D6B32F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C7A625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A68A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6E5B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_13830_12464",
    x1: 126.411,
    y1: 32.9939,
    x2: 128.692,
    y2: 64.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B17D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#91661F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6E4D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8D631F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_13830_12464",
    x1: 126.613,
    y1: 44.6682,
    x2: 128.89,
    y2: 76.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B28029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_13830_12464",
    x1: 287.219,
    y1: 32.0122,
    x2: 201.058,
    y2: 38.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_13830_12464",
    x1: 245.34,
    y1: 13.843,
    x2: 248.309,
    y2: 55.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_13830_12464",
    x1: 244.784,
    y1: 7.11516,
    x2: 247.066,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_13830_12464",
    x1: 245.007,
    y1: 18.7306,
    x2: 247.289,
    y2: 50.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_13830_12464",
    x1: 82.9373,
    y1: 65.9017,
    x2: -3.41011,
    y2: 63.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_13830_12464",
    x1: 42.9266,
    y1: 43.9072,
    x2: 41.8997,
    y2: 85.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_13830_12464",
    x1: 43.1012,
    y1: 37.0186,
    x2: 42.3143,
    y2: 68.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_13830_12464",
    x1: 42.2041,
    y1: 48.612,
    x2: 41.4185,
    y2: 80.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_13830_12464",
    x1: 136.72,
    y1: 45.7134,
    x2: 50.5684,
    y2: 51.9103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_13830_12464",
    x1: 94.8407,
    y1: 27.5262,
    x2: 97.8105,
    y2: 68.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_13830_12464",
    x1: 94.2862,
    y1: 20.8253,
    x2: 96.5675,
    y2: 52.4513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_13830_12464",
    x1: 94.518,
    y1: 32.4399,
    x2: 96.7993,
    y2: 64.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_13830_12464",
    x1: 187.849,
    y1: 33.7877,
    x2: 101.582,
    y2: 29.6649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_13830_12464",
    x1: 148.339,
    y1: 10.976,
    x2: 146.359,
    y2: 52.3845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_13830_12464",
    x1: 148.697,
    y1: 3.99375,
    x2: 147.178,
    y2: 35.6746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_13830_12464",
    x1: 147.541,
    y1: 15.5527,
    x2: 146.023,
    y2: 47.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_13830_12464",
    x1: 242.28,
    y1: 15.2717,
    x2: 156.12,
    y2: 21.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_13830_12464",
    x1: 200.34,
    y1: -2.75092,
    x2: 203.323,
    y2: 38.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_13830_12464",
    x1: 199.846,
    y1: -9.62472,
    x2: 202.128,
    y2: 22.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_13830_12464",
    x1: 200.069,
    y1: 1.9905,
    x2: 202.351,
    y2: 33.6254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_13830_12464",
    x1: 233.867,
    y1: 18.7288,
    x2: 320.217,
    y2: 17.1183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E2A132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C88E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#805A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_13830_12464",
    x1: 273.989,
    y1: -3.01356,
    x2: 274.763,
    y2: 38.4352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F1DA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8C334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D9B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B89A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#806A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_13830_12464",
    x1: 273.878,
    y1: -9.90099,
    x2: 274.471,
    y2: 21.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C38B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A37324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#805A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F7124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38B2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_13830_12464",
    x1: 274.697,
    y1: 1.68687,
    x2: 275.29,
    y2: 33.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFBA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DFA132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C48D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.57c30105.svg";
export { ForwardRef as ReactComponent };